// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-flow-shell {
  min-height: 100vh;
  background: #f4f7f7;
  color: #142624;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.invoice-flow-shell .invoice-item-actions button {
  cursor: pointer;
}
.invoice-flow-main {
  min-height: 100vh;
  margin-left: 256px;
}
.invoice-editor-page {
  padding: 32px;
}
.invoice-flow-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0f766e;
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}
.invoice-editor-header {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px 24px;
  margin: 8px 0 24px;
}
.invoice-editor-header h1 {
  margin: 0;
  font-size: 32px;
  line-height: 40px;
  font-weight: 600;
}
.invoice-editor-header p,
.invoice-editor-header small {
  margin: 4px 0 0;
  color: #506360;
  font-size: 12px;
}
.invoice-editor-header p span {
  font-family: var(--font-family-mono, monospace);
  color: #142624;
}
.invoice-editor-header > small {
  grid-column: 1/-1;
}
.invoice-editor-shell .invoice-editor-header {
  display: flex;
  flex-direction: column;
  gap: var(--space-4, 16px);
}
.invoice-editor-shell .invoice-editor-header h1 {
  font-size: var(--font-size-h1, 32px);
  line-height: var(--line-height-h1, 1.25);
  letter-spacing: var(--letter-spacing-h1, -0.48px);
}
.invoice-editor-shell .invoice-editor-header .quotation-editor-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
}
.invoice-editor-shell .invoice-editor-header .quotation-editor-subtitle span {
  font-family: inherit;
  color: inherit;
}
@media (max-width: 767px) {
  .invoice-editor-shell .invoice-editor-header h1 {
    font-size: 28px;
    line-height: 36px;
  }
}
.invoice-editor-actions {
  display: flex;
  gap: 8px;
}
.invoice-editor-actions button,
.invoice-doc-action {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 13px;
  border: 1px solid #cdd6d4;
  border-radius: 10px;
  background: #fff;
  color: #142624;
  font: 500 12px var(--font-family-primary);
  cursor: pointer;
}
.invoice-editor-actions button.primary {
  border-color: #0f766e;
  background: #0f766e;
  color: #fff;
}
.invoice-editor-shell.dark .invoice-editor-actions button:not(.primary) {
  background: var(--surface-primary);
  color: var(--text-primary);
  border-color: var(--border-default);
}
.invoice-editor-shell.dark
  .invoice-editor-actions
  button:not(.primary):hover:not(:disabled) {
  background: var(--surface-secondary);
  border-color: var(--border-strong);
}
.invoice-editor-shell.dark
  .invoice-editor-actions
  button:not(.primary):focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.invoice-editor-actions button:disabled,
.invoice-doc-action:disabled,
.invoice-delivery-card button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.invoice-editor-shell .invoice-editor-actions button.primary:not(:disabled),
.invoice-editor-shell .invoice-delivery-card > button:not(:disabled) {
  cursor: pointer;
}
.invoice-editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;
}
.invoice-editor-column,
.invoice-editor-aside {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.invoice-flow-card {
  box-sizing: border-box;
  padding: 24px;
  border: 1px solid #dce3e2;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.invoice-flow-card h2 {
  margin: 0;
  font-size: 16px;
  line-height: 23px;
  font-weight: 500;
}
.invoice-flow-card > p,
.invoice-section-title p,
.invoice-flow-card > small {
  margin: 4px 0 18px;
  color: #506360;
  font-size: 12px;
  line-height: 18px;
}
.invoice-flow-card label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
  color: #142624;
  font-size: 12px;
  font-weight: 500;
}
.invoice-flow-card input,
.invoice-flow-card select,
.invoice-flow-card textarea {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #cdd6d4;
  border-radius: 8px;
  outline: 0;
  background: #fff;
  color: #142624;
  font: 400 13px var(--font-family-primary);
}
.invoice-flow-card textarea {
  height: 112px;
  padding: 12px;
  resize: vertical;
}
.invoice-flow-card input:focus,
.invoice-flow-card select:focus,
.invoice-flow-card textarea:focus {
  border-color: #0f766e;
  box-shadow: none;
}
.invoice-flow-card input[readonly] {
  background: #f4f7f7;
  color: #506360;
}
.invoice-flow-card label > em {
  color: #c23a2b;
  font-size: 11px;
  font-style: normal;
}
.invoice-fields {
  display: grid;
  gap: 16px;
  margin: 18px 0;
}
.invoice-fields.two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.invoice-fields.three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.invoice-date-input {
  position: relative;
}
.invoice-date-input svg {
  position: absolute;
  top: 11px;
  right: 12px;
  color: #506360;
  pointer-events: none;
}
.invoice-section-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.invoice-section-title > select {
  width: 140px;
}
.invoice-item-heading {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 56px 104px 84px 112px 28px;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 0;
  background: #f4f7f7;
  color: #506360;
  font-size: 10px;
}
.invoice-edit-item {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 56px 104px 84px 112px 28px;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid #dce3e2;
}
.invoice-edit-item .item-picker {
  grid-column: 1/-1;
}
.invoice-edit-item .item-description {
  grid-column: 1;
}
.invoice-edit-item strong {
  align-self: center;
  text-align: right;
  font: 500 12px var(--font-family-mono, monospace);
}
.invoice-edit-item > strong {
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}
.invoice-edit-item > button {
  display: grid;
  width: 28px;
  height: 40px;
  place-items: center;
  border: 0;
  background: transparent;
  color: #506360;
}
.invoice-edit-item .discount-type {
  grid-column: 1;
  width: 148px;
}
.invoice-edit-item .discount-value {
  grid-column: 2/4;
  width: 148px;
}
.invoice-item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0;
}
.invoice-item-actions button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid #cdd6d4;
  border-radius: 8px;
  background: #fff;
  color: #0f766e;
  font: 500 11px var(--font-family-primary);
}
.invoice-item-actions > span {
  margin-left: auto;
  color: #506360;
  font-size: 10px;
}
.invoice-item-actions strong {
  margin-left: 12px;
  color: #142624;
  font-family: var(--font-family-mono, monospace);
}
.invoice-attachment-box {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #dce3e2;
  border-radius: 10px;
  background: #f4f7f7;
}
.invoice-attachment-box > svg {
  color: #0f766e;
}
.invoice-attachment-box strong {
  font-size: 13px;
}
.invoice-attachment-box p {
  margin: 3px 0 0;
  color: #506360;
  font-size: 11px;
}
.invoice-upload-button {
  margin-left: auto;
}
.invoice-upload-button input {
  display: none;
}
.invoice-editor-aside {
  position: sticky;
  top: 88px;
  max-height: calc(100vh - 112px);
  overflow-y: auto;
  overscroll-behavior: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.invoice-editor-aside::-webkit-scrollbar {
  display: none;
}
.invoice-total-card > div {
  display: flex;
  justify-content: space-between;
}
.invoice-total-card svg {
  color: #0f766e;
}
.invoice-total-card > strong {
  display: block;
  margin: 18px 0 7px;
  font: 700 24px var(--font-family-mono, monospace);
}
.invoice-total-card > p {
  margin: 0;
}
.invoice-balance-payment-action {
  width: 100%;
  height: 40px;
  margin-top: 20px;
  border: 0;
  border-radius: var(--radius-md, 10px);
  color: var(--on-interactive-primary, #fff);
  background: var(--interactive-default, #0f766e);
  font: 500 13px / normal var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.invoice-balance-payment-action:hover {
  background: var(--interactive-hover, #0c5f59);
}
.invoice-remaining-card {
  min-height: 437px;
  padding: 0;
  overflow: hidden;
}
.invoice-remaining-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-5, 24px);
  width: 100%;
  min-height: 120px;
  box-sizing: border-box;
}
.invoice-remaining-heading {
  display: flex;
  align-items: center;
  gap: var(--space-3, 12px);
  width: 100%;
}
.invoice-remaining-heading h2 {
  flex: 1 1;
  margin: 0;
  font: 500 16px/22.4px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: -0.08px;
}
.invoice-remaining-heading svg {
  width: 20px;
  height: 20px;
  color: var(--interactive-default, #0f766e);
}
.invoice-remaining-headline {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
  width: 100%;
}
.invoice-remaining-headline strong {
  font: 700 20px/24px var(--font-family-mono, "JetBrains Mono", monospace);
}
.invoice-remaining-headline p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
}
.invoice-remaining-financials {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4, 16px);
  width: 100%;
  box-sizing: border-box;
}
.invoice-remaining-financials > hr {
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.invoice-remaining-financials .invoice-status {
  height: 22px;
  padding: 0 6px;
  font: 500 11px/14.3px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.11px;
}
.invoice-remaining-financials .invoice-balance-breakdown {
  gap: var(--space-4, 16px);
  padding: 0;
  border: 0;
}
.invoice-remaining-financials .invoice-balance-breakdown span {
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
}
.invoice-remaining-financials .invoice-balance-breakdown strong {
  font: 500 15px/19.5px var(--font-family-mono, "JetBrains Mono", monospace);
}
.invoice-remaining-financials .invoice-balance-payment-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 0;
  padding: 0 12px;
}
.invoice-remaining-financials .invoice-balance-payment-action svg {
  width: 16px;
  height: 16px;
}
.invoice-total-card > .invoice-status {
  align-self: flex-start;
}
.invoice-balance-breakdown {
  display: grid;
  gap: var(--space-2, 8px);
  width: 100%;
  padding-top: var(--space-2, 8px);
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.invoice-balance-breakdown p,
.invoice-credit-total,
.invoice-delivery-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3, 12px);
  width: 100%;
  margin: 0;
}
.invoice-balance-breakdown span,
.invoice-delivery-card > span,
.invoice-delivery-card > p {
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.invoice-balance-breakdown strong,
.invoice-credit-total strong {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 13px;
}
.invoice-delivery-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3, 12px);
}
.invoice-delivery-card > h2,
.invoice-delivery-card > p {
  margin: 0;
}
.invoice-delivery-card > strong {
  overflow-wrap: anywhere;
  font-size: 12px;
}
.invoice-delivery-status b {
  color: var(--interactive-default, #0f766e);
}
.invoice-delivery-card .invoice-link-action {
  padding: 0;
  color: var(--text-link, #0f766e);
  background: transparent;
  border: 0;
  font: 500 12px/18px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.invoice-delivery-card hr {
  width: 100%;
  margin: var(--space-1, 4px) 0;
}
.invoice-delivery-card .invoice-reminder-action {
  width: 100%;
  margin-top: var(--space-1, 4px);
  height: 40px;
  padding: 0 12px;
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  font: 500 13px / normal var(--font-family-primary, "Lexend", sans-serif);
}
.invoice-delivery-card .invoice-reminder-action:hover {
  color: var(--text-primary, #142624);
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-default, #cdd6d4);
}
.invoice-delivery-card .invoice-reminder-action svg {
  width: 16px;
  height: 16px;
}
.invoice-payment-credit-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-6, 24px);
}
.invoice-payment-credit-grid > .invoice-flow-card {
  min-width: 0;
}
.invoice-credit-notes-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4, 16px);
}
.invoice-credit-notes-card > h2,
.invoice-credit-notes-card > p {
  margin: 0;
}
.invoice-credit-notes-card > hr {
  width: 100%;
  margin: 0;
}
.invoice-credit-notes-card .invoice-credit-list {
  width: 100%;
  max-height: 244px;
  margin-top: 0;
  padding-right: var(--space-2, 8px);
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.invoice-credit-notes-card .invoice-credit-list article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4, 16px);
}
.invoice-credit-note-details {
  display: grid;
  min-width: 0;
  gap: var(--space-1, 4px);
}
.invoice-credit-note-details small {
  grid-column: auto;
}
.invoice-credit-note-link {
  flex: 0 0 auto;
  text-decoration: none;
}
.invoice-secondary-actions {
  display: none;
}
@media (max-width: 900px) {
  .invoice-payment-credit-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 420px) {
  .invoice-credit-notes-card .invoice-credit-list article {
    align-items: stretch;
    flex-direction: column;
  }
  .invoice-credit-note-link {
    width: 100%;
  }
}
.invoice-doc-action {
  width: 100%;
}
.invoice-doc-action.download {
  border: 0;
  background: transparent;
  color: #0f766e;
}
.invoice-summary-card > p {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin: 16px 0;
  font-size: 11px;
}
.invoice-summary-card > p span {
  color: #506360;
}
.invoice-summary-card > p strong {
  font-family: var(--font-family-mono, monospace);
  text-align: right;
}
.invoice-summary-card hr {
  border: 0;
  border-top: 1px solid #dce3e2;
}
.invoice-summary-card > p.grand {
  font-size: 13px;
}
.invoice-delivery-card p {
  margin: 14px 0;
  color: #506360;
  font-size: 11px;
  line-height: 17px;
}
.invoice-delivery-card button {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-radius: 8px;
  background: #0f766e;
  color: #fff;
  font: 500 12px var(--font-family-primary);
}
.invoice-flow-shell.dark {
  background: #101113;
  color: #f2f3f5;
}
.invoice-flow-shell.dark .invoice-flow-card,
.invoice-flow-shell.dark input,
.invoice-flow-shell.dark select,
.invoice-flow-shell.dark textarea {
  border-color: #343a3a;
  background: #191b1f;
  color: #f2f3f5;
}
@media (max-width: 1023px) {
  .invoice-flow-main {
    margin-left: 0;
  }
  .invoice-editor-page {
    padding: 24px;
  }
  .invoice-editor-grid {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
  .invoice-item-heading,
  .invoice-edit-item {
    grid-template-columns: minmax(180px, 1fr) 48px 88px 72px 96px 28px;
  }
}
@media (max-width: 700px) {
  .invoice-editor-page {
    padding: 16px;
  }
  .invoice-flow-back {
    height: 44px;
  }
  .invoice-editor-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .invoice-editor-header h1 {
    font-size: 24px;
    line-height: 30px;
  }
  .invoice-editor-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .invoice-editor-actions .primary {
    grid-column: 1/-1;
  }
  .invoice-editor-grid {
    display: flex;
    flex-direction: column;
  }
  .invoice-editor-aside {
    position: static;
    display: contents;
  }
  .invoice-total-card {
    order: -1;
  }
  .invoice-flow-card {
    padding: 16px;
    border-radius: 10px;
  }
  .invoice-fields.two,
  .invoice-fields.three {
    grid-template-columns: 1fr;
  }
  .invoice-item-heading {
    display: none;
  }
  .invoice-edit-item {
    grid-template-columns: 1fr 64px;
    gap: 8px;
  }
  .invoice-edit-item .item-picker {
    grid-column: 1/-1;
  }
  .invoice-edit-item .item-description {
    grid-column: 1/-1;
  }
  .invoice-edit-item > input:not(.item-picker):not(.item-description),
  .invoice-edit-item > select:not(.item-picker) {
    width: 100%;
  }
  .invoice-edit-item strong {
    grid-column: 1;
  }
  .invoice-edit-item > button {
    grid-column: 2;
    grid-row: 3;
  }
  .invoice-edit-item .discount-type {
    grid-column: 1;
  }
  .invoice-edit-item .discount-value {
    grid-column: 2;
  }
  .invoice-item-actions {
    flex-wrap: wrap;
  }
  .invoice-item-actions > span {
    width: 100%;
    margin-left: 0;
  }
  .invoice-attachment-box {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .invoice-upload-button {
    width: 100%;
    margin-left: 0;
  }
  .invoice-editor-column,
  .invoice-editor-aside {
    gap: 12px;
  }
}

.invoice-editor-intro {
  max-width: 776px;
  margin: -8px 0 24px;
  color: #142624;
  font-size: 12px;
  line-height: 18px;
}
.invoice-editor-intro span {
  color: #506360;
}
.invoice-source-banner {
  display: flex;
  max-width: 1104px;
  box-sizing: border-box;
  align-items: flex-start;
  gap: 10px;
  margin: -8px 0 24px;
  padding: 12px 16px;
  border: 1px solid #dce3e2;
  border-radius: 10px;
  background: #f0f8f7;
  color: #0f766e;
}
.invoice-source-banner div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.invoice-source-banner strong {
  font-size: 12px;
}
.invoice-source-banner span {
  color: #506360;
  font-size: 11px;
}
.invoice-text-action {
  margin-top: 14px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0f766e;
  font: 500 11px var(--font-family-primary);
  cursor: pointer;
}
.invoice-pricing-basis {
  margin-top: 12px;
  color: #506360;
  font-size: 11px;
}
.invoice-pricing-basis span {
  margin-left: 4px;
  color: #0f766e;
}
.invoice-draft-footnote {
  margin: 0;
  color: #506360;
  font-size: 11px;
  line-height: 17px;
}
@media (max-width: 700px) {
  .invoice-editor-intro {
    margin-top: 0;
  }
  .invoice-source-banner {
    margin-top: 0;
  }
  .invoice-draft-footnote {
    padding: 0 4px;
  }
}

.invoice-import-card {
  display: flex;
  max-width: 1104px;
  box-sizing: border-box;
  align-items: flex-start;
  gap: 14px;
  margin: -8px 0 24px;
  padding: 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  background: var(--surface-primary, #fff);
  box-shadow: var(--elevation-sm, 0 1px 2px rgba(14, 26, 32, 0.06));
}
.invoice-import-card__icon {
  display: grid;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  place-items: center;
  border-radius: var(--radius-md, 10px);
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-import-card__icon svg {
  width: 19px;
  height: 19px;
}
.invoice-import-card__content {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 4px;
}
.invoice-import-card__content > strong {
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 600;
}
.invoice-import-card__content > span {
  color: var(--text-secondary, #506360);
  font-size: 11px;
  line-height: 17px;
}
.invoice-import-card__actions {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}
.invoice-import-card__actions button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 13px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--interactive-default, #0f766e);
  font: 500 12px var(--font-family-primary);
  cursor: pointer;
}
.invoice-import-card__actions button:hover:not(:disabled) {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft, #f0f8f7);
}
.invoice-import-card__actions button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.invoice-import-card__actions .invoice-import-card__camera {
  display: none;
}
.invoice-import-card > input {
  display: none;
}
.invoice-import-card__result {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 7px;
  padding-top: 9px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
  color: var(--text-secondary, #506360);
  font-size: 11px;
  line-height: 17px;
}
.invoice-import-card__result b {
  overflow: hidden;
  color: var(--text-primary, #142624);
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invoice-import-card__result ul {
  margin: 3px 0 0;
  padding-left: 18px;
  color: var(--warning-text, #8a5d00);
}
.invoice-import-card__result li + li {
  margin-top: 3px;
}
.invoice-import-card__result small {
  color: var(--text-tertiary, #71807d);
  font-family: var(--font-family-mono, monospace);
  font-size: 10px;
}
.invoice-import-card--success {
  border-color: var(--success-border, #a7dfbd);
}
.invoice-import-card--error {
  border-color: var(--danger-border, #f0b7b1);
}
.invoice-import-card--error .invoice-import-card__result > span {
  color: var(--danger-text, #a52f25);
}
.invoice-import-card--loading .invoice-import-card__icon svg {
  animation: invoice-import-pulse 1.2s ease-in-out infinite;
}
@keyframes invoice-import-pulse {
  0%,
  100% {
    opacity: 0.35;
    transform: translateY(2px);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
.invoice-flow-shell.dark .invoice-import-card {
  border-color: var(--border-subtle, #343a3a);
  background: var(--surface-primary, #191b1f);
}
.invoice-flow-shell.dark .invoice-import-card__icon {
  background: var(--interactive-soft, #22252a);
  color: var(--interactive-default, #43a79c);
}
.invoice-flow-shell.dark .invoice-import-card__actions button {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-secondary, #22252a);
  color: var(--interactive-default, #43a79c);
}
.invoice-flow-shell.dark .invoice-import-card__result {
  border-color: var(--border-subtle, #343a3a);
}
@media (max-width: 1023px) {
  .invoice-import-card {
    flex-wrap: wrap;
  }
  .invoice-import-card__actions {
    width: 100%;
    justify-content: flex-end;
  }
  .invoice-import-card__actions .invoice-import-card__camera {
    display: inline-flex;
  }
}
@media (max-width: 700px) {
  .invoice-import-card {
    display: grid;
    grid-template-columns: 40px minmax(0, 1fr);
    margin-top: 0;
    padding: 14px;
  }
  .invoice-import-card__actions {
    display: grid;
    grid-column: 1/-1;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
  .invoice-import-card__actions button {
    width: 100%;
  }
}

.invoice-detail-page {
  padding: 32px;
}
.invoice-detail-header {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px 24px;
  margin: 8px 0 24px;
}
.invoice-detail-header h1 {
  margin: 0;
  font-size: 32px;
  line-height: 40px;
  font-weight: 600;
}
.invoice-detail-header p,
.invoice-detail-header small {
  margin: 4px 0 0;
  color: #506360;
  font-size: 12px;
}
.invoice-detail-header p span {
  margin-right: 8px;
  font-family: var(--font-family-mono, monospace);
  color: #142624;
}
.invoice-detail-header > small {
  grid-column: 1/-1;
}
.invoice-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  background: #edf1f0;
  color: #506360;
  font-size: 10px;
  font-weight: 500;
}
.status-paid {
  background: #e7f7ed;
  color: #247a48;
}
.status-overdue {
  background: #fff0ed;
  color: #c23a2b;
}
.status-partial-paid,
.status-partially-paid {
  background: #fff7df;
  color: #956800;
}
.invoice-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;
}
.invoice-content-card > hr,
.invoice-settings-card hr {
  margin: 24px 0;
  border: 0;
  border-top: 1px solid #dce3e2;
}
.invoice-detail-pairs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 22px;
}
.invoice-detail-pairs div,
.invoice-settings-card {
  display: flex;
  flex-direction: column;
}
.invoice-detail-pairs span,
.invoice-settings-card > span,
.invoice-content-summary span {
  color: #506360;
  font-size: 11px;
}
.invoice-detail-pairs strong,
.invoice-settings-card > strong {
  margin-top: 7px;
  font-size: 12px;
  font-weight: 500;
}
.invoice-detail-items .head,
.invoice-detail-items .row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) 48px 112px 64px 96px 112px;
  gap: 12px;
  align-items: center;
}
.invoice-detail-items .head {
  min-height: 44px;
  padding: 0 12px;
  border-radius: 6px;
  background: #f4f7f7;
  color: #506360;
  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  letter-spacing: 0.12px;
}
.invoice-detail-items .head span:not(:first-child) {
  text-align: right;
}
.invoice-detail-items .row {
  min-height: 56px;
  padding: 12px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  font-size: 14px;
  line-height: 21.7px;
}
.invoice-detail-items .row > strong:first-child {
  font-weight: 400;
}
.invoice-detail-items .row > span:nth-child(3),
.invoice-detail-items .row > strong:last-child {
  font-family: var(--font-family-mono, monospace);
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
}
.invoice-detail-items .row span:not(:first-child),
.invoice-detail-items .row strong:last-child {
  text-align: right;
}
.invoice-content-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  margin-top: 24px;
}
.invoice-content-summary > div:first-child p {
  margin: 6px 0 18px;
  font-size: 11px;
  line-height: 17px;
}
.invoice-content-summary > div:last-child p {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0 0 16px;
  font-size: 11px;
}
.invoice-content-summary > div:last-child strong {
  font-family: var(--font-family-mono, monospace);
}
.invoice-content-summary hr {
  border: 0;
  border-top: 1px solid #dce3e2;
}
.invoice-attachments-line {
  display: flex;
  align-items: center;
  gap: var(--space-3, 12px);
  justify-content: space-between;
  font-size: 11px;
}
.invoice-attachment-summary {
  display: flex;
  flex-direction: column;
  gap: var(--space-1, 4px);
}
.invoice-attachment-preview-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.invoice-attachments-line span {
  color: #506360;
}
.invoice-detail-aside {
  display: flex;
  position: sticky;
  top: 88px;
  flex-direction: column;
  gap: 24px;
}
.invoice-settings-card > h2 {
  margin-bottom: 20px;
}
.invoice-settings-card > span:not(:first-child) {
  margin-top: 18px;
}
.invoice-settings-card h3 {
  margin: 0 0 10px;
  font-size: 12px;
}
.invoice-settings-card p {
  margin: 0;
  color: #506360;
  font-size: 11px;
  line-height: 17px;
  overflow-wrap: anywhere;
}
.invoice-history-card {
  margin-top: 24px;
}
.invoice-history-card h2 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.invoice-private-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 18px 0;
  padding: 14px 16px;
  border-radius: 8px;
  background: #f4f7f7;
}
.invoice-private-note div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.invoice-private-note strong {
  font-size: 11px;
}
.invoice-private-note span {
  color: #506360;
  font-size: 10px;
}
.invoice-history-content {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 24px;
}
.invoice-history-content > div {
  padding: 16px;
  border: 1px solid #dce3e2;
  border-radius: 8px;
  font-size: 11px;
}
.invoice-history-content > div small {
  float: right;
  color: #506360;
}
.invoice-history-content > div p {
  margin: 8px 0;
}
.invoice-history-content label textarea {
  margin-top: 8px;
}
.invoice-history-content label small {
  color: #506360;
  font-size: 10px;
}
.invoice-history-content label button {
  align-self: flex-end;
  height: 34px;
  margin-top: 10px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: #0f766e;
  color: #fff;
}
.invoice-history-content label button:disabled {
  opacity: 0.35;
}
@media (max-width: 1023px) {
  .invoice-detail-page {
    padding: 24px;
  }
  .invoice-detail-grid {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
}
@media (max-width: 700px) {
  .invoice-detail-page {
    padding: 16px;
  }
  .invoice-detail-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .invoice-detail-header h1 {
    font-size: 24px;
    line-height: 30px;
  }
  .invoice-detail-grid {
    display: flex;
    flex-direction: column;
  }
  .invoice-detail-aside {
    position: static;
    width: 100%;
    order: -1;
  }
  .invoice-content-card {
    width: 100%;
    overflow: hidden;
  }
  .invoice-detail-items .head {
    display: none;
  }
  .invoice-detail-items .row {
    grid-template-columns: 1fr 1fr;
    padding: 14px 0;
  }
  .invoice-detail-items .row strong:first-child {
    grid-column: 1/-1;
  }
  .invoice-detail-items .row span,
  .invoice-detail-items .row strong:last-child {
    text-align: left !important;
  }
  .invoice-content-summary,
  .invoice-history-content,
  .invoice-detail-pairs {
    grid-template-columns: 1fr;
  }
  .invoice-history-content {
    gap: 16px;
  }
  .invoice-editor-actions {
    width: 100%;
  }
}

/* Final Figma token and responsive alignment pass. */
.invoice-editor-page,
.invoice-detail-page {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  margin: 0;
  padding: 32px;
}
.invoice-flow-back {
  height: 40px;
  font-size: 13px;
  line-height: 18px;
}
.invoice-editor-header,
.invoice-detail-header {
  margin: 8px 0 20px;
}
.invoice-editor-header h1,
.invoice-detail-header h1 {
  font-size: 32px;
  line-height: 41.6px;
  letter-spacing: -0.32px;
}
.invoice-editor-header p,
.invoice-editor-header small,
.invoice-detail-header p,
.invoice-detail-header small {
  font-size: 12px;
  line-height: 17px;
}
.invoice-editor-actions svg,
.invoice-doc-action svg,
.invoice-item-actions svg,
.invoice-upload-button svg,
.invoice-delivery-card button svg,
.invoice-flow-back svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.invoice-editor-intro {
  margin: -4px 0 24px;
  font-size: 13px;
  line-height: 18.2px;
}
.invoice-source-banner {
  max-width: none;
  min-height: 64px;
  margin: 0 0 24px;
  padding: 14px 16px;
  border-radius: 10px;
}
.invoice-source-banner svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.invoice-source-banner strong {
  font-size: 13px;
  line-height: 18px;
}
.invoice-source-banner span {
  font-size: 12px;
  line-height: 17px;
}
.invoice-flow-card {
  padding: 24px;
  border-radius: 14px;
}
.invoice-flow-card h2 {
  font-size: 18px;
  line-height: 25.2px;
  letter-spacing: -0.09px;
}
.invoice-flow-card > p,
.invoice-section-title p,
.invoice-flow-card > small {
  font-size: 13px;
  line-height: 18.2px;
}
.invoice-flow-card label {
  gap: 6px;
  font-size: 13px;
  line-height: 18.2px;
}
.invoice-flow-card input,
.invoice-flow-card select,
.invoice-flow-card textarea {
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 21.7px;
}
.invoice-flow-card textarea {
  height: 120px;
  padding: 12px;
}
.invoice-fields {
  gap: 16px;
  margin: 20px 0;
}
.invoice-notes-fields {
  grid-template-columns: 1fr;
}
.invoice-text-action {
  height: 40px;
  margin-top: 8px;
  font-size: 13px;
}
.invoice-section-title > select {
  width: 144px;
}
.invoice-pricing-basis {
  font-size: 12px;
  line-height: 17px;
}
.invoice-item-heading {
  min-height: 36px;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 11px;
}
.invoice-edit-item {
  padding: 12px 0;
}
.invoice-item-actions button {
  height: 40px;
  border-radius: 10px;
  font-size: 13px;
}
.invoice-item-actions > span {
  font-size: 12px;
}
.invoice-attachment-box {
  margin: 20px 0 12px;
  padding: 16px;
  border-radius: 10px;
}
.invoice-attachment-box strong {
  font-size: 13px;
  line-height: 18px;
}
.invoice-attachment-box p {
  font-size: 12px;
  line-height: 17px;
}
.invoice-upload-button {
  display: inline-flex !important;
  width: max-content;
  flex-direction: row !important;
  align-items: center;
  gap: 6px !important;
  height: 40px;
  box-sizing: border-box;
  margin: 0;
  padding: 0 12px;
  border: 1px solid #cdd6d4;
  border-radius: 10px;
  color: #142624 !important;
  font-size: 13px !important;
  cursor: pointer;
}
.invoice-total-card > strong {
  font-size: 24px;
  line-height: 31px;
}
.invoice-summary-card > p,
.invoice-delivery-card p {
  font-size: 13px;
  line-height: 18.2px;
}
.invoice-delivery-card {
  gap: 12px;
}
.invoice-delivery-card p {
  margin: 0;
}
.invoice-delivery-card button {
  height: 40px;
  border-radius: 10px;
  font-size: 13px;
}
.invoice-draft-footnote {
  font-size: 12px;
  line-height: 17px;
}
.invoice-detail-pairs span,
.invoice-settings-card > span,
.invoice-content-summary span {
  font-size: 12px;
  line-height: 17px;
}
.invoice-detail-pairs strong,
.invoice-settings-card > strong {
  font-size: 14px;
  line-height: 21.7px;
}
.invoice-detail-items .head {
  font-size: 12px;
}
.invoice-detail-items .row {
  font-size: 14px;
  line-height: 21.7px;
}
.invoice-content-summary > div:first-child p,
.invoice-content-summary > div:last-child p,
.invoice-settings-card p {
  font-size: 13px;
  line-height: 18.2px;
}
.invoice-attachments-line {
  font-size: 13px;
}
.invoice-history-content > div {
  font-size: 14px;
  line-height: 21.7px;
}
.invoice-private-note strong {
  font-size: 13px;
}
.invoice-private-note span,
.invoice-history-content label small {
  font-size: 12px;
  line-height: 17px;
}
@media (max-width: 1023px) {
  .invoice-editor-page,
  .invoice-detail-page {
    max-width: none;
    padding: 24px;
  }
  .invoice-editor-grid {
    display: flex;
    flex-direction: column;
  }
  .invoice-editor-column,
  .invoice-editor-aside {
    display: contents;
  }
  .invoice-total-card {
    order: -1;
  }
  .invoice-editor-grid > .invoice-editor-column > .invoice-flow-card,
  .invoice-editor-grid > .invoice-editor-aside > * {
    width: 100%;
  }
  .invoice-detail-grid {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
  .invoice-editor-actions button {
    height: 40px;
  }
  .invoice-flow-card h2 {
    font-size: 17px;
    line-height: 23.8px;
  }
}
@media (max-width: 700px) {
  .invoice-editor-page,
  .invoice-detail-page {
    padding: 16px;
  }
  .invoice-editor-header,
  .invoice-detail-header {
    margin: 4px 0 16px;
  }
  .invoice-editor-header h1,
  .invoice-detail-header h1 {
    font-size: 24px;
    line-height: 31px;
  }
  .invoice-editor-header > small,
  .invoice-detail-header > small {
    order: 2;
  }
  .invoice-editor-actions {
    order: 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .invoice-editor-actions button {
    height: 44px;
    font-size: 14px;
  }
  .invoice-editor-actions .primary {
    grid-column: 1/-1;
  }
  .invoice-editor-actions svg,
  .invoice-doc-action svg,
  .invoice-delivery-card button svg {
    width: 20px;
    height: 20px;
    flex-basis: 20px;
  }
  .invoice-flow-card {
    padding: 16px;
  }
  .invoice-flow-card h2 {
    font-size: 16px;
    line-height: 22.4px;
  }
  .invoice-flow-card > p,
  .invoice-section-title p,
  .invoice-flow-card > small,
  .invoice-flow-card label {
    font-size: 13px;
    line-height: 18.2px;
  }
  .invoice-flow-card input,
  .invoice-flow-card select {
    height: 44px;
    font-size: 14px;
  }
  .invoice-flow-card textarea {
    height: 120px;
  }
  .invoice-fields.two,
  .invoice-fields.three {
    grid-template-columns: 1fr;
  }
  .invoice-source-banner {
    min-height: auto;
    padding: 12px;
  }
  .invoice-item-actions button,
  .invoice-upload-button,
  .invoice-doc-action,
  .invoice-delivery-card button {
    height: 44px;
    font-size: 14px;
  }
  .invoice-delivery-card {
    gap: 12px;
  }
  .invoice-summary-card > p,
  .invoice-delivery-card p {
    font-size: 13px;
    line-height: 20.2px;
  }
  .invoice-detail-grid {
    display: flex;
  }
  .invoice-detail-aside {
    order: -1;
  }
  .invoice-detail-items .row {
    font-size: 13px;
    line-height: 20.2px;
  }
}

/* Invoice editor controls: match Figma and style the portalled option menu. */
.invoice-items-editor .invoice-item-actions > button {
  color: var(--text-primary, #142624);
}

.invoice-flow-card .invoice-themed-select {
  width: 100%;
  min-width: 0;
  height: 40px;
  box-sizing: border-box;
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px/21.7px var(--font-family-primary, "Lexend", sans-serif);
}
.invoice-flow-card .invoice-themed-select .MuiSelect-select {
  display: flex;
  align-items: center;
  min-height: 0;
  box-sizing: border-box;
  padding: 0 40px 0 12px;
  height: 100%;
  font: inherit;
  color: inherit;
}
.invoice-flow-card .invoice-themed-select .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: inherit;
}
.invoice-flow-card .invoice-themed-select.Mui-focused {
  box-shadow: none;
}
.invoice-flow-card
  .invoice-themed-select.Mui-focused
  .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--interactive-default, #0f766e);
}
.invoice-flow-card .invoice-themed-select .MuiSelect-icon {
  width: 20px;
  height: 20px;
  right: 12px;
  top: calc(50% - 10px);
  color: var(--text-secondary, #506360);
  pointer-events: none;
}
.invoice-select-menu.MuiPaper-root {
  margin-top: 4px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  box-shadow: 0 4px 16px rgba(14, 26, 32, 0.12);
}
.invoice-select-menu .MuiMenu-list {
  padding: 4px;
}
.invoice-select-menu .MuiMenuItem-root {
  min-height: 40px;
  padding: 8px 12px;
  border-radius: 6px;
  font: 400 14px/21.7px var(--font-family-primary, "Lexend", sans-serif);
  white-space: normal;
}
.invoice-select-menu .MuiMenuItem-root:hover,
.invoice-select-menu .MuiMenuItem-root.Mui-selected,
.invoice-select-menu .MuiMenuItem-root.Mui-selected:hover,
.invoice-select-menu .MuiMenuItem-root.Mui-focusVisible {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-flow-shell.dark .invoice-themed-select,
.invoice-select-menu.dark {
  --surface-primary: #191b1f;
  --text-primary: #f2f3f5;
  --text-secondary: #adbab7;
  --border-default: #343a3a;
  --border-subtle: #343a3a;
  --interactive-soft: #153b36;
  --interactive-default: #83c7be;
}
.invoice-section-title > .invoice-themed-select {
  flex: 0 0 144px;
}
.invoice-date-input {
  display: block;
  width: 100%;
}
.invoice-date-input input {
  padding-right: 44px;
}
.invoice-date-input svg {
  width: 20px;
  height: 20px;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
}
.invoice-date-input input::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 0;
  top: 0;
  width: 44px;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
}
.invoice-date-input input::-webkit-inner-spin-button {
  display: none;
}
.invoice-attachment-list {
  margin-bottom: var(--space-3, 12px);
}
.invoice-attachment-view-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  padding: 4px 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  font: 400 13px/20px var(--font-family-primary, "Lexend", sans-serif);
  text-align: left;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.invoice-attachment-list > .invoice-attachment-view-button {
  display: flex;
  width: 100%;
}
.invoice-attachment-view-button svg {
  flex-shrink: 0;
}
.invoice-attachment-list .quotation-attachment-info {
  min-width: 0;
  overflow-wrap: anywhere;
}
.invoice-attachment-list .quotation-attachment-info svg,
.invoice-attachment-list .quotation-attachment-remove-btn {
  flex-shrink: 0;
}
.invoice-upload-button {
  background: var(--surface-secondary, #f4f7f7);
}
.invoice-flow-shell.dark .invoice-upload-button {
  background: #191b1f;
  border-color: #343a3a;
  color: #f2f3f5 !important;
}
@media (max-width: 700px) {
  .invoice-flow-card .invoice-themed-select {
    height: 44px;
  }
}

/* The shared ThemedSelect keeps invoice-specific sizing below. */
.invoice-flow-shell .rcti-supplier-select.is-open,
.invoice-flow-shell .invoice-customer-select.is-open {
  z-index: 1;
}
.invoice-flow-shell .invoice-customer-select .quotation-figma-dropdown-menu,
.invoice-flow-shell .rcti-supplier-select .quotation-figma-dropdown-menu,
.invoice-flow-shell .invoice-contact-search .quotation-autocomplete-dropdown {
  top: calc(100% + 4px);
  max-height: min(260px, 40vh);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  box-sizing: border-box;
}
.invoice-contact-search .quotation-input-box {
  box-sizing: border-box;
}
.invoice-flow-shell .invoice-customer-search .quotation-input-box:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.invoice-flow-shell .invoice-contact-search .quotation-input-box input {
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  font-size: 14px;
  color: var(--text-primary, #142624);
}
.invoice-contact-search .quotation-autocomplete-item {
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  font-family: var(--font-family-primary);
  overflow-wrap: anywhere;
}
.invoice-contact-search .quotation-autocomplete-item:hover {
  background: var(--surface-secondary, #f4f7f7);
}
.invoice-contact-search .quotation-autocomplete-item span {
  color: var(--text-secondary, #506360);
}
.invoice-contact-search .quotation-customer-option {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.invoice-contact-search .quotation-customer-option-select {
  color: inherit;
  font: inherit;
}
.invoice-customer-select .quotation-autocomplete-item > span {
  display: none;
}
.invoice-edit-item .quotation-figma-dropdown.discount-type {
  grid-column: 1;
  width: 148px;
}
.invoice-edit-item
  .quotation-figma-dropdown.discount-type
  .quotation-figma-dropdown-menu {
  min-width: 148px;
}
.invoice-edit-item
  .quotation-figma-dropdown[aria-label="Item GST"]
  .quotation-figma-dropdown-menu {
  min-width: 92px;
}
.invoice-section-title > .quotation-figma-dropdown {
  flex: 0 0 164px;
  width: 164px;
}
@media (min-width: 1024px) {
  .invoice-edit-item .quotation-figma-dropdown[aria-label="Item GST"] {
    width: 92px;
  }
  .invoice-item-heading,
  .invoice-edit-item {
    grid-template-columns: minmax(220px, 1fr) 56px 104px 92px 112px 28px;
  }
}
@media (min-width: 701px) and (max-width: 1023px) {
  .invoice-edit-item .quotation-figma-dropdown[aria-label="Item GST"] {
    width: 92px;
  }
  .invoice-item-heading,
  .invoice-edit-item {
    grid-template-columns: minmax(180px, 1fr) 48px 88px 92px 96px 28px;
  }
}
@media (max-width: 700px) {
  .invoice-section-title > .quotation-figma-dropdown {
    flex-basis: 128px;
    width: 128px;
  }
}
@media (max-width: 700px) {
  .quotation-figma-dropdown-trigger {
    height: 44px;
  }
  .invoice-edit-item .quotation-figma-dropdown.discount-type {
    width: 100%;
  }
}

/* Catalogue picker reuses the New Quote search and result card styles. */
.invoice-items-editor
  .quotation-item-row-card:has(.quotation-item-search-dropdown) {
  position: relative;
  z-index: 120;
}
.invoice-flow-shell .invoice-items-editor .quotation-discount-val-wrap input {
  height: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.invoice-flow-shell.dark .invoice-items-editor .quotation-pricing-basis-label,
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-item-discount-row
  label,
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-total-item-discounts-badge
  strong,
.invoice-flow-shell.dark .invoice-items-editor .quotation-col-line-total {
  color: var(--text-primary, #f2f3f5);
}
.invoice-flow-shell.dark .invoice-items-editor .quotation-items-table-header,
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-total-item-discounts-badge {
  background: var(--surface-secondary, #22252a) !important;
  color: var(--text-secondary, #b3b8c2) !important;
}
.invoice-flow-shell.dark .invoice-items-editor .quotation-col-line-total,
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-discount-val-wrap.disabled
  .quotation-input-box {
  background: var(--surface-secondary, #22252a);
}
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-discount-val-wrap
  .quotation-input-box {
  border-color: var(--border-default, #3a3f47);
}
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-discount-val-wrap:not(.disabled)
  .quotation-input-box {
  background: var(--surface-primary, #191b1f);
}
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-discount-val-wrap.disabled
  label {
  color: var(--text-disabled, #8a9896);
}
.invoice-flow-shell.dark .invoice-items-editor .quotation-item-row-card {
  border-bottom-color: var(--border-subtle, #2c3036);
}
.invoice-flow-shell.dark .invoice-items-editor .quotation-item-remove-btn,
.invoice-flow-shell.dark
  .invoice-items-editor
  .quotation-item-details-row
  > [data-label]::before {
  color: var(--text-secondary, #b3b8c2);
}
.invoice-items-editor .quotation-item-no-results strong {
  align-self: flex-start;
  text-align: left;
  font-family: var(--font-family-primary);
}
.invoice-flow-shell.dark .quotation-item-search-footer-btn {
  color: var(--interactive-default, #43a79c);
}
.invoice-flow-shell.dark .quotation-item-search-footer-btn:hover {
  background: var(--interactive-soft, #153b36);
}
.invoice-flow-shell.dark .quotation-item-search-divider {
  background: var(--border-subtle, #343a3a);
}
.invoice-flow-shell .quotation-item-search-row {
  position: relative;
  width: 100%;
  min-width: 0;
}
.invoice-flow-shell .quotation-item-search-box {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.invoice-flow-shell .quotation-item-search-box:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.invoice-flow-shell .quotation-item-search-box > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  color: var(--text-secondary, #506360);
}
.invoice-flow-shell .quotation-item-search-box input {
  flex: 1 1;
  min-width: 0;
  width: auto;
  height: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  outline: 0;
  background: transparent;
  color: var(--text-primary, #142624);
  font: 400 14px/21.7px var(--font-family-primary, "Lexend", sans-serif);
  box-shadow: none;
}
.invoice-flow-shell .quotation-item-search-box input:focus {
  border: 0;
  outline: 0;
  box-shadow: none;
}
.invoice-flow-shell .quotation-item-search-box input::placeholder {
  color: var(--text-secondary, #6b7b78);
}
.invoice-flow-shell .quotation-item-search-dropdown {
  position: absolute;
  z-index: 1100;
  top: calc(100% + 4px);
  right: 0;
  left: 0;
  overflow: hidden;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-elevated, #fff);
  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),
    0 1px 2px rgba(14, 26, 32, 0.04);
}
.invoice-flow-shell .quotation-item-search-results-list {
  display: flex;
  max-height: 250px;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  padding: 4px;
}
.invoice-flow-shell .quotation-item-result-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  cursor: pointer;
  transition: background 0.12s ease;
}
.invoice-flow-shell .quotation-item-result-card:hover,
.invoice-flow-shell .quotation-item-result-card.selected {
  background: var(--interactive-soft, #f0f8f7);
}
.invoice-flow-shell .quotation-item-result-top {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.invoice-flow-shell .quotation-item-result-name-group,
.invoice-flow-shell .quotation-item-result-price-group {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}
.invoice-flow-shell .quotation-item-result-name-group .quotation-match-icon {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  color: var(--interactive-default, #0f766e);
}
.invoice-flow-shell .quotation-item-result-name {
  overflow: hidden;
  color: var(--interactive-default, #0f766e);
  font: 400 14px/21.7px var(--font-family-primary, "Lexend", sans-serif);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invoice-flow-shell .quotation-item-result-price-group {
  flex-shrink: 0;
  white-space: nowrap;
}
.invoice-flow-shell .quotation-item-result-gst-label {
  color: var(--text-tertiary, #6b7b78);
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
}
.invoice-flow-shell .quotation-item-result-price {
  color: var(--interactive-default, #0f766e);
  font: 500 16px/20.8px var(--font-family-mono, monospace);
}
.invoice-flow-shell .quotation-item-result-sub {
  margin: 0;
  color: var(--interactive-default, #0f766e);
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
  opacity: 0.75;
}
.invoice-flow-shell .quotation-item-no-results {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18px;
}
.invoice-flow-shell.dark .quotation-item-search-box {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-primary, #191b1f);
}
.invoice-flow-shell.dark .quotation-item-search-box:focus-within {
  border-color: var(--interactive-default, #43a79c);
  box-shadow: none;
}
.invoice-flow-shell.dark .quotation-item-search-box > svg {
  color: var(--text-secondary, #b3b8c2);
}
.invoice-flow-shell.dark .quotation-item-search-box input {
  color: var(--text-primary, #f2f3f5);
}
.invoice-flow-shell.dark .quotation-item-search-dropdown {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-elevated, #25282e);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}
.invoice-flow-shell.dark .quotation-item-result-card:hover,
.invoice-flow-shell.dark .quotation-item-result-card.selected {
  background: rgba(67, 167, 156, 0.15);
}
.invoice-flow-shell.dark
  .quotation-item-result-name-group
  .quotation-match-icon,
.invoice-flow-shell.dark .quotation-item-result-name,
.invoice-flow-shell.dark .quotation-item-result-price,
.invoice-flow-shell.dark .quotation-item-result-sub {
  color: var(--interactive-default, #43a79c);
}
.invoice-flow-shell.dark .quotation-item-result-gst-label {
  color: var(--text-tertiary, #959fa8);
}
.invoice-flow-shell.dark .quotation-item-no-results {
  color: var(--text-secondary, #b3b8c2);
}
.invoice-editor-shell .quotation-new-item-option {
  gap: 3px;
  padding: 10px 12px;
  background: transparent;
  color: var(--text-primary, #142624);
}
.invoice-editor-shell .quotation-new-item-option .quotation-item-result-name {
  color: inherit;
  font-weight: 600;
}
.invoice-editor-shell
  .quotation-new-item-option
  .quotation-item-result-name-group
  .quotation-match-icon {
  color: inherit;
}
.invoice-editor-shell.dark .quotation-new-item-option {
  background: transparent;
  color: var(--text-primary, #f2f3f5);
}
.invoice-editor-shell.dark
  .quotation-new-item-option
  .quotation-item-result-sub {
  opacity: 0.85;
}
@media (max-width: 700px) {
  .invoice-flow-shell .quotation-item-search-box {
    height: 44px;
  }
}
/* Invoice detail states and their shared history/payment panels. */
.invoice-status.status-draft {
  background: #f1f3f2;
  color: #52615f;
}
.invoice-status.status-awaiting-payment {
  background: #fff5df;
  color: #8a5d00;
}
.invoice-status.status-partially-paid {
  background: #fff5df;
  color: #8a5d00;
}
.invoice-status.status-overdue {
  background: #fff0ed;
  color: #b9382d;
}
.invoice-status.status-paid {
  background: #e7f7ed;
  color: #247a48;
}
.invoice-status.status-voided {
  background: #f1e9e9;
  color: #8b3434;
}
.invoice-origin-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px;
  padding: 10px 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--interactive-default, #0f766e);
  font: 500 12px var(--font-family-primary);
  cursor: pointer;
}
.invoice-origin-link svg {
  width: 16px;
  height: 16px;
}
.invoice-source-banner.draft {
  border-color: #dce3e2;
  background: #f7f9f8;
}
.invoice-financial-breakdown {
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #dce3e2;
}
.invoice-financial-breakdown span {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #506360;
  font-size: 11px;
}
.invoice-financial-breakdown b {
  color: #142624;
  font-family: var(--font-family-mono, monospace);
  font-weight: 500;
}
.invoice-inline-action {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid #cdd6d4;
  border-radius: 8px;
  background: #fff;
  color: #142624;
  font: 500 12px var(--font-family-primary);
  cursor: pointer;
}
.invoice-inline-action:hover {
  border-color: #0f766e;
  color: #0f766e;
}
.invoice-inline-action svg {
  width: 15px;
  height: 15px;
}
.invoice-settings-card .invoice-inline-action {
  align-self: flex-start;
  margin-top: 12px;
}
.invoice-state-panel {
  margin-top: 20px;
}
.invoice-state-panel-heading,
.invoice-history-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.invoice-state-panel-heading p,
.invoice-history-heading p {
  margin: 4px 0 18px;
  color: #506360;
  font-size: 12px;
  line-height: 18px;
}
.invoice-financial-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}
.invoice-financial-grid > div {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border: 1px solid #dce3e2;
  border-radius: 8px;
}
.invoice-financial-grid span,
.invoice-payment-list small {
  color: #506360;
  font-size: 11px;
}
.invoice-financial-grid strong,
.invoice-payment-list strong {
  font-family: var(--font-family-mono, monospace);
  font-size: 15px;
  font-weight: 500;
}
.invoice-payment-list {
  display: flex;
  flex-direction: column;
  margin-top: 14px;
}
.invoice-payment-list article {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 12px;
  padding: 12px 0;
  border-top: 1px solid #eef1f0;
}
.invoice-payment-list small {
  grid-column: 1/-1;
}
.invoice-payment-empty {
  margin-top: 14px;
  padding: 18px;
  border: 1px dashed #cdd6d4;
  border-radius: 8px;
  color: #506360;
  font-size: 12px;
  text-align: center;
}
.invoice-secondary-actions > div:last-child {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.invoice-history-heading {
  align-items: center;
}
.invoice-history-heading h2 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.invoice-history-heading .quotation-history-link-btn {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  cursor: pointer;
  font: 500 13px var(--font-family-primary);
}
.invoice-history-heading .quotation-history-link-btn:hover {
  text-decoration: underline;
}
.invoice-history-heading .quotation-history-link-btn:focus-visible {
  border-radius: 4px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 3px;
}
.invoice-history-content {
  align-items: start;
}
.invoice-activity-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 !important;
  border: 0 !important;
}
.invoice-activity-list article {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px 16px;
  padding: 12px 14px;
  border: 1px solid #dce3e2;
  border-bottom: 0;
  font-size: 12px;
}
.invoice-activity-list article.note {
  background: #f4f7f7;
}
.invoice-activity-list article:first-child {
  border-radius: 8px 8px 0 0;
}
.invoice-activity-list article:last-child {
  border-bottom: 1px solid #dce3e2;
  border-radius: 0 0 8px 8px;
}
.invoice-activity-list article time {
  grid-column: 2;
  grid-row: 1;
  white-space: nowrap;
  color: #506360;
}
.invoice-activity-list article > span,
.invoice-activity-list article > p {
  grid-column: 1 / -1;
}
.invoice-activity-list article > span {
  color: #142624;
  font-weight: 500;
}
.invoice-activity-list article p {
  margin: 0;
  color: #506360;
  line-height: 1.5;
}
.invoice-note-composer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.invoice-note-composer label {
  width: 100%;
}
.invoice-note-composer textarea {
  height: 92px !important;
}
.invoice-note-composer button {
  height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: #0f766e;
  color: #fff;
  font: 500 12px var(--font-family-primary);
  cursor: pointer;
}
.invoice-note-composer button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.invoice-flow-shell.dark .invoice-origin-link,
.invoice-flow-shell.dark .invoice-inline-action {
  border-color: #3a3f47;
  background: #191b1f;
  color: #f2f3f5;
}
.invoice-flow-shell.dark .invoice-inline-action:hover {
  border-color: #43a79c;
  color: #43a79c;
}
.invoice-flow-shell.dark .invoice-financial-breakdown,
.invoice-flow-shell.dark .invoice-payment-list article {
  border-color: #3a3f47;
}
.invoice-flow-shell.dark .invoice-financial-breakdown span,
.invoice-flow-shell.dark .invoice-payment-list small,
.invoice-flow-shell.dark .invoice-financial-grid span,
.invoice-flow-shell.dark .invoice-state-panel-heading p,
.invoice-flow-shell.dark .invoice-history-heading p,
.invoice-flow-shell.dark .invoice-payment-empty {
  color: #b3b8c2;
}
.invoice-flow-shell.dark .invoice-financial-breakdown b,
.invoice-flow-shell.dark .invoice-financial-grid strong,
.invoice-flow-shell.dark .invoice-payment-list strong {
  color: #f2f3f5;
}
.invoice-flow-shell.dark .invoice-financial-grid > div,
.invoice-flow-shell.dark .invoice-payment-empty,
.invoice-flow-shell.dark .invoice-activity-list article {
  border-color: #3a3f47;
  background: #191b1f;
  color: #f2f3f5;
}
.invoice-flow-shell.dark .invoice-activity-list article p,
.invoice-flow-shell.dark .invoice-activity-list article time {
  color: #b3b8c2;
}
.invoice-flow-shell.dark .invoice-activity-list article > span {
  color: #f2f3f5;
}
@media (max-width: 700px) {
  .invoice-state-panel-heading,
  .invoice-history-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .invoice-financial-grid {
    grid-template-columns: 1fr;
  }
  .invoice-secondary-actions > div:last-child {
    display: grid;
    grid-template-columns: 1fr;
  }
  .invoice-history-content {
    display: flex;
    flex-direction: column;
  }
  .invoice-note-composer {
    width: 100%;
  }
}

/* Invoice detail tablet and mobile layouts from Figma 1209:51343 / 1209:55575. */
.invoice-detail-orgbar {
  display: none;
  --dn-bg: var(--bg-primary, #f4f7f7);
  --dn-surface: var(--surface-primary, #fff);
  --dn-soft: var(--surface-secondary, #f4f7f7);
  --dn-text: var(--text-primary, #142624);
  --dn-muted: var(--text-secondary, #506360);
  --dn-border: var(--border-subtle, #dce3e2);
  --dn-border-strong: var(--border-default, #cdd6d4);
  --dn-brand: var(--interactive-default, #0f766e);
  --dn-brand-soft: var(--interactive-soft, #f0f8f7);
}
.invoice-flow-shell.dark .invoice-detail-orgbar {
  --dn-bg: #101113;
  --dn-surface: #191b1f;
  --dn-soft: #22252a;
  --dn-text: #f2f3f5;
  --dn-muted: #b3b8c2;
  --dn-border: #2c3036;
  --dn-border-strong: #3a3f47;
  --dn-brand: #43a79c;
  --dn-brand-soft: #22252a;
}
.desktop-origin-link {
  display: none;
}
@media (min-width: 1024px) {
  .invoice-detail-page > .mobile-origin-link {
    display: none;
  }
  .invoice-source-banner .desktop-origin-link {
    display: inline-flex;
    min-height: 40px;
    flex: 0 0 auto;
    align-self: center;
    margin: 0 0 0 auto;
    padding: 0 12px;
    white-space: nowrap;
  }
  .invoice-source-banner > div {
    min-width: 0;
    flex: 1 1;
  }
}
@media (max-width: 1023px) {
  .invoice-detail-page {
    padding: 24px;
  }
  .invoice-detail-orgbar {
    display: block;
    margin: 0 0 12px;
  }
  .invoice-detail-orgbar .debit-tablet-nav {
    display: flex;
    height: 62px;
    min-height: 62px;
    align-items: center;
    justify-content: space-between;
    margin: 0;
  }
  .invoice-detail-orgbar .debit-organisation-switcher {
    width: 220px;
    height: 62px;
  }
  .invoice-flow-back {
    height: 44px;
    margin-bottom: 8px;
  }
  .invoice-detail-header {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 4px 0 16px;
  }
  .invoice-detail-header h1 {
    font-size: 28px;
    line-height: 36px;
  }
  .invoice-detail-header > small {
    order: 2;
    font-size: 13px;
    line-height: 19px;
  }
  .invoice-detail-header .invoice-editor-actions {
    order: 3;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }
  .invoice-detail-header .invoice-editor-actions button {
    min-width: 0;
    height: 44px;
    padding: 0 8px;
    font-size: 13px;
    white-space: nowrap;
  }
  .invoice-detail-header .invoice-editor-actions button.primary {
    grid-column: 1/-1;
  }
  .invoice-detail-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .invoice-detail-aside {
    display: contents;
    position: static;
    width: auto;
  }
  .invoice-detail-aside > .invoice-total-card {
    order: -1;
  }
  .invoice-detail-aside > .invoice-settings-card {
    order: 1;
  }
  .invoice-detail-grid > .invoice-content-card {
    order: 2;
    width: 100%;
    min-width: 0;
  }
  .invoice-detail-aside > .invoice-draft-footnote {
    order: 3;
  }
  .invoice-detail-grid > .invoice-flow-card,
  .invoice-detail-aside > .invoice-flow-card {
    width: 100%;
    min-width: 0;
  }
  .invoice-detail-items .head {
    display: none;
  }
  .invoice-detail-items .row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px 16px;
    align-items: center;
    min-height: 0;
    margin-top: 12px;
    padding: 16px;
    border: 1px solid #dce3e2;
    border-radius: 10px;
    background: #fff;
    font-size: 13px;
    line-height: 20px;
  }
  .invoice-detail-items .row strong:first-child {
    grid-column: 1/-1;
    overflow-wrap: anywhere;
  }
  .invoice-detail-items .row span,
  .invoice-detail-items .row strong[data-label] {
    display: flex;
    grid-column: 1/-1;
    justify-content: space-between;
    gap: 16px;
    text-align: right !important;
  }
  .invoice-detail-items .row [data-label]::before {
    content: attr(data-label);
    color: #506360;
    font-family: var(--font-family-primary, "Lexend", sans-serif);
    font-size: 12px;
    font-weight: 400;
    text-align: left;
  }
  .invoice-detail-items .row strong[data-label] {
    font-family: var(--font-family-mono, monospace);
    font-weight: 500;
  }
  .invoice-content-summary {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .invoice-detail-aside > .invoice-settings-card {
    margin-top: 0;
  }
  .invoice-detail-page > .invoice-history-card-live {
    margin-top: 16px;
  }
}
@media (max-width: 700px) {
  .invoice-detail-page {
    padding: 16px;
  }
  .invoice-detail-orgbar {
    margin: 0 0 8px;
  }
  .invoice-detail-orgbar .debit-tablet-nav {
    min-height: 58px;
    height: auto;
    justify-content: flex-start;
    margin: 0;
  }
  .invoice-detail-orgbar .debit-tablet-brand {
    display: none;
  }
  .invoice-detail-orgbar .debit-organisation-wrap {
    width: 100%;
  }
  .invoice-detail-orgbar .debit-organisation-switcher {
    width: 100%;
    height: auto;
    min-height: 58px;
  }
  .invoice-flow-back {
    height: 40px;
    margin-bottom: 8px;
  }
  .invoice-detail-header h1 {
    font-size: 24px;
    line-height: 31px;
  }
  .invoice-detail-header p,
  .invoice-detail-header small {
    font-size: 12px;
    line-height: 18px;
  }
  .invoice-detail-header .invoice-editor-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .invoice-detail-header .invoice-editor-actions button {
    height: 44px;
    font-size: 12px;
  }
  .invoice-detail-grid {
    gap: 12px;
  }
  .invoice-detail-grid > .invoice-flow-card {
    padding: 16px;
    border-radius: 12px;
  }
  .invoice-detail-pairs {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .invoice-detail-items .row {
    margin-top: 10px;
    padding: 14px;
    border-radius: 8px;
    font-size: 13px;
    line-height: 20px;
  }
  .invoice-content-summary > div:first-child p,
  .invoice-content-summary > div:last-child p,
  .invoice-settings-card p {
    overflow-wrap: anywhere;
  }
  .invoice-detail-page > .invoice-state-panel,
  .invoice-detail-page > .invoice-history-card-live {
    margin-top: 12px;
  }
}

/* Desktop dark surface, contrast, and state treatments from Figma 1210:54382. */
.invoice-detail-shell.dark {
  color: var(--text-primary);
}
.invoice-detail-shell.dark.invoice-flow-shell {
  background: var(--bg-primary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark .invoice-flow-main {
  background: var(--bg-primary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark .invoice-detail-page {
  background: var(--bg-primary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark .app-topbar {
  background: var(--surface-primary);
}
.invoice-detail-shell.dark .dashboard-nav.dark {
  background: var(--surface-primary);
}
.invoice-detail-shell.dark .app-topbar {
  --tb-bg: var(--surface-primary);
  --tb-border: var(--border-subtle);
  --tb-search-bg: var(--surface-secondary);
  --tb-search-border: var(--border-subtle);
  --tb-search-focus-border: var(--focus-ring);
  --tb-text: var(--text-primary);
  --tb-text-muted: var(--text-secondary);
  --tb-text-tertiary: var(--text-tertiary);
  --tb-credits-border: var(--border-default);
  --tb-hover-bg: var(--surface-secondary);
  --tb-avatar-border: var(--border-subtle);
  --tb-status-ring: var(--surface-primary);
  --tb-status-dot: var(--interactive-default);
  --tb-menu-bg: var(--surface-primary);
  --tb-menu-border: var(--border-subtle);
  --tb-menu-item-hover: var(--surface-secondary);
}
.invoice-detail-shell.dark .dashboard-nav.dark {
  --dash-surface: var(--surface-primary);
  --dash-surface-2: var(--surface-secondary);
  --dash-surface-3: var(--surface-tertiary);
  --dash-border: var(--border-subtle);
  --dash-border-strong: var(--border-default);
  --dash-text: var(--text-primary);
  --dash-muted: var(--text-secondary);
  --dash-lock: var(--text-tertiary);
  --dash-brand: var(--interactive-default);
  --dash-brand-soft: var(--interactive-soft);
  --dash-danger: var(--money-overdue);
  --dash-bg: var(--bg-primary);
  --text-link: var(--interactive-default);
  background: var(--surface-primary);
  border-color: var(--border-subtle);
}
.invoice-detail-shell.dark .dashboard-nav.dark {
  background-color: #191b1f !important;
}
.invoice-detail-shell.dark .invoice-detail-orgbar {
  --dn-bg: var(--bg-primary);
  --dn-surface: var(--surface-primary);
  --dn-soft: var(--surface-secondary);
  --dn-text: var(--text-primary);
  --dn-muted: var(--text-secondary);
  --dn-border: var(--border-subtle);
  --dn-border-strong: var(--border-default);
  --dn-brand: var(--interactive-default);
  --dn-brand-soft: var(--interactive-soft);
}
.invoice-detail-shell.dark .invoice-detail-page {
  color: var(--text-primary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card {
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card label,
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-header p span,
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-pairs strong,
.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card > strong,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-content-summary
  > div:last-child
  strong,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-attachments-line
  strong {
  color: var(--text-primary);
}

.invoice-detail-contact-link {
  color: inherit;
  font: inherit;
  text-decoration: none;
  text-underline-offset: 2px;
}
.invoice-detail-contact-link:hover {
  text-decoration: underline !important;
}
.invoice-detail-contact-link:focus-visible {
  border-radius: 2px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}
.invoice-detail-contact-link:hover {
  color: #0f766e;
  text-decoration: underline !important;
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card input,
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card select,
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card textarea {
  border-color: var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-flow-card
  input::placeholder,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-flow-card
  textarea::placeholder {
  color: var(--text-tertiary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-header p,
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-header small,
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card > p,
.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card p,
.invoice-detail-shell.dark .invoice-detail-page .invoice-draft-footnote,
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-pairs span,
.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card > span,
.invoice-detail-shell.dark .invoice-detail-page .invoice-content-summary span,
.invoice-detail-shell.dark .invoice-detail-page .invoice-content-summary p,
.invoice-detail-shell.dark .invoice-detail-page .invoice-attachments-line span {
  color: var(--text-secondary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-content-card > hr,
.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card hr,
.invoice-detail-shell.dark .invoice-detail-page .invoice-content-summary hr {
  border-color: var(--border-subtle);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-items .head {
  background: var(--surface-secondary);
  color: var(--text-secondary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-items .row {
  border-color: var(--border-subtle);
  color: var(--text-primary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-items .row {
  background: var(--surface-primary);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-detail-items
  .row
  [data-label]::before {
  color: var(--text-secondary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-source-banner {
  border-color: var(--border-subtle);
  background: var(--bg-tertiary);
  color: var(--text-link);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-source-banner.draft {
  border-color: var(--border-subtle);
  background: var(--bg-tertiary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-source-banner span {
  color: var(--text-secondary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-origin-link {
  border-color: var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-link);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-private-note {
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-private-note span,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-history-content
  label
  small,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-history-content
  > div
  small {
  color: var(--text-secondary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-history-content > div {
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-editor-actions button,
.invoice-detail-shell.dark .invoice-detail-page .invoice-doc-action,
.invoice-detail-shell.dark .invoice-detail-page .invoice-inline-action {
  border-color: var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-editor-actions
  button:hover,
.invoice-detail-shell.dark .invoice-detail-page .invoice-doc-action:hover,
.invoice-detail-shell.dark .invoice-detail-page .invoice-inline-action:hover {
  border-color: var(--interactive-default);
  color: var(--text-link);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-editor-actions
  button.primary,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-note-composer
  button:not(:disabled) {
  border-color: var(--interactive-default);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-editor-actions
  button.primary:hover,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-note-composer
  button:not(:disabled):hover {
  border-color: var(--interactive-hover);
  background: var(--interactive-hover);
  color: var(--on-interactive-primary);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-editor-actions
  button:active,
.invoice-detail-shell.dark .invoice-detail-page .invoice-inline-action:active {
  border-color: var(--interactive-pressed);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card input:focus,
.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card select:focus,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-flow-card
  textarea:focus {
  border-color: var(--focus-ring);
  box-shadow: none;
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-draft {
  background: var(--money-draft-soft);
  color: var(--money-draft);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-status.status-awaiting-payment,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-status.status-partially-paid,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-status.status-partial-paid {
  background: var(--money-pending-soft);
  color: var(--money-pending);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-overdue {
  background: var(--money-overdue-soft);
  color: var(--money-overdue);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-paid {
  background: var(--money-paid-soft);
  color: var(--money-paid);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-voided {
  background: var(--surface-tertiary);
  color: var(--text-secondary);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-note-composer
  button:disabled {
  border: 1px solid var(--border-subtle);
  background: var(--surface-tertiary);
  color: var(--text-disabled);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-total-card svg,
.invoice-detail-shell.dark .invoice-detail-page .invoice-history-card h2 svg {
  color: var(--interactive-default);
}
.invoice-detail-shell.dark .invoice-detail-page .invoice-financial-grid > div,
.invoice-detail-shell.dark .invoice-detail-page .invoice-payment-empty {
  border-color: var(--border-subtle);
}
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-flow-back:focus-visible,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-editor-actions
  button:focus-visible,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-origin-link:focus-visible,
.invoice-detail-shell.dark
  .invoice-detail-page
  .invoice-inline-action:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

/* Figma Invoice Preview matching frame 905:88684 / 1179:48151 */
.customer-invoice-preview-page {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding: 32px 0 64px;
  box-sizing: border-box;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  color: var(--text-primary, #142624);
}

.customer-preview-back {
  margin-bottom: 16px;
}

.customer-preview-identity-row {
  margin-bottom: 16px;
}

.customer-preview-identity h1 {
  margin: 0 0 8px;
  color: var(--text-primary, #142624);
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.36px;
}

.customer-preview-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}

.customer-preview-number {
  color: var(--text-primary, #142624);
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.28px;
  text-transform: uppercase;
}

.customer-preview-legacy-controls {
  display: none;
}

.customer-invoice-preview-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.customer-invoice-preview-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.invoice-preview-btn {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 13px/18px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
  transition: all 0.15s ease;
}

.invoice-preview-btn:hover {
  border-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}

.invoice-preview-btn.primary {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: #fff;
}

.invoice-preview-btn.primary:hover {
  background: var(--interactive-hover, #0c5f59);
}

.invoice-preview-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.customer-invoice-preview-header {
  display: none;
}

.customer-invoice-preview-feedback[aria-label="Invoice status summary"] {
  display: none;
}

.preview-meta-grid.quote-meta-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.customer-invoice-preview-header h1 {
  margin: 0;
  font-size: 32px;
  line-height: 40px;
  font-weight: 600;
  letter-spacing: -0.48px;
  color: var(--text-primary, #142624);
}

.customer-invoice-preview-feedback {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  margin-bottom: 24px;
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  border: 1px solid var(--border-subtle, #dce3e2);
  box-sizing: border-box;
}

.customer-invoice-preview-feedback > svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: var(--text-secondary, #506360);
}

.customer-invoice-preview-feedback > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.customer-invoice-preview-feedback .feedback-primary {
  margin: 0;
  font-size: 13px;
  line-height: 16.9px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.customer-invoice-preview-feedback .feedback-secondary {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

.customer-invoice-preview-feedback .dot-sep {
  opacity: 0.7;
}

.customer-invoice-preview-card {
  padding: 32px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  background: var(--surface-primary, #fff);
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.preview-issuer-identity {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.preview-issuer-name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-height: 90px;
}

.preview-business-logo {
  display: block;
  width: auto;
  height: 64px;
  max-width: 160px;
  flex: 0 0 auto;
  object-fit: contain;
  object-position: left center;
}

.preview-business-monogram {
  display: inline-flex;
  width: 64px;
  height: 64px;
  align-items: center;
  justify-content: center;
  flex: 0 0 64px;
  border-radius: 999px;
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
  font-size: 16px;
  font-weight: 600;
}

.preview-issuer-name h2 {
  margin: 0;
  font-size: 18px;
  line-height: 25.2px;
  font-weight: 500;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.preview-doc-identity {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 200px;
}

.preview-doc-title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: -0.36px;
  color: var(--text-primary, #142624);
}

.preview-doc-number {
  font-family: var(--font-family-mono, monospace);
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  letter-spacing: 0.28px;
  text-transform: uppercase;
  color: var(--text-primary, #142624);
}

.preview-status-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.12px;
  white-space: nowrap;
}

.preview-status-pill.status-draft {
  background: #f4f7f7;
  color: #506360;
  border: 1px solid #dce3e2;
}

.preview-status-pill.status-awaiting {
  background: #fef3c7;
  color: #b45309;
  border: 1px solid #fde68a;
}

.preview-status-pill.status-paid {
  background: #dcfce7;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.preview-status-pill.status-overdue {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.preview-divider {
  margin: 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}

.preview-meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 20px;
}

.preview-meta-grid.quote-meta-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.preview-meta-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.preview-meta-label {
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

.preview-meta-value {
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  color: var(--text-primary, #142624);
  word-break: break-word;
}

.preview-meta-sub {
  font-size: 12px;
  color: var(--text-secondary, #506360);
  word-break: break-all;
}

.preview-items-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.preview-items-header h3 {
  margin: 0;
  font-size: 18px;
  line-height: 25.2px;
  font-weight: 500;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.preview-items-header p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

.preview-table-container {
  width: 100%;
  overflow-x: auto;
}

.preview-items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.preview-items-table thead tr {
  height: 44px;
  background: var(--surface-secondary, #f4f7f7);
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}

.preview-items-table th {
  padding: 8px 12px;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.12px;
  text-align: right;
  white-space: nowrap;
}

.preview-items-table th.th-desc {
  text-align: left;
}

.preview-items-table .th-qty { width: 48px; }
.preview-items-table .th-price { width: 112px; }
.preview-items-table .th-gst { width: 64px; }
.preview-items-table .th-discount { width: 96px; }
.preview-items-table .th-total { width: 140px; }

.preview-items-table tbody tr {
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}

.preview-items-table td {
  padding: 12px;
  vertical-align: middle;
  color: var(--text-primary, #142624);
  text-align: right;
  line-height: 21.7px;
}

.preview-items-table td.td-desc {
  text-align: left;
}

.preview-items-table td .item-name {
  display: block;
  font-weight: 400;
  color: var(--text-primary, #142624);
}

.preview-items-table td .item-sub-desc {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  line-height: 18px;
  color: var(--text-secondary, #506360);
}

.preview-items-table td.td-empty {
  text-align: center;
  padding: 24px;
  color: var(--text-secondary, #506360);
}

.font-mono {
  font-family: var(--font-family-mono, monospace);
  font-weight: 500;
}

.preview-bottom-section {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 400px;
  gap: 32px;
  align-items: flex-start;
  margin-top: 8px;
}

.preview-notes-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.preview-note-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.preview-note-title {
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  color: var(--text-primary, #142624);
  letter-spacing: 0.07px;
}

.preview-note-body {
  margin: 0;
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
  white-space: pre-line;
}

.preview-totals-column {
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-sizing: border-box;
}

.preview-totals-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.preview-totals-row .totals-label {
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
  letter-spacing: 0.065px;
}

.preview-totals-row .totals-value {
  font-size: 16px;
  line-height: 20.8px;
  color: var(--text-primary, #142624);
  white-space: nowrap;
}

.totals-divider {
  margin: 4px 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}

.preview-totals-row.grand-total .totals-label {
  font-size: 13px;
  color: var(--text-secondary, #506360);
}

.preview-totals-row.grand-total .grand-amount {
  font-size: 22px;
  line-height: 26.4px;
  font-weight: 700;
  color: var(--text-primary, #142624);
}

.preview-gst-clarification {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
  letter-spacing: 0.065px;
}

.preview-card-footnote {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
  letter-spacing: 0.065px;
}

.preview-bank-details {
  padding-top: 24px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}

.preview-bank-details h3 {
  margin: 0 0 16px;
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
  line-height: 17px;
}

.preview-bank-details dl {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
}

.preview-bank-details dl > div {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  gap: 16px;
}

.preview-bank-details dt,
.preview-bank-details dd {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 15px;
  line-height: 24px;
}

.preview-bank-details dd {
  color: var(--text-primary, #142624);
}

/* Dark mode overrides for Customer Invoice Preview */
.customer-invoice-preview-page.dark,
.invoice-flow-shell.dark .customer-invoice-preview-page {
  color: var(--text-primary, #f2f3f5);
}

.customer-invoice-preview-page.dark .customer-invoice-preview-header h1,
.invoice-flow-shell.dark .customer-invoice-preview-header h1,
.customer-invoice-preview-page.dark .preview-issuer-name h2,
.invoice-flow-shell.dark .preview-issuer-name h2,
.customer-invoice-preview-page.dark .preview-doc-title,
.invoice-flow-shell.dark .preview-doc-title,
.customer-invoice-preview-page.dark .preview-doc-number,
.invoice-flow-shell.dark .preview-doc-number,
.customer-invoice-preview-page.dark .preview-meta-value,
.invoice-flow-shell.dark .preview-meta-value,
.customer-invoice-preview-page.dark .preview-items-header h3,
.invoice-flow-shell.dark .preview-items-header h3,
.customer-invoice-preview-page.dark .preview-items-table td,
.invoice-flow-shell.dark .preview-items-table td,
.customer-invoice-preview-page.dark .preview-items-table td .item-name,
.invoice-flow-shell.dark .preview-items-table td .item-name,
.customer-invoice-preview-page.dark .preview-note-title,
.invoice-flow-shell.dark .preview-note-title,
.customer-invoice-preview-page.dark .preview-note-body,
.invoice-flow-shell.dark .preview-note-body,
.customer-invoice-preview-page.dark .preview-totals-row .totals-value,
.invoice-flow-shell.dark .preview-totals-row .totals-value,
.customer-invoice-preview-page.dark
  .preview-totals-row.grand-total
  .grand-amount,
.invoice-flow-shell.dark .preview-totals-row.grand-total .grand-amount {
  color: var(--text-primary, #f2f3f5);
}

.customer-invoice-preview-page.dark .customer-invoice-preview-feedback,
.invoice-flow-shell.dark .customer-invoice-preview-feedback {
  background: var(--surface-secondary, #22252a);
}

.customer-invoice-preview-page.dark .customer-invoice-preview-card,
.invoice-flow-shell.dark .customer-invoice-preview-card {
  border-color: var(--border-subtle, #343a3a);
  background: var(--surface-primary, #191b1f);
}

.customer-invoice-preview-page.dark .preview-status-pill,
.invoice-flow-shell.dark .preview-status-pill {
  background: var(--surface-tertiary, #2c3036);
  color: var(--text-secondary, #adbab7);
}

.customer-invoice-preview-page.dark .preview-items-table thead tr,
.invoice-flow-shell.dark .preview-items-table thead tr {
  background: var(--surface-secondary, #22252a);
  border-bottom-color: var(--border-subtle, #343a3a);
}

.customer-invoice-preview-page.dark .preview-items-table th,
.invoice-flow-shell.dark .preview-items-table th {
  color: var(--text-secondary, #adbab7);
}

.customer-invoice-preview-page.dark .preview-items-table tbody tr,
.invoice-flow-shell.dark .preview-items-table tbody tr,
.customer-invoice-preview-page.dark .preview-divider,
.invoice-flow-shell.dark .preview-divider,
.customer-invoice-preview-page.dark .preview-bank-details,
.invoice-flow-shell.dark .preview-bank-details,
.customer-invoice-preview-page.dark .totals-divider,
.invoice-flow-shell.dark .totals-divider {
  border-color: var(--border-subtle, #343a3a);
}

.customer-invoice-preview-page.dark .preview-bank-details h3,
.customer-invoice-preview-page.dark .preview-bank-details dd,
.invoice-flow-shell.dark .preview-bank-details h3,
.invoice-flow-shell.dark .preview-bank-details dd {
  color: var(--text-primary, #f2f3f5);
}

.customer-invoice-preview-page.dark .invoice-preview-btn,
.invoice-flow-shell.dark .invoice-preview-btn {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-primary, #191b1f);
  color: var(--text-primary, #f2f3f5);
}

.customer-invoice-preview-page.dark .invoice-preview-btn:hover,
.invoice-flow-shell.dark .invoice-preview-btn:hover {
  border-color: var(--interactive-default, #43a79c);
  color: var(--interactive-default, #43a79c);
}

.customer-invoice-preview-page.dark .invoice-preview-btn.primary,
.invoice-flow-shell.dark .invoice-preview-btn.primary {
  border-color: var(--interactive-default, #43a79c);
  background: var(--interactive-default, #43a79c);
  color: #101113;
}

.customer-invoice-preview-topbar.public-document-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.preview-topbar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.preview-topbar-left .invoice-context {
  font-size: 14px;
  color: var(--text-secondary, #506360);
  font-weight: 500;
}

.preview-amount-due-box {
  padding: 16px;
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
}

.amount-due-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.amount-due-label {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.amount-due-value {
  font-size: 22px;
  font-weight: 700;
  line-height: 26.4px;
  color: var(--text-primary, #142624);
}

.amount-due-sub {
  font-size: 13px;
  color: var(--text-secondary, #506360);
}

.preview-settled-box {
  padding: 16px;
  border-radius: 10px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-sizing: border-box;
}

.settled-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #065f46;
  font-size: 16px;
  font-weight: 600;
}

.preview-settled-box p {
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: #047857;
}

.customer-invoice-preview-page.dark .preview-amount-due-box,
.invoice-flow-shell.dark .preview-amount-due-box {
  background: var(--surface-secondary, #22252a);
}

.customer-invoice-preview-page.dark .amount-due-label,
.customer-invoice-preview-page.dark .amount-due-value,
.invoice-flow-shell.dark .amount-due-label,
.invoice-flow-shell.dark .amount-due-value {
  color: var(--text-primary, #f2f3f5);
}

.customer-invoice-preview-page.dark .preview-settled-box,
.invoice-flow-shell.dark .preview-settled-box {
  background: #06281e;
  border-color: #0d4a36;
}

.customer-invoice-preview-page.dark .settled-header,
.invoice-flow-shell.dark .settled-header {
  color: #34d399;
}

.customer-invoice-preview-page.dark .preview-settled-box p,
.invoice-flow-shell.dark .preview-settled-box p {
  color: #a7f3d0;
}

.invoice-preview-screen-shell {
  min-height: 100vh;
  background: var(--bg-dashboard, #f4f7f7);
  padding: 24px;
  box-sizing: border-box;
}

.invoice-preview-screen-shell.dark {
  background: #111315;
}

@media (max-width: 1023px) {
  .customer-invoice-preview-page {
    padding: 24px 16px 48px;
  }
  .preview-bottom-section {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .preview-totals-column {
    border-top: 1px solid var(--border-subtle, #dce3e2);
    padding-top: 20px;
  }
}

@media (max-width: 700px) {
  .customer-invoice-preview-page {
    padding: 16px 12px 32px;
  }
  .customer-invoice-preview-topbar {
    flex-direction: column;
    align-items: flex-start;
  }
  .customer-invoice-preview-actions {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .customer-invoice-preview-card {
    padding: 20px 16px;
  }
  .preview-issuer-identity {
    flex-direction: column;
  }
  .preview-doc-identity {
    align-items: flex-start;
  }
  .preview-meta-grid {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .preview-meta-grid.quote-meta-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .preview-bank-details dl > div {
    grid-template-columns: 120px minmax(0, 1fr);
  }
}

/* ==========================================================================
   Dedicated Send Invoice Modal (Figma node 905:88012 - Invoice Communications)
   ========================================================================== */

/* Record payment dialog (Figma nodes 905:88348 and 1209:58838) */
.record-payment-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4, 16px);
  background: var(--overlay-default, rgba(10, 22, 20, 0.4));
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.record-payment-dialog {
  width: min(100%, 640px);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  box-sizing: border-box;
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  box-shadow: var(--elevation-lg, 0 16px 36px rgba(10, 22, 20, 0.18));
}

.record-payment-header,
.record-payment-balance,
.record-payment-actions {
  display: flex;
  align-items: center;
}

.record-payment-header {
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.record-payment-header h2 {
  margin: 0;
  font: 500 18px/25.2px var(--font-family-primary, "Lexend", sans-serif);
}
.record-payment-header button {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  padding: 0;
  color: var(--text-secondary, #506360);
  background: transparent;
  border: 0;
  border-radius: var(--radius-md, 10px);
  cursor: pointer;
}
.record-payment-header button:hover {
  background: var(--surface-secondary, #f4f7f7);
}
.record-payment-header button span {
  display: none;
}
.record-payment-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-3, 12px);
  padding: 16px 20px;
}
.record-payment-invoice,
.record-payment-help {
  margin: 0;
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
}
.record-payment-invoice {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-weight: 500;
  text-transform: uppercase;
}
.record-payment-status {
  align-self: flex-start;
  padding: 3px 7px;
  color: var(--warning-text, #7d4412);
  background: var(--warning-soft, #fef8ec);
  border-radius: var(--radius-pill, 999px);
  font: 500 12px/15.6px var(--font-family-primary, "Lexend", sans-serif);
}
.record-payment-help {
  color: var(--text-secondary, #506360);
}
.record-payment-balance {
  justify-content: space-between;
  gap: 12px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
}
.record-payment-balance strong {
  color: var(--text-primary, #142624);
  font: 500 15px/19.5px var(--font-family-mono, "JetBrains Mono", monospace);
  white-space: nowrap;
}
.record-payment-content label,
.record-payment-field-label {
  display: flex;
  font: 500 13px/16.9px var(--font-family-primary, "Lexend", sans-serif);
}
.record-payment-content > label {
  flex-direction: column;
  gap: 6px;
}
.record-payment-field {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.record-payment-field .quotation-figma-dropdown,
.record-payment-field .figma-datepicker-root,
.record-payment-field .react-datepicker-wrapper,
.record-payment-field .react-datepicker__input-container {
  width: 100%;
}
.record-payment-field .quotation-figma-dropdown-trigger,
.record-payment-field .figma-datepicker__input-container {
  min-height: var(--control-md, 40px);
  border-radius: var(--radius-md, 10px);
}
.record-payment-field .quotation-figma-dropdown-menu {
  z-index: 12;
}
.record-payment-content label em,
.record-payment-field-label em {
  color: var(--danger-default, #c23a2b);
  font-style: normal;
}
.record-payment-content input:not(.figma-datepicker__input),
.record-payment-content select {
  width: 100%;
  height: var(--control-md, 40px);
  padding: 0 12px;
  box-sizing: border-box;
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  font: 400 13px/20.2px var(--font-family-primary, "Lexend", sans-serif);
}
.record-payment-content input:not(.figma-datepicker__input):focus,
.record-payment-content select:focus {
  outline: none;
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.record-payment-content input:not(.figma-datepicker__input)[readonly] {
  background: var(--surface-secondary, #f4f7f7);
}
.record-payment-error {
  color: var(--danger-text, #a3301f);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
}
.record-payment-projection {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  color: var(--text-secondary, #506360);
  background: var(--surface-secondary, #f4f7f7);
  border-radius: var(--radius-md, 10px);
  font: 400 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
}
.record-payment-projection strong {
  color: var(--text-primary, #142624);
  font-weight: 500;
}
.record-payment-actions {
  gap: var(--space-3, 12px);
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.record-payment-actions button {
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
  font: 500 13px / normal var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.record-payment-actions button.primary {
  color: var(--on-interactive-primary, #fff);
  background: var(--interactive-default, #0f766e);
  border-color: var(--interactive-default, #0f766e);
}
.record-payment-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .record-payment-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .record-payment-dialog {
    width: 100%;
    max-height: 88vh;
    border-radius: 20px 20px 0 0;
  }
  .record-payment-header {
    padding: 16px;
  }
  .record-payment-header h2 {
    font-size: 16px;
    line-height: 22.4px;
  }
  .record-payment-header button {
    display: block;
    width: auto;
    height: auto;
    color: var(--interactive-default, #0f766e);
    font: 500 13px/18.2px var(--font-family-primary, "Lexend", sans-serif);
  }
  .record-payment-header button svg {
    display: none;
  }
  .record-payment-header button span {
    display: inline;
  }
  .record-payment-content {
    padding: 16px;
  }
  .record-payment-actions {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }
  .record-payment-actions button {
    width: 100%;
    min-height: 44px;
  }
}

.send-invoice-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(14, 26, 32, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  animation: sendModalFadeIn 0.18s ease-out;
}

.send-invoice-dialog-backdrop.dark {
  background: var(--overlay-default, rgb(0 0 0 / 60%)) !important;
}

.invoice-editor-shell:has(> .send-invoice-dialog-backdrop)
  > .invoice-flow-main:has(> .customer-invoice-preview-page) {
  filter: blur(4px);
  pointer-events: none;
}

.invoice-editor-shell:has(> .invoice-flow-main > .customer-invoice-preview-page)
  > .send-invoice-dialog-backdrop {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

@keyframes sendModalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.send-invoice-dialog {
  width: 100%;
  max-width: 664px;
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),
    0px 1px 2px 0px rgba(14, 26, 32, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  max-height: 92vh;
  animation: sendModalSlideUp 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes sendModalSlideUp {
  from {
    transform: translateY(12px) scale(0.98);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.send-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  gap: 12px;
  box-sizing: border-box;
}

.send-dialog-header .header-identity {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.send-dialog-header .header-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.send-dialog-header .send-icon {
  font-size: 20px;
  color: var(--text-primary, #142624);
}

.send-dialog-header .send-icon.spin {
  animation: spin 1s linear infinite;
  color: var(--interactive-default, #0f766e);
}

.send-dialog-header .send-icon.failed {
  color: var(--danger-default, #c23a2b);
}

.send-dialog-header .send-icon.success {
  color: var(--success-default, #115a33);
}

.send-dialog-header .header-title {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 18px;
  line-height: 25.2px;
  font-weight: 500;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.send-dialog-close-btn {
  background: transparent;
  border: none;
  width: 32px;
  height: 40px;
  border-radius: var(--radius-md, 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary, #506360);
  font-size: 16px;
  transition: background 0.15s ease, color 0.15s ease;
}

.send-dialog-close-btn:hover:not(:disabled) {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}

.send-dialog-close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.send-dialog-divider {
  margin: 0;
  border: 0;
  height: 1px;
  background: var(--border-subtle, #dce3e2);
}

.send-dialog-body {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  box-sizing: border-box;
}

/* Feedback banners (waiting / failed) */
.send-feedback-banner {
  border-radius: var(--radius-md, 10px);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-sizing: border-box;
}

.send-feedback-banner.waiting {
  background: var(--surface-secondary, #f4f7f7);
}

.send-feedback-banner.waiting .feedback-headline {
  color: var(--text-primary, #142624);
}

.send-feedback-banner.failed {
  background: var(--danger-soft, #fef2f1);
  border: 1px solid rgba(194, 58, 43, 0.25);
}

.send-feedback-banner.failed .feedback-headline {
  color: var(--danger-default, #c23a2b);
}

.send-feedback-banner .feedback-headline {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  letter-spacing: 0.07px;
}

.send-feedback-banner .feedback-sub {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  line-height: 18.2px;
  font-weight: 400;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

/* Form stack */
.send-form-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.send-field-error {
  display: block;
  margin-top: 6px;
  color: var(--danger-text, #a3301f);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
}

.send-input-box:has([aria-invalid="true"]),
.send-textarea-box:has([aria-invalid="true"]) {
  border-color: var(--danger-default, #c23a2b);
}

.send-context-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.send-context-row .context-identity {
  font-family: var(--font-family-mono, monospace);
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  letter-spacing: 0.28px;
  text-transform: uppercase;
  color: var(--text-primary, #142624);
}

.send-context-row .context-status-pill {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  line-height: 15.6px;
  font-weight: 500;
  letter-spacing: 0.12px;
  padding: 3px 8px;
  border-radius: var(--radius-pill, 999px);
  white-space: nowrap;
}

/* Field Groups */
.send-field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.send-field-group.disabled {
  opacity: 0.75;
}

.send-field-group label {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.send-field-group.disabled label {
  color: var(--text-disabled, #8a9896);
}

.send-input-box {
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.send-field-group.disabled .send-input-box {
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-subtle, #dce3e2);
}

.send-input-box input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.send-input-box input:disabled {
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}

.send-textarea-box {
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-lg, 14px);
  padding: 12px 14px;
  box-sizing: border-box;
}

.send-field-group.disabled .send-textarea-box {
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-subtle, #dce3e2);
}

.send-textarea-box textarea {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  resize: vertical;
  min-height: 120px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.send-textarea-box textarea:disabled {
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}

/* Feedback Summary Card */
.send-summary-card {
  background: var(--surface-secondary, #f4f7f7);
  border-radius: var(--radius-md, 10px);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-sizing: border-box;
}

.send-summary-card .summary-title {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
}

.send-summary-card .summary-detail {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  line-height: 18.2px;
  font-weight: 400;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

/* Delivery Options */
.send-delivery-options {
  display: flex;
  gap: 16px;
  align-items: center;
  box-sizing: border-box;
}

.send-delivery-options.disabled {
  opacity: 0.75;
}

.send-delivery-options .checkbox-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.send-delivery-options .checkbox-option input[type="checkbox"] {
  accent-color: var(--interactive-default, #0f766e);
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

.send-delivery-options.disabled .checkbox-option {
  cursor: not-allowed;
  color: var(--text-disabled, #8a9896);
}

.send-supporting-copy {
  margin: 4px 0 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
  letter-spacing: 0.065px;
}

/* Dialog Actions Footer */
.send-dialog-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 20px;
  gap: 12px;
  box-sizing: border-box;
}

.send-action-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.15s ease;
  box-sizing: border-box;
  text-decoration: none;
}

.send-action-btn.outline {
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-default, #cdd6d4);
  color: var(--text-primary, #142624);
}

.send-action-btn.outline:hover:not(:disabled) {
  background: var(--surface-secondary, #f4f7f7);
}

.send-action-btn.outline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.send-action-btn.primary {
  background: var(--interactive-default, #0f766e);
  border: 1px solid var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #ffffff);
}

.send-action-btn.primary:hover:not(:disabled) {
  background: #0d655e;
  border-color: #0d655e;
}

.send-action-btn.primary:disabled,
.send-action-btn.primary.sending {
  opacity: 0.85;
  cursor: not-allowed;
}

/* Success Panel (Figma node 905:88103) */
.send-success-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0 8px;
}

.send-success-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
}

.send-success-indicator .success-icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(17, 90, 51, 0.12);
  color: var(--success-default, #115a33);
  font-size: 16px;
}

.send-success-indicator .success-sent-text {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  line-height: 21.7px;
  color: var(--success-text, #115a33);
  font-weight: 500;
}

.success-invoice-identity {
  font-family: var(--font-family-mono, monospace);
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 500;
  letter-spacing: 0.28px;
  text-transform: uppercase;
  color: var(--text-primary, #142624);
}

.success-badges {
  display: flex;
  gap: 8px;
  align-items: center;
}

.success-pill {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  line-height: 15.6px;
  font-weight: 500;
  letter-spacing: 0.12px;
  padding: 3px 8px;
  border-radius: var(--radius-pill, 999px);
  white-space: nowrap;
}

.success-pill.warning {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}

.success-pill.info {
  background: var(--info-soft, #eff6ff);
  color: var(--info-text, #1d4ed8);
}

.success-financial-breakdown {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 0 4px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}

.success-financial-breakdown .breakdown-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.success-financial-breakdown .breakdown-row span {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

.success-financial-breakdown .breakdown-row strong {
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.success-due-text {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  line-height: 21.7px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.success-footnote {
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

.success-action-wrap {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
}

/* Spinner helper */
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Dark mode for Send Invoice Dialog */
.send-invoice-dialog-backdrop.dark .send-invoice-dialog {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #343a3a);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.45);
}

.send-invoice-dialog-backdrop.dark .header-title,
.send-invoice-dialog-backdrop.dark .send-icon,
.send-invoice-dialog-backdrop.dark .send-field-group label,
.send-invoice-dialog-backdrop.dark .send-input-box input,
.send-invoice-dialog-backdrop.dark .send-textarea-box textarea,
.send-invoice-dialog-backdrop.dark .send-context-row .context-identity,
.send-invoice-dialog-backdrop.dark .send-summary-card .summary-title,
.send-invoice-dialog-backdrop.dark .checkbox-option,
.send-invoice-dialog-backdrop.dark .success-invoice-identity,
.send-invoice-dialog-backdrop.dark .success-due-text,
.send-invoice-dialog-backdrop.dark
  .success-financial-breakdown
  .breakdown-row
  strong {
  color: var(--text-primary, #f2f3f5);
}

.send-invoice-dialog-backdrop.dark .send-dialog-divider,
.send-invoice-dialog-backdrop.dark .success-financial-breakdown {
  background: var(--border-subtle, #343a3a);
  border-color: var(--border-subtle, #343a3a);
}

.send-invoice-dialog-backdrop.dark .send-input-box,
.send-invoice-dialog-backdrop.dark .send-textarea-box {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-default, #3a3f47);
}

.send-invoice-dialog-backdrop.dark .send-summary-card,
.send-invoice-dialog-backdrop.dark .send-feedback-banner.waiting {
  background: var(--surface-secondary, #22252a);
}

.send-invoice-dialog-backdrop.dark
  .send-feedback-banner.waiting
  .feedback-headline {
  color: var(--text-primary, #f2f3f5);
}

.send-invoice-dialog-backdrop.dark .send-feedback-banner.failed {
  background: rgba(194, 58, 43, 0.15);
  border-color: rgba(194, 58, 43, 0.35);
}

.send-invoice-dialog-backdrop.dark .send-context-row .context-status-pill {
  background: var(--surface-tertiary, #2c3036);
  color: var(--text-secondary, #adbab7);
}

.send-invoice-dialog-backdrop.dark .send-action-btn.outline {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.send-invoice-dialog-backdrop.dark
  .send-action-btn.outline:hover:not(:disabled) {
  background: var(--surface-secondary, #22252a);
}

.send-invoice-dialog-backdrop.dark .send-action-btn.primary {
  background: var(--interactive-default, #43a79c);
  border-color: var(--interactive-default, #43a79c);
  color: #101113;
}

.send-invoice-dialog-backdrop.dark
  .send-action-btn.primary:hover:not(:disabled) {
  background: #399288;
  border-color: #399288;
}

.send-invoice-dialog-backdrop.dark .success-pill.warning {
  background: rgba(254, 248, 236, 0.12);
  color: #f59e0b;
}

.send-invoice-dialog-backdrop.dark .success-pill.info {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}

.invoice-editor-shell .invoice-date-fields {
  align-items: start;
}

.invoice-editor-shell .invoice-date-fields > * {
  min-width: 0;
}

.invoice-editor-shell .invoice-date-picker-field,
.invoice-editor-shell .invoice-date-picker-field .react-datepicker-wrapper,
.invoice-editor-shell
  .invoice-date-picker-field
  .react-datepicker__input-container {
  width: 100%;
}

.invoice-editor-shell .invoice-date-picker-field .figma-datepicker__label {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}

.invoice-editor-shell .invoice-date-follow-up > input[readonly] {
  background: var(--surface-primary, #fff);
}

/* Match quotation fields with thin green focus borders and no glow. */
:is(.invoice-flow-shell.invoice-editor-shell, .invoice-flow-shell.invoice-detail-shell, .invoice-flow-shell.rcti-editor-shell)
  :is(.invoice-flow-card
    input:not(:disabled):not([readonly]):not([aria-invalid="true"]):focus, .invoice-flow-card
    select:not(:disabled):not([aria-invalid="true"]):focus, .invoice-flow-card
    textarea:not(:disabled):not([readonly]):not([aria-invalid="true"]):focus, .quotation-input-box:not(.disabled):not(.quotation-input-readonly):not(.error):not(:has(:disabled, [readonly], [aria-invalid="true"])):focus-within, .quotation-item-search-box:not(:has([aria-invalid="true"])):focus-within, .quotation-select-box:focus-within, .quotation-figma-dropdown.is-open
    .quotation-figma-dropdown-trigger, .quotation-figma-dropdown-trigger:not(:disabled):focus-visible) {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
  outline: none;
}

:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger,
:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)
  .quotation-figma-dropdown-trigger:not(:disabled):focus-visible,
.invoice-editor-shell
  .quotation-item-details-row
  .quotation-col-gst-select.quotation-custom-dropdown-wrap
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger {
  border-width: 1px;
  padding-inline: 12px 10px;
}

:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)
  .invoice-themed-select.Mui-focused {
  box-shadow: none;
}

:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)
  .figma-datepicker__input-container:focus-within {
  box-shadow: none !important;
}

:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)
  .figma-datepicker__input:focus {
  box-shadow: none !important;
}

.send-invoice-dialog
  :is(.send-input-box, .send-textarea-box):not(:has(:disabled, [aria-invalid="true"])):focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}

/* Invoice and RCTI draft errors match quotation field borders. */
:is(.invoice-editor-shell, .rcti-editor-shell)
  .invoice-flow-card
  :is(input[aria-invalid="true"], button[aria-invalid="true"], .quotation-input-box:has(input[aria-invalid="true"]), .quotation-item-search-box:has(input[aria-invalid="true"])) {
  border-color: var(--danger-default, #c23a2b);
  box-shadow: none;
}

/* Multi-recipient chip field in Send Invoice Dialog */
.send-invoice-dialog .quotation-dialog-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.send-invoice-dialog .quotation-dialog-field label {
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}
.send-invoice-dialog .quotation-recipient-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2, 8px);
  min-height: 40px;
  padding: 4px 8px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px/20px var(--font-family-primary, "Lexend", sans-serif);
  box-sizing: border-box;
}
.send-invoice-dialog .quotation-recipient-box:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.send-invoice-dialog .quotation-recipient-box.has-error {
  border-color: var(--danger-text, #a3301f);
}
.send-invoice-dialog .quotation-recipient-chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1, 4px);
  max-width: 100%;
  min-height: 28px;
  padding: 4px 8px;
  border-radius: var(--radius-sm, 6px);
  background: var(--interactive-soft, #f0f8f7);
  color: var(--text-primary, #142624);
  font-size: 13px;
}
.send-invoice-dialog .quotation-recipient-chip > span {
  min-width: 0;
  overflow-wrap: anywhere;
}
.send-invoice-dialog .quotation-recipient-chip--saved {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.send-invoice-dialog .quotation-recipient-chip button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.send-invoice-dialog .quotation-recipient-chip button:hover {
  background: var(--surface-tertiary, #e8edec);
}
.send-invoice-dialog .quotation-recipient-chip button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.send-invoice-dialog .quotation-recipient-chip svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
.send-invoice-dialog .quotation-recipient-box input.quotation-recipient-entry {
  flex: 1 1 160px;
  width: auto;
  min-width: 0;
  height: 30px;
  padding: 4px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  outline: none;
  box-shadow: none;
}
.send-invoice-dialog .quotation-field-error {
  margin: 0;
  color: var(--danger-text, #a3301f);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
}
.send-invoice-dialog .quotation-dialog-cancel-btn {
  align-self: flex-start;
  padding: 2px 4px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  font: 500 12px/16px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
  text-decoration: underline;
}
.send-invoice-dialog .quotation-dialog-cancel-btn:hover {
  color: var(--interactive-hover, #0d5f58);
}

/* Dark mode overrides for recipient field */
.send-invoice-dialog-backdrop.dark
  .send-invoice-dialog
  .quotation-recipient-box {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #343a3a);
  color: #fff;
}
.send-invoice-dialog-backdrop.dark
  .send-invoice-dialog
  .quotation-recipient-chip {
  background: rgba(15, 118, 110, 0.25);
  color: #5eead4;
}
.send-invoice-dialog-backdrop.dark
  .send-invoice-dialog
  .quotation-recipient-chip--saved {
  background: #2a2e35;
  color: #cbd5e1;
}
.send-invoice-dialog-backdrop.dark
  .send-invoice-dialog
  .quotation-recipient-chip
  button:hover {
  background: #343a3a;
}
.send-invoice-dialog-backdrop.dark
  .send-invoice-dialog
  .quotation-recipient-box
  input.quotation-recipient-entry {
  color: #fff;
}

/* Issue confirmation occupies its own row above the shared email actions. */
.rcti-email-authorisation { display: flex; align-items: flex-start; gap: 12px; padding: 16px; margin-top: 16px; border: 1px solid var(--border-subtle); border-radius: 10px; font-size: 13px; line-height: 1.6; }
.rcti-email-authorisation input { flex: 0 0 16px; width: 16px; height: 16px; margin: 3px 0 0; accent-color: var(--interactive-default); }
`, "",{"version":3,"sources":["webpack://./src/layouts/Invoices/invoiceFlow.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,6DAA6D;AAC/D;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,iDAAiD;AACnD;AACA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;;;EAGE,oCAAoC;EACpC,kCAAkC;AACpC;AACA;;;EAGE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;;EAGE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,oEAAoE;EACpE,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,oEAAoE;EACpE,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iDAAiD;AACnD;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,0CAA0C;EAC1C,+CAA+C;EAC/C,wEAAwE;EACxE,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,SAAO;EACP,SAAS;EACT,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,SAAS;EACT,SAAS;EACT,mDAAmD;AACrD;AACA;EACE,YAAY;EACZ,cAAc;EACd,sEAAsE;EACtE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,SAAS;AACX;AACA;EACE,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,gCAAgC;EAChC,mDAAmD;AACrD;AACA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,SAAS;AACX;AACA;;;EAGE,qCAAqC;EACrC,eAAe;AACjB;AACA;;EAEE,iEAAiE;EACjE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,gCAAgC;EAChC,uBAAuB;EACvB,SAAS;EACT,oEAAoE;EACpE,eAAe;AACjB;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,wCAAwC;EACxC,gDAAgD;EAChD,qCAAqC;EACrC,wEAAwE;AAC1E;AACA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,SAAS;AACX;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,2CAA2C;EAC7C;EACA;;IAEE,kEAAkE;EACpE;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,+BAA+B;IAC/B,QAAQ;EACV;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;;IAEE,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,iEAAiE;AACnE;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mDAAmD;EACnD,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yDAAyD;AAC3D;AACA;EACE;;IAEE,aAAa;IACb,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;AACA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,6CAA6C;EAC7C,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,aAAa;IACb,0CAA0C;IAC1C,aAAa;IACb,aAAa;EACf;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;;;EAGE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,oEAAoE;EACpE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sDAAsD;EACtD,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,2CAA2C;EAC7C;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA,qDAAqD;AACrD;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;;;EAGE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;;;EAGE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;;IAEE,eAAe;IACf,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;;IAEE,WAAW;EACb;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,aAAa;EACf;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,aAAa;IACb,8BAA8B;IAC9B,QAAQ;EACV;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;;IAGE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;;;;IAIE,eAAe;IACf,mBAAmB;EACrB;EACA;;IAEE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;;;;IAIE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;;IAEE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,8EAA8E;AAC9E;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,sEAAsE;AACxE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,qDAAqD;AACvD;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sEAAsE;EACtE,mBAAmB;AACrB;AACA;;;;EAIE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,UAAU;EACV,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,oEAAoE;EACpE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA,iEAAiE;AACjE;;EAEE,UAAU;AACZ;AACA;;;EAGE,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;EACvC,uBAAuB;AACzB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE;IACE,WAAW;EACb;EACA;;IAEE,oEAAoE;EACtE;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;;IAEE,kEAAkE;EACpE;AACF;AACA;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA,yEAAyE;AACzE;;EAEE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,mCAAmC;AACrC;AACA;;;;EAIE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;;;;;EAKE,6CAA6C;AAC/C;AACA;;;;EAIE,4CAA4C;AAC9C;AACA;;;;EAIE,2CAA2C;AAC7C;AACA;;;;EAIE,oCAAoC;AACtC;AACA;EACE,kDAAkD;AACpD;AACA;;;;;EAKE,qCAAqC;AACvC;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,0DAA0D;AAC5D;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mCAAmC;EACnC,sEAAsE;EACtE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,gDAAgD;EAChD,qCAAqC;EACrC,yCAAyC;EACzC;oCACkC;AACpC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;;EAEE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,sEAAsE;EACtE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,sEAAsE;EACtE,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,wDAAwD;AAC1D;AACA;EACE,SAAS;EACT,0CAA0C;EAC1C,sEAAsE;EACtE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,4CAA4C;EAC5C,2CAA2C;AAC7C;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,yCAAyC;AAC3C;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;;;EAME,0CAA0C;AAC5C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;AACA;;;EAGE,aAAa;AACf;AACA;EACE;IACE,YAAY;EACd;AACF;AACA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,mCAAmC;EACnC,0CAA0C;EAC1C,4CAA4C;EAC5C,uCAAuC;EACvC,0CAA0C;EAC1C,0CAA0C;EAC1C,kDAAkD;EAClD,+CAA+C;EAC/C,iDAAiD;AACnD;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,SAAO;EACT;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,QAAQ;IACR,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,QAAQ;IACR,aAAa;IACb,WAAW;IACX,gDAAgD;IAChD,QAAQ;EACV;EACA;IACE,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,WAAW;IACX,YAAY;EACd;EACA;IACE,QAAQ;EACV;EACA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,0CAA0C;IAC1C,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;;IAEE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,6DAA6D;IAC7D,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,+CAA+C;IAC/C,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;;;IAGE,uBAAuB;EACzB;EACA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,gFAAgF;AAChF;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,wCAAwC;EACxC,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,sCAAsC;EACtC,wCAAwC;EACxC,0CAA0C;EAC1C,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;EACxC,2CAA2C;EAC3C,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;AAChD;AACA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,yCAAyC;EACzC,mCAAmC;EACnC,2CAA2C;EAC3C,gCAAgC;EAChC,mCAAmC;EACnC,iCAAiC;EACjC,wCAAwC;EACxC,0CAA0C;EAC1C,mCAAmC;EACnC,4BAA4B;EAC5B,uCAAuC;EACvC,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mCAAmC;EACnC,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,yCAAyC;EACzC,sCAAsC;EACtC,wCAAwC;AAC1C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;;;;;;;;;;;;;EAaE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qCAAqC;AACvC;AACA;;;EAGE,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;;;;;;;;EAQE,2BAA2B;AAC7B;AACA;;;;;;;;;;EAUE,4BAA4B;AAC9B;AACA;;;EAGE,kCAAkC;AACpC;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,kCAAkC;AACpC;AACA;;;;;EAKE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;;;;;;;;;;;EAWE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;;;EAGE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;;;;;;EAME,wCAAwC;EACxC,uBAAuB;AACzB;AACA;;;;;;;;EAQE,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;AACtC;AACA;;;;;;;;EAQE,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;AACtC;AACA;;;;;EAKE,wCAAwC;AAC1C;AACA;;;;;;EAME,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;;;;EAIE,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,kCAAkC;AACpC;AACA;;;;;;;;;;;;;EAaE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,6DAA6D;EAC7D,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iEAAiE;EACjE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;EACpE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,kDAAkD;EAClD,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,+CAA+C;EAC/C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,4CAA4C;EAC5C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B,WAAW,EAAE;AAC5C,iCAAiC,YAAY,EAAE;AAC/C,+BAA+B,WAAW,EAAE;AAC5C,oCAAoC,WAAW,EAAE;AACjD,iCAAiC,YAAY,EAAE;;AAE/C;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,qDAAqD;AACrD;;EAEE,mCAAmC;AACrC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,mCAAmC;AACrC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;;EAEE,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;;EAEE,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;;;;;;;EAQE,2CAA2C;AAC7C;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;EAEE,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;;EAEE,iDAAiD;EACjD,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,mDAAmD;IACnD,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;;+EAE+E;;AAE/E,iEAAiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yDAAyD;EACzD,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,wCAAwC;EACxC,+CAA+C;EAC/C,qCAAqC;EACrC,mEAAmE;AACrE;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,SAAS;EACT,sEAAsE;AACxE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,uBAAuB;EACvB,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,sEAAsE;AACxE;AACA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,wCAAwC;EACxC,wCAAwC;EACxC,sEAAsE;AACxE;AACA;EACE,qCAAqC;AACvC;AACA;EACE,8BAA8B;EAC9B,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,0EAA0E;EAC1E,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,sEAAsE;AACxE;AACA;EACE,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;;;EAIE,WAAW;AACb;AACA;;EAEE,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;;EAEE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,mCAAmC;EACnC,wCAAwC;EACxC,gDAAgD;EAChD,qCAAqC;EACrC,sEAAsE;AACxE;AACA;;EAEE,aAAa;EACb,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kCAAkC;EAClC,oEAAoE;AACtE;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;EACrC,sEAAsE;AACxE;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,mCAAmC;EACnC,wCAAwC;EACxC,wEAAwE;EACxE,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,iDAAiD;AACnD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,sEAAsE;EACxE;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC;0CACwC;EACxC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,oEAAoE;AACtE;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sCAAsC;AACtC;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;;;;;;;;;;;;;EAcE,mCAAmC;AACrC;;AAEA;;EAEE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;;EAEE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sEAAsE;AACtE;;;;;;EAME,iDAAiD;EACjD,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;;;;;;;;EAUE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;;;EAGE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;EACpE,sBAAsB;AACxB;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,4CAA4C;EAC5C,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,oEAAoE;AACtE;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,oEAAoE;EACpE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,wCAAwC;AAC1C;;AAEA,4CAA4C;AAC5C;;;EAGE,2CAA2C;EAC3C,4CAA4C;EAC5C,WAAW;AACb;AACA;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;AACA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;EAIE,WAAW;AACb;;AAEA,4EAA4E;AAC5E,4BAA4B,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,aAAa,EAAE,gBAAgB,EAAE,sCAAsC,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChN,kCAAkC,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,wCAAwC,EAAE","sourcesContent":[".invoice-flow-shell {\n  min-height: 100vh;\n  background: #f4f7f7;\n  color: #142624;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.invoice-flow-shell .invoice-item-actions button {\n  cursor: pointer;\n}\n.invoice-flow-main {\n  min-height: 100vh;\n  margin-left: 256px;\n}\n.invoice-editor-page {\n  padding: 32px;\n}\n.invoice-flow-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0f766e;\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-editor-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px 24px;\n  margin: 8px 0 24px;\n}\n.invoice-editor-header h1 {\n  margin: 0;\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 600;\n}\n.invoice-editor-header p,\n.invoice-editor-header small {\n  margin: 4px 0 0;\n  color: #506360;\n  font-size: 12px;\n}\n.invoice-editor-header p span {\n  font-family: var(--font-family-mono, monospace);\n  color: #142624;\n}\n.invoice-editor-header > small {\n  grid-column: 1/-1;\n}\n.invoice-editor-shell .invoice-editor-header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4, 16px);\n}\n.invoice-editor-shell .invoice-editor-header h1 {\n  font-size: var(--font-size-h1, 32px);\n  line-height: var(--line-height-h1, 1.25);\n  letter-spacing: var(--letter-spacing-h1, -0.48px);\n}\n.invoice-editor-shell .invoice-editor-header .quotation-editor-subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.invoice-editor-shell .invoice-editor-header .quotation-editor-subtitle span {\n  font-family: inherit;\n  color: inherit;\n}\n@media (max-width: 767px) {\n  .invoice-editor-shell .invoice-editor-header h1 {\n    font-size: 28px;\n    line-height: 36px;\n  }\n}\n.invoice-editor-actions {\n  display: flex;\n  gap: 8px;\n}\n.invoice-editor-actions button,\n.invoice-doc-action {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 13px;\n  border: 1px solid #cdd6d4;\n  border-radius: 10px;\n  background: #fff;\n  color: #142624;\n  font: 500 12px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-editor-actions button.primary {\n  border-color: #0f766e;\n  background: #0f766e;\n  color: #fff;\n}\n.invoice-editor-shell.dark .invoice-editor-actions button:not(.primary) {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border-color: var(--border-default);\n}\n.invoice-editor-shell.dark\n  .invoice-editor-actions\n  button:not(.primary):hover:not(:disabled) {\n  background: var(--surface-secondary);\n  border-color: var(--border-strong);\n}\n.invoice-editor-shell.dark\n  .invoice-editor-actions\n  button:not(.primary):focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.invoice-editor-actions button:disabled,\n.invoice-doc-action:disabled,\n.invoice-delivery-card button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.invoice-editor-shell .invoice-editor-actions button.primary:not(:disabled),\n.invoice-editor-shell .invoice-delivery-card > button:not(:disabled) {\n  cursor: pointer;\n}\n.invoice-editor-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 24px;\n  align-items: start;\n}\n.invoice-editor-column,\n.invoice-editor-aside {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.invoice-flow-card {\n  box-sizing: border-box;\n  padding: 24px;\n  border: 1px solid #dce3e2;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.invoice-flow-card h2 {\n  margin: 0;\n  font-size: 16px;\n  line-height: 23px;\n  font-weight: 500;\n}\n.invoice-flow-card > p,\n.invoice-section-title p,\n.invoice-flow-card > small {\n  margin: 4px 0 18px;\n  color: #506360;\n  font-size: 12px;\n  line-height: 18px;\n}\n.invoice-flow-card label {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 7px;\n  color: #142624;\n  font-size: 12px;\n  font-weight: 500;\n}\n.invoice-flow-card input,\n.invoice-flow-card select,\n.invoice-flow-card textarea {\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid #cdd6d4;\n  border-radius: 8px;\n  outline: 0;\n  background: #fff;\n  color: #142624;\n  font: 400 13px var(--font-family-primary);\n}\n.invoice-flow-card textarea {\n  height: 112px;\n  padding: 12px;\n  resize: vertical;\n}\n.invoice-flow-card input:focus,\n.invoice-flow-card select:focus,\n.invoice-flow-card textarea:focus {\n  border-color: #0f766e;\n  box-shadow: none;\n}\n.invoice-flow-card input[readonly] {\n  background: #f4f7f7;\n  color: #506360;\n}\n.invoice-flow-card label > em {\n  color: #c23a2b;\n  font-size: 11px;\n  font-style: normal;\n}\n.invoice-fields {\n  display: grid;\n  gap: 16px;\n  margin: 18px 0;\n}\n.invoice-fields.two {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.invoice-fields.three {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n.invoice-date-input {\n  position: relative;\n}\n.invoice-date-input svg {\n  position: absolute;\n  top: 11px;\n  right: 12px;\n  color: #506360;\n  pointer-events: none;\n}\n.invoice-section-title {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n.invoice-section-title > select {\n  width: 140px;\n}\n.invoice-item-heading {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) 56px 104px 84px 112px 28px;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 10px 0;\n  background: #f4f7f7;\n  color: #506360;\n  font-size: 10px;\n}\n.invoice-edit-item {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) 56px 104px 84px 112px 28px;\n  gap: 8px;\n  padding: 12px 0;\n  border-bottom: 1px solid #dce3e2;\n}\n.invoice-edit-item .item-picker {\n  grid-column: 1/-1;\n}\n.invoice-edit-item .item-description {\n  grid-column: 1;\n}\n.invoice-edit-item strong {\n  align-self: center;\n  text-align: right;\n  font: 500 12px var(--font-family-mono, monospace);\n}\n.invoice-edit-item > strong {\n  min-width: 0;\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.invoice-edit-item > button {\n  display: grid;\n  width: 28px;\n  height: 40px;\n  place-items: center;\n  border: 0;\n  background: transparent;\n  color: #506360;\n}\n.invoice-edit-item .discount-type {\n  grid-column: 1;\n  width: 148px;\n}\n.invoice-edit-item .discount-value {\n  grid-column: 2/4;\n  width: 148px;\n}\n.invoice-item-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 16px 0;\n}\n.invoice-item-actions button {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid #cdd6d4;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f766e;\n  font: 500 11px var(--font-family-primary);\n}\n.invoice-item-actions > span {\n  margin-left: auto;\n  color: #506360;\n  font-size: 10px;\n}\n.invoice-item-actions strong {\n  margin-left: 12px;\n  color: #142624;\n  font-family: var(--font-family-mono, monospace);\n}\n.invoice-attachment-box {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-top: 16px;\n  padding: 16px;\n  border: 1px solid #dce3e2;\n  border-radius: 10px;\n  background: #f4f7f7;\n}\n.invoice-attachment-box > svg {\n  color: #0f766e;\n}\n.invoice-attachment-box strong {\n  font-size: 13px;\n}\n.invoice-attachment-box p {\n  margin: 3px 0 0;\n  color: #506360;\n  font-size: 11px;\n}\n.invoice-upload-button {\n  margin-left: auto;\n}\n.invoice-upload-button input {\n  display: none;\n}\n.invoice-editor-aside {\n  position: sticky;\n  top: 88px;\n  max-height: calc(100vh - 112px);\n  overflow-y: auto;\n  overscroll-behavior: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.invoice-editor-aside::-webkit-scrollbar {\n  display: none;\n}\n.invoice-total-card > div {\n  display: flex;\n  justify-content: space-between;\n}\n.invoice-total-card svg {\n  color: #0f766e;\n}\n.invoice-total-card > strong {\n  display: block;\n  margin: 18px 0 7px;\n  font: 700 24px var(--font-family-mono, monospace);\n}\n.invoice-total-card > p {\n  margin: 0;\n}\n.invoice-balance-payment-action {\n  width: 100%;\n  height: 40px;\n  margin-top: 20px;\n  border: 0;\n  border-radius: var(--radius-md, 10px);\n  color: var(--on-interactive-primary, #fff);\n  background: var(--interactive-default, #0f766e);\n  font: 500 13px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.invoice-balance-payment-action:hover {\n  background: var(--interactive-hover, #0c5f59);\n}\n.invoice-remaining-card {\n  min-height: 437px;\n  padding: 0;\n  overflow: hidden;\n}\n.invoice-remaining-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-5, 24px);\n  width: 100%;\n  min-height: 120px;\n  box-sizing: border-box;\n}\n.invoice-remaining-heading {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3, 12px);\n  width: 100%;\n}\n.invoice-remaining-heading h2 {\n  flex: 1;\n  margin: 0;\n  font: 500 16px/22.4px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: -0.08px;\n}\n.invoice-remaining-heading svg {\n  width: 20px;\n  height: 20px;\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-remaining-headline {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n  width: 100%;\n}\n.invoice-remaining-headline strong {\n  font: 700 20px/24px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.invoice-remaining-headline p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n}\n.invoice-remaining-financials {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-4, 16px);\n  width: 100%;\n  box-sizing: border-box;\n}\n.invoice-remaining-financials > hr {\n  width: 100%;\n  margin: 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.invoice-remaining-financials .invoice-status {\n  height: 22px;\n  padding: 0 6px;\n  font: 500 11px/14.3px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.11px;\n}\n.invoice-remaining-financials .invoice-balance-breakdown {\n  gap: var(--space-4, 16px);\n  padding: 0;\n  border: 0;\n}\n.invoice-remaining-financials .invoice-balance-breakdown span {\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n}\n.invoice-remaining-financials .invoice-balance-breakdown strong {\n  font: 500 15px/19.5px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.invoice-remaining-financials .invoice-balance-payment-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 0;\n  padding: 0 12px;\n}\n.invoice-remaining-financials .invoice-balance-payment-action svg {\n  width: 16px;\n  height: 16px;\n}\n.invoice-total-card > .invoice-status {\n  align-self: flex-start;\n}\n.invoice-balance-breakdown {\n  display: grid;\n  gap: var(--space-2, 8px);\n  width: 100%;\n  padding-top: var(--space-2, 8px);\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.invoice-balance-breakdown p,\n.invoice-credit-total,\n.invoice-delivery-status {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3, 12px);\n  width: 100%;\n  margin: 0;\n}\n.invoice-balance-breakdown span,\n.invoice-delivery-card > span,\n.invoice-delivery-card > p {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.invoice-balance-breakdown strong,\n.invoice-credit-total strong {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 13px;\n}\n.invoice-delivery-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-3, 12px);\n}\n.invoice-delivery-card > h2,\n.invoice-delivery-card > p {\n  margin: 0;\n}\n.invoice-delivery-card > strong {\n  overflow-wrap: anywhere;\n  font-size: 12px;\n}\n.invoice-delivery-status b {\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-delivery-card .invoice-link-action {\n  padding: 0;\n  color: var(--text-link, #0f766e);\n  background: transparent;\n  border: 0;\n  font: 500 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.invoice-delivery-card hr {\n  width: 100%;\n  margin: var(--space-1, 4px) 0;\n}\n.invoice-delivery-card .invoice-reminder-action {\n  width: 100%;\n  margin-top: var(--space-1, 4px);\n  height: 40px;\n  padding: 0 12px;\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  font: 500 13px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.invoice-delivery-card .invoice-reminder-action:hover {\n  color: var(--text-primary, #142624);\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-default, #cdd6d4);\n}\n.invoice-delivery-card .invoice-reminder-action svg {\n  width: 16px;\n  height: 16px;\n}\n.invoice-payment-credit-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-6, 24px);\n}\n.invoice-payment-credit-grid > .invoice-flow-card {\n  min-width: 0;\n}\n.invoice-credit-notes-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-4, 16px);\n}\n.invoice-credit-notes-card > h2,\n.invoice-credit-notes-card > p {\n  margin: 0;\n}\n.invoice-credit-notes-card > hr {\n  width: 100%;\n  margin: 0;\n}\n.invoice-credit-notes-card .invoice-credit-list {\n  width: 100%;\n  max-height: 244px;\n  margin-top: 0;\n  padding-right: var(--space-2, 8px);\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n.invoice-credit-notes-card .invoice-credit-list article {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4, 16px);\n}\n.invoice-credit-note-details {\n  display: grid;\n  min-width: 0;\n  gap: var(--space-1, 4px);\n}\n.invoice-credit-note-details small {\n  grid-column: auto;\n}\n.invoice-credit-note-link {\n  flex: 0 0 auto;\n  text-decoration: none;\n}\n.invoice-secondary-actions {\n  display: none;\n}\n@media (max-width: 900px) {\n  .invoice-payment-credit-grid {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 420px) {\n  .invoice-credit-notes-card .invoice-credit-list article {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .invoice-credit-note-link {\n    width: 100%;\n  }\n}\n.invoice-doc-action {\n  width: 100%;\n}\n.invoice-doc-action.download {\n  border: 0;\n  background: transparent;\n  color: #0f766e;\n}\n.invoice-summary-card > p {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 16px 0;\n  font-size: 11px;\n}\n.invoice-summary-card > p span {\n  color: #506360;\n}\n.invoice-summary-card > p strong {\n  font-family: var(--font-family-mono, monospace);\n  text-align: right;\n}\n.invoice-summary-card hr {\n  border: 0;\n  border-top: 1px solid #dce3e2;\n}\n.invoice-summary-card > p.grand {\n  font-size: 13px;\n}\n.invoice-delivery-card p {\n  margin: 14px 0;\n  color: #506360;\n  font-size: 11px;\n  line-height: 17px;\n}\n.invoice-delivery-card button {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: 0;\n  border-radius: 8px;\n  background: #0f766e;\n  color: #fff;\n  font: 500 12px var(--font-family-primary);\n}\n.invoice-flow-shell.dark {\n  background: #101113;\n  color: #f2f3f5;\n}\n.invoice-flow-shell.dark .invoice-flow-card,\n.invoice-flow-shell.dark input,\n.invoice-flow-shell.dark select,\n.invoice-flow-shell.dark textarea {\n  border-color: #343a3a;\n  background: #191b1f;\n  color: #f2f3f5;\n}\n@media (max-width: 1023px) {\n  .invoice-flow-main {\n    margin-left: 0;\n  }\n  .invoice-editor-page {\n    padding: 24px;\n  }\n  .invoice-editor-grid {\n    grid-template-columns: minmax(0, 1fr) 280px;\n  }\n  .invoice-item-heading,\n  .invoice-edit-item {\n    grid-template-columns: minmax(180px, 1fr) 48px 88px 72px 96px 28px;\n  }\n}\n@media (max-width: 700px) {\n  .invoice-editor-page {\n    padding: 16px;\n  }\n  .invoice-flow-back {\n    height: 44px;\n  }\n  .invoice-editor-header {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 16px;\n  }\n  .invoice-editor-header h1 {\n    font-size: 24px;\n    line-height: 30px;\n  }\n  .invoice-editor-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n  .invoice-editor-actions .primary {\n    grid-column: 1/-1;\n  }\n  .invoice-editor-grid {\n    display: flex;\n    flex-direction: column;\n  }\n  .invoice-editor-aside {\n    position: static;\n    display: contents;\n  }\n  .invoice-total-card {\n    order: -1;\n  }\n  .invoice-flow-card {\n    padding: 16px;\n    border-radius: 10px;\n  }\n  .invoice-fields.two,\n  .invoice-fields.three {\n    grid-template-columns: 1fr;\n  }\n  .invoice-item-heading {\n    display: none;\n  }\n  .invoice-edit-item {\n    grid-template-columns: 1fr 64px;\n    gap: 8px;\n  }\n  .invoice-edit-item .item-picker {\n    grid-column: 1/-1;\n  }\n  .invoice-edit-item .item-description {\n    grid-column: 1/-1;\n  }\n  .invoice-edit-item > input:not(.item-picker):not(.item-description),\n  .invoice-edit-item > select:not(.item-picker) {\n    width: 100%;\n  }\n  .invoice-edit-item strong {\n    grid-column: 1;\n  }\n  .invoice-edit-item > button {\n    grid-column: 2;\n    grid-row: 3;\n  }\n  .invoice-edit-item .discount-type {\n    grid-column: 1;\n  }\n  .invoice-edit-item .discount-value {\n    grid-column: 2;\n  }\n  .invoice-item-actions {\n    flex-wrap: wrap;\n  }\n  .invoice-item-actions > span {\n    width: 100%;\n    margin-left: 0;\n  }\n  .invoice-attachment-box {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n  .invoice-upload-button {\n    width: 100%;\n    margin-left: 0;\n  }\n  .invoice-editor-column,\n  .invoice-editor-aside {\n    gap: 12px;\n  }\n}\n\n.invoice-editor-intro {\n  max-width: 776px;\n  margin: -8px 0 24px;\n  color: #142624;\n  font-size: 12px;\n  line-height: 18px;\n}\n.invoice-editor-intro span {\n  color: #506360;\n}\n.invoice-source-banner {\n  display: flex;\n  max-width: 1104px;\n  box-sizing: border-box;\n  align-items: flex-start;\n  gap: 10px;\n  margin: -8px 0 24px;\n  padding: 12px 16px;\n  border: 1px solid #dce3e2;\n  border-radius: 10px;\n  background: #f0f8f7;\n  color: #0f766e;\n}\n.invoice-source-banner div {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.invoice-source-banner strong {\n  font-size: 12px;\n}\n.invoice-source-banner span {\n  color: #506360;\n  font-size: 11px;\n}\n.invoice-text-action {\n  margin-top: 14px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0f766e;\n  font: 500 11px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-pricing-basis {\n  margin-top: 12px;\n  color: #506360;\n  font-size: 11px;\n}\n.invoice-pricing-basis span {\n  margin-left: 4px;\n  color: #0f766e;\n}\n.invoice-draft-footnote {\n  margin: 0;\n  color: #506360;\n  font-size: 11px;\n  line-height: 17px;\n}\n@media (max-width: 700px) {\n  .invoice-editor-intro {\n    margin-top: 0;\n  }\n  .invoice-source-banner {\n    margin-top: 0;\n  }\n  .invoice-draft-footnote {\n    padding: 0 4px;\n  }\n}\n\n.invoice-import-card {\n  display: flex;\n  max-width: 1104px;\n  box-sizing: border-box;\n  align-items: flex-start;\n  gap: 14px;\n  margin: -8px 0 24px;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  background: var(--surface-primary, #fff);\n  box-shadow: var(--elevation-sm, 0 1px 2px rgba(14, 26, 32, 0.06));\n}\n.invoice-import-card__icon {\n  display: grid;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  place-items: center;\n  border-radius: var(--radius-md, 10px);\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-import-card__icon svg {\n  width: 19px;\n  height: 19px;\n}\n.invoice-import-card__content {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 4px;\n}\n.invoice-import-card__content > strong {\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 600;\n}\n.invoice-import-card__content > span {\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  line-height: 17px;\n}\n.invoice-import-card__actions {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n}\n.invoice-import-card__actions button {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 13px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--interactive-default, #0f766e);\n  font: 500 12px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-import-card__actions button:hover:not(:disabled) {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft, #f0f8f7);\n}\n.invoice-import-card__actions button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.invoice-import-card__actions .invoice-import-card__camera {\n  display: none;\n}\n.invoice-import-card > input {\n  display: none;\n}\n.invoice-import-card__result {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 7px;\n  padding-top: 9px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  line-height: 17px;\n}\n.invoice-import-card__result b {\n  overflow: hidden;\n  color: var(--text-primary, #142624);\n  font-weight: 500;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.invoice-import-card__result ul {\n  margin: 3px 0 0;\n  padding-left: 18px;\n  color: var(--warning-text, #8a5d00);\n}\n.invoice-import-card__result li + li {\n  margin-top: 3px;\n}\n.invoice-import-card__result small {\n  color: var(--text-tertiary, #71807d);\n  font-family: var(--font-family-mono, monospace);\n  font-size: 10px;\n}\n.invoice-import-card--success {\n  border-color: var(--success-border, #a7dfbd);\n}\n.invoice-import-card--error {\n  border-color: var(--danger-border, #f0b7b1);\n}\n.invoice-import-card--error .invoice-import-card__result > span {\n  color: var(--danger-text, #a52f25);\n}\n.invoice-import-card--loading .invoice-import-card__icon svg {\n  animation: invoice-import-pulse 1.2s ease-in-out infinite;\n}\n@keyframes invoice-import-pulse {\n  0%,\n  100% {\n    opacity: 0.35;\n    transform: translateY(2px);\n  }\n  50% {\n    opacity: 1;\n    transform: translateY(-2px);\n  }\n}\n.invoice-flow-shell.dark .invoice-import-card {\n  border-color: var(--border-subtle, #343a3a);\n  background: var(--surface-primary, #191b1f);\n}\n.invoice-flow-shell.dark .invoice-import-card__icon {\n  background: var(--interactive-soft, #22252a);\n  color: var(--interactive-default, #43a79c);\n}\n.invoice-flow-shell.dark .invoice-import-card__actions button {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-secondary, #22252a);\n  color: var(--interactive-default, #43a79c);\n}\n.invoice-flow-shell.dark .invoice-import-card__result {\n  border-color: var(--border-subtle, #343a3a);\n}\n@media (max-width: 1023px) {\n  .invoice-import-card {\n    flex-wrap: wrap;\n  }\n  .invoice-import-card__actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n  .invoice-import-card__actions .invoice-import-card__camera {\n    display: inline-flex;\n  }\n}\n@media (max-width: 700px) {\n  .invoice-import-card {\n    display: grid;\n    grid-template-columns: 40px minmax(0, 1fr);\n    margin-top: 0;\n    padding: 14px;\n  }\n  .invoice-import-card__actions {\n    display: grid;\n    grid-column: 1/-1;\n    grid-template-columns: 1fr 1fr;\n    width: 100%;\n  }\n  .invoice-import-card__actions button {\n    width: 100%;\n  }\n}\n\n.invoice-detail-page {\n  padding: 32px;\n}\n.invoice-detail-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px 24px;\n  margin: 8px 0 24px;\n}\n.invoice-detail-header h1 {\n  margin: 0;\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 600;\n}\n.invoice-detail-header p,\n.invoice-detail-header small {\n  margin: 4px 0 0;\n  color: #506360;\n  font-size: 12px;\n}\n.invoice-detail-header p span {\n  margin-right: 8px;\n  font-family: var(--font-family-mono, monospace);\n  color: #142624;\n}\n.invoice-detail-header > small {\n  grid-column: 1/-1;\n}\n.invoice-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: #edf1f0;\n  color: #506360;\n  font-size: 10px;\n  font-weight: 500;\n}\n.status-paid {\n  background: #e7f7ed;\n  color: #247a48;\n}\n.status-overdue {\n  background: #fff0ed;\n  color: #c23a2b;\n}\n.status-partial-paid,\n.status-partially-paid {\n  background: #fff7df;\n  color: #956800;\n}\n.invoice-detail-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 24px;\n  align-items: start;\n}\n.invoice-content-card > hr,\n.invoice-settings-card hr {\n  margin: 24px 0;\n  border: 0;\n  border-top: 1px solid #dce3e2;\n}\n.invoice-detail-pairs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-top: 22px;\n}\n.invoice-detail-pairs div,\n.invoice-settings-card {\n  display: flex;\n  flex-direction: column;\n}\n.invoice-detail-pairs span,\n.invoice-settings-card > span,\n.invoice-content-summary span {\n  color: #506360;\n  font-size: 11px;\n}\n.invoice-detail-pairs strong,\n.invoice-settings-card > strong {\n  margin-top: 7px;\n  font-size: 12px;\n  font-weight: 500;\n}\n.invoice-detail-items .head,\n.invoice-detail-items .row {\n  display: grid;\n  grid-template-columns: minmax(180px, 1fr) 48px 112px 64px 96px 112px;\n  gap: 12px;\n  align-items: center;\n}\n.invoice-detail-items .head {\n  min-height: 44px;\n  padding: 0 12px;\n  border-radius: 6px;\n  background: #f4f7f7;\n  color: #506360;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15.6px;\n  letter-spacing: 0.12px;\n}\n.invoice-detail-items .head span:not(:first-child) {\n  text-align: right;\n}\n.invoice-detail-items .row {\n  min-height: 56px;\n  padding: 12px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.invoice-detail-items .row > strong:first-child {\n  font-weight: 400;\n}\n.invoice-detail-items .row > span:nth-child(3),\n.invoice-detail-items .row > strong:last-child {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20.8px;\n}\n.invoice-detail-items .row span:not(:first-child),\n.invoice-detail-items .row strong:last-child {\n  text-align: right;\n}\n.invoice-content-summary {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  margin-top: 24px;\n}\n.invoice-content-summary > div:first-child p {\n  margin: 6px 0 18px;\n  font-size: 11px;\n  line-height: 17px;\n}\n.invoice-content-summary > div:last-child p {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  margin: 0 0 16px;\n  font-size: 11px;\n}\n.invoice-content-summary > div:last-child strong {\n  font-family: var(--font-family-mono, monospace);\n}\n.invoice-content-summary hr {\n  border: 0;\n  border-top: 1px solid #dce3e2;\n}\n.invoice-attachments-line {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3, 12px);\n  justify-content: space-between;\n  font-size: 11px;\n}\n.invoice-attachment-summary {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1, 4px);\n}\n.invoice-attachment-preview-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n.invoice-attachments-line span {\n  color: #506360;\n}\n.invoice-detail-aside {\n  display: flex;\n  position: sticky;\n  top: 88px;\n  flex-direction: column;\n  gap: 24px;\n}\n.invoice-settings-card > h2 {\n  margin-bottom: 20px;\n}\n.invoice-settings-card > span:not(:first-child) {\n  margin-top: 18px;\n}\n.invoice-settings-card h3 {\n  margin: 0 0 10px;\n  font-size: 12px;\n}\n.invoice-settings-card p {\n  margin: 0;\n  color: #506360;\n  font-size: 11px;\n  line-height: 17px;\n  overflow-wrap: anywhere;\n}\n.invoice-history-card {\n  margin-top: 24px;\n}\n.invoice-history-card h2 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.invoice-private-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 18px 0;\n  padding: 14px 16px;\n  border-radius: 8px;\n  background: #f4f7f7;\n}\n.invoice-private-note div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.invoice-private-note strong {\n  font-size: 11px;\n}\n.invoice-private-note span {\n  color: #506360;\n  font-size: 10px;\n}\n.invoice-history-content {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 24px;\n}\n.invoice-history-content > div {\n  padding: 16px;\n  border: 1px solid #dce3e2;\n  border-radius: 8px;\n  font-size: 11px;\n}\n.invoice-history-content > div small {\n  float: right;\n  color: #506360;\n}\n.invoice-history-content > div p {\n  margin: 8px 0;\n}\n.invoice-history-content label textarea {\n  margin-top: 8px;\n}\n.invoice-history-content label small {\n  color: #506360;\n  font-size: 10px;\n}\n.invoice-history-content label button {\n  align-self: flex-end;\n  height: 34px;\n  margin-top: 10px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 8px;\n  background: #0f766e;\n  color: #fff;\n}\n.invoice-history-content label button:disabled {\n  opacity: 0.35;\n}\n@media (max-width: 1023px) {\n  .invoice-detail-page {\n    padding: 24px;\n  }\n  .invoice-detail-grid {\n    grid-template-columns: minmax(0, 1fr) 280px;\n  }\n}\n@media (max-width: 700px) {\n  .invoice-detail-page {\n    padding: 16px;\n  }\n  .invoice-detail-header {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 16px;\n  }\n  .invoice-detail-header h1 {\n    font-size: 24px;\n    line-height: 30px;\n  }\n  .invoice-detail-grid {\n    display: flex;\n    flex-direction: column;\n  }\n  .invoice-detail-aside {\n    position: static;\n    width: 100%;\n    order: -1;\n  }\n  .invoice-content-card {\n    width: 100%;\n    overflow: hidden;\n  }\n  .invoice-detail-items .head {\n    display: none;\n  }\n  .invoice-detail-items .row {\n    grid-template-columns: 1fr 1fr;\n    padding: 14px 0;\n  }\n  .invoice-detail-items .row strong:first-child {\n    grid-column: 1/-1;\n  }\n  .invoice-detail-items .row span,\n  .invoice-detail-items .row strong:last-child {\n    text-align: left !important;\n  }\n  .invoice-content-summary,\n  .invoice-history-content,\n  .invoice-detail-pairs {\n    grid-template-columns: 1fr;\n  }\n  .invoice-history-content {\n    gap: 16px;\n  }\n  .invoice-editor-actions {\n    width: 100%;\n  }\n}\n\n/* Final Figma token and responsive alignment pass. */\n.invoice-editor-page,\n.invoice-detail-page {\n  width: 100%;\n  max-width: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 32px;\n}\n.invoice-flow-back {\n  height: 40px;\n  font-size: 13px;\n  line-height: 18px;\n}\n.invoice-editor-header,\n.invoice-detail-header {\n  margin: 8px 0 20px;\n}\n.invoice-editor-header h1,\n.invoice-detail-header h1 {\n  font-size: 32px;\n  line-height: 41.6px;\n  letter-spacing: -0.32px;\n}\n.invoice-editor-header p,\n.invoice-editor-header small,\n.invoice-detail-header p,\n.invoice-detail-header small {\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-editor-actions svg,\n.invoice-doc-action svg,\n.invoice-item-actions svg,\n.invoice-upload-button svg,\n.invoice-delivery-card button svg,\n.invoice-flow-back svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n.invoice-editor-intro {\n  margin: -4px 0 24px;\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.invoice-source-banner {\n  max-width: none;\n  min-height: 64px;\n  margin: 0 0 24px;\n  padding: 14px 16px;\n  border-radius: 10px;\n}\n.invoice-source-banner svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n.invoice-source-banner strong {\n  font-size: 13px;\n  line-height: 18px;\n}\n.invoice-source-banner span {\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-flow-card {\n  padding: 24px;\n  border-radius: 14px;\n}\n.invoice-flow-card h2 {\n  font-size: 18px;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n}\n.invoice-flow-card > p,\n.invoice-section-title p,\n.invoice-flow-card > small {\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.invoice-flow-card label {\n  gap: 6px;\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.invoice-flow-card input,\n.invoice-flow-card select,\n.invoice-flow-card textarea {\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.invoice-flow-card textarea {\n  height: 120px;\n  padding: 12px;\n}\n.invoice-fields {\n  gap: 16px;\n  margin: 20px 0;\n}\n.invoice-notes-fields {\n  grid-template-columns: 1fr;\n}\n.invoice-text-action {\n  height: 40px;\n  margin-top: 8px;\n  font-size: 13px;\n}\n.invoice-section-title > select {\n  width: 144px;\n}\n.invoice-pricing-basis {\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-item-heading {\n  min-height: 36px;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-size: 11px;\n}\n.invoice-edit-item {\n  padding: 12px 0;\n}\n.invoice-item-actions button {\n  height: 40px;\n  border-radius: 10px;\n  font-size: 13px;\n}\n.invoice-item-actions > span {\n  font-size: 12px;\n}\n.invoice-attachment-box {\n  margin: 20px 0 12px;\n  padding: 16px;\n  border-radius: 10px;\n}\n.invoice-attachment-box strong {\n  font-size: 13px;\n  line-height: 18px;\n}\n.invoice-attachment-box p {\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-upload-button {\n  display: inline-flex !important;\n  width: max-content;\n  flex-direction: row !important;\n  align-items: center;\n  gap: 6px !important;\n  height: 40px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 12px;\n  border: 1px solid #cdd6d4;\n  border-radius: 10px;\n  color: #142624 !important;\n  font-size: 13px !important;\n  cursor: pointer;\n}\n.invoice-total-card > strong {\n  font-size: 24px;\n  line-height: 31px;\n}\n.invoice-summary-card > p,\n.invoice-delivery-card p {\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.invoice-delivery-card {\n  gap: 12px;\n}\n.invoice-delivery-card p {\n  margin: 0;\n}\n.invoice-delivery-card button {\n  height: 40px;\n  border-radius: 10px;\n  font-size: 13px;\n}\n.invoice-draft-footnote {\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-detail-pairs span,\n.invoice-settings-card > span,\n.invoice-content-summary span {\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-detail-pairs strong,\n.invoice-settings-card > strong {\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.invoice-detail-items .head {\n  font-size: 12px;\n}\n.invoice-detail-items .row {\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.invoice-content-summary > div:first-child p,\n.invoice-content-summary > div:last-child p,\n.invoice-settings-card p {\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.invoice-attachments-line {\n  font-size: 13px;\n}\n.invoice-history-content > div {\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.invoice-private-note strong {\n  font-size: 13px;\n}\n.invoice-private-note span,\n.invoice-history-content label small {\n  font-size: 12px;\n  line-height: 17px;\n}\n@media (max-width: 1023px) {\n  .invoice-editor-page,\n  .invoice-detail-page {\n    max-width: none;\n    padding: 24px;\n  }\n  .invoice-editor-grid {\n    display: flex;\n    flex-direction: column;\n  }\n  .invoice-editor-column,\n  .invoice-editor-aside {\n    display: contents;\n  }\n  .invoice-total-card {\n    order: -1;\n  }\n  .invoice-editor-grid > .invoice-editor-column > .invoice-flow-card,\n  .invoice-editor-grid > .invoice-editor-aside > * {\n    width: 100%;\n  }\n  .invoice-detail-grid {\n    grid-template-columns: minmax(0, 1fr) 280px;\n  }\n  .invoice-editor-actions button {\n    height: 40px;\n  }\n  .invoice-flow-card h2 {\n    font-size: 17px;\n    line-height: 23.8px;\n  }\n}\n@media (max-width: 700px) {\n  .invoice-editor-page,\n  .invoice-detail-page {\n    padding: 16px;\n  }\n  .invoice-editor-header,\n  .invoice-detail-header {\n    margin: 4px 0 16px;\n  }\n  .invoice-editor-header h1,\n  .invoice-detail-header h1 {\n    font-size: 24px;\n    line-height: 31px;\n  }\n  .invoice-editor-header > small,\n  .invoice-detail-header > small {\n    order: 2;\n  }\n  .invoice-editor-actions {\n    order: 3;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n  .invoice-editor-actions button {\n    height: 44px;\n    font-size: 14px;\n  }\n  .invoice-editor-actions .primary {\n    grid-column: 1/-1;\n  }\n  .invoice-editor-actions svg,\n  .invoice-doc-action svg,\n  .invoice-delivery-card button svg {\n    width: 20px;\n    height: 20px;\n    flex-basis: 20px;\n  }\n  .invoice-flow-card {\n    padding: 16px;\n  }\n  .invoice-flow-card h2 {\n    font-size: 16px;\n    line-height: 22.4px;\n  }\n  .invoice-flow-card > p,\n  .invoice-section-title p,\n  .invoice-flow-card > small,\n  .invoice-flow-card label {\n    font-size: 13px;\n    line-height: 18.2px;\n  }\n  .invoice-flow-card input,\n  .invoice-flow-card select {\n    height: 44px;\n    font-size: 14px;\n  }\n  .invoice-flow-card textarea {\n    height: 120px;\n  }\n  .invoice-fields.two,\n  .invoice-fields.three {\n    grid-template-columns: 1fr;\n  }\n  .invoice-source-banner {\n    min-height: auto;\n    padding: 12px;\n  }\n  .invoice-item-actions button,\n  .invoice-upload-button,\n  .invoice-doc-action,\n  .invoice-delivery-card button {\n    height: 44px;\n    font-size: 14px;\n  }\n  .invoice-delivery-card {\n    gap: 12px;\n  }\n  .invoice-summary-card > p,\n  .invoice-delivery-card p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .invoice-detail-grid {\n    display: flex;\n  }\n  .invoice-detail-aside {\n    order: -1;\n  }\n  .invoice-detail-items .row {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n}\n\n/* Invoice editor controls: match Figma and style the portalled option menu. */\n.invoice-items-editor .invoice-item-actions > button {\n  color: var(--text-primary, #142624);\n}\n\n.invoice-flow-card .invoice-themed-select {\n  width: 100%;\n  min-width: 0;\n  height: 40px;\n  box-sizing: border-box;\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px/21.7px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.invoice-flow-card .invoice-themed-select .MuiSelect-select {\n  display: flex;\n  align-items: center;\n  min-height: 0;\n  box-sizing: border-box;\n  padding: 0 40px 0 12px;\n  height: 100%;\n  font: inherit;\n  color: inherit;\n}\n.invoice-flow-card .invoice-themed-select .MuiOutlinedInput-notchedOutline {\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: inherit;\n}\n.invoice-flow-card .invoice-themed-select.Mui-focused {\n  box-shadow: none;\n}\n.invoice-flow-card\n  .invoice-themed-select.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  border: 1px solid var(--interactive-default, #0f766e);\n}\n.invoice-flow-card .invoice-themed-select .MuiSelect-icon {\n  width: 20px;\n  height: 20px;\n  right: 12px;\n  top: calc(50% - 10px);\n  color: var(--text-secondary, #506360);\n  pointer-events: none;\n}\n.invoice-select-menu.MuiPaper-root {\n  margin-top: 4px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  box-shadow: 0 4px 16px rgba(14, 26, 32, 0.12);\n}\n.invoice-select-menu .MuiMenu-list {\n  padding: 4px;\n}\n.invoice-select-menu .MuiMenuItem-root {\n  min-height: 40px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font: 400 14px/21.7px var(--font-family-primary, \"Lexend\", sans-serif);\n  white-space: normal;\n}\n.invoice-select-menu .MuiMenuItem-root:hover,\n.invoice-select-menu .MuiMenuItem-root.Mui-selected,\n.invoice-select-menu .MuiMenuItem-root.Mui-selected:hover,\n.invoice-select-menu .MuiMenuItem-root.Mui-focusVisible {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-flow-shell.dark .invoice-themed-select,\n.invoice-select-menu.dark {\n  --surface-primary: #191b1f;\n  --text-primary: #f2f3f5;\n  --text-secondary: #adbab7;\n  --border-default: #343a3a;\n  --border-subtle: #343a3a;\n  --interactive-soft: #153b36;\n  --interactive-default: #83c7be;\n}\n.invoice-section-title > .invoice-themed-select {\n  flex: 0 0 144px;\n}\n.invoice-date-input {\n  display: block;\n  width: 100%;\n}\n.invoice-date-input input {\n  padding-right: 44px;\n}\n.invoice-date-input svg {\n  width: 20px;\n  height: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 12px;\n}\n.invoice-date-input input::-webkit-calendar-picker-indicator {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 44px;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n.invoice-date-input input::-webkit-inner-spin-button {\n  display: none;\n}\n.invoice-attachment-list {\n  margin-bottom: var(--space-3, 12px);\n}\n.invoice-attachment-view-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n  padding: 4px 8px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  font: 400 13px/20px var(--font-family-primary, \"Lexend\", sans-serif);\n  text-align: left;\n  overflow-wrap: anywhere;\n  cursor: pointer;\n}\n.invoice-attachment-list > .invoice-attachment-view-button {\n  display: flex;\n  width: 100%;\n}\n.invoice-attachment-view-button svg {\n  flex-shrink: 0;\n}\n.invoice-attachment-list .quotation-attachment-info {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.invoice-attachment-list .quotation-attachment-info svg,\n.invoice-attachment-list .quotation-attachment-remove-btn {\n  flex-shrink: 0;\n}\n.invoice-upload-button {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.invoice-flow-shell.dark .invoice-upload-button {\n  background: #191b1f;\n  border-color: #343a3a;\n  color: #f2f3f5 !important;\n}\n@media (max-width: 700px) {\n  .invoice-flow-card .invoice-themed-select {\n    height: 44px;\n  }\n}\n\n/* The shared ThemedSelect keeps invoice-specific sizing below. */\n.invoice-flow-shell .rcti-supplier-select.is-open,\n.invoice-flow-shell .invoice-customer-select.is-open {\n  z-index: 1;\n}\n.invoice-flow-shell .invoice-customer-select .quotation-figma-dropdown-menu,\n.invoice-flow-shell .rcti-supplier-select .quotation-figma-dropdown-menu,\n.invoice-flow-shell .invoice-contact-search .quotation-autocomplete-dropdown {\n  top: calc(100% + 4px);\n  max-height: min(260px, 40vh);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  box-sizing: border-box;\n}\n.invoice-contact-search .quotation-input-box {\n  box-sizing: border-box;\n}\n.invoice-flow-shell .invoice-customer-search .quotation-input-box:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.invoice-flow-shell .invoice-contact-search .quotation-input-box input {\n  min-width: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n}\n.invoice-contact-search .quotation-autocomplete-item {\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: var(--font-family-primary);\n  overflow-wrap: anywhere;\n}\n.invoice-contact-search .quotation-autocomplete-item:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.invoice-contact-search .quotation-autocomplete-item span {\n  color: var(--text-secondary, #506360);\n}\n.invoice-contact-search .quotation-customer-option {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n.invoice-contact-search .quotation-customer-option-select {\n  color: inherit;\n  font: inherit;\n}\n.invoice-customer-select .quotation-autocomplete-item > span {\n  display: none;\n}\n.invoice-edit-item .quotation-figma-dropdown.discount-type {\n  grid-column: 1;\n  width: 148px;\n}\n.invoice-edit-item\n  .quotation-figma-dropdown.discount-type\n  .quotation-figma-dropdown-menu {\n  min-width: 148px;\n}\n.invoice-edit-item\n  .quotation-figma-dropdown[aria-label=\"Item GST\"]\n  .quotation-figma-dropdown-menu {\n  min-width: 92px;\n}\n.invoice-section-title > .quotation-figma-dropdown {\n  flex: 0 0 164px;\n  width: 164px;\n}\n@media (min-width: 1024px) {\n  .invoice-edit-item .quotation-figma-dropdown[aria-label=\"Item GST\"] {\n    width: 92px;\n  }\n  .invoice-item-heading,\n  .invoice-edit-item {\n    grid-template-columns: minmax(220px, 1fr) 56px 104px 92px 112px 28px;\n  }\n}\n@media (min-width: 701px) and (max-width: 1023px) {\n  .invoice-edit-item .quotation-figma-dropdown[aria-label=\"Item GST\"] {\n    width: 92px;\n  }\n  .invoice-item-heading,\n  .invoice-edit-item {\n    grid-template-columns: minmax(180px, 1fr) 48px 88px 92px 96px 28px;\n  }\n}\n@media (max-width: 700px) {\n  .invoice-section-title > .quotation-figma-dropdown {\n    flex-basis: 128px;\n    width: 128px;\n  }\n}\n@media (max-width: 700px) {\n  .quotation-figma-dropdown-trigger {\n    height: 44px;\n  }\n  .invoice-edit-item .quotation-figma-dropdown.discount-type {\n    width: 100%;\n  }\n}\n\n/* Catalogue picker reuses the New Quote search and result card styles. */\n.invoice-items-editor\n  .quotation-item-row-card:has(.quotation-item-search-dropdown) {\n  position: relative;\n  z-index: 120;\n}\n.invoice-flow-shell .invoice-items-editor .quotation-discount-val-wrap input {\n  height: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n.invoice-flow-shell.dark .invoice-items-editor .quotation-pricing-basis-label,\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-item-discount-row\n  label,\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-total-item-discounts-badge\n  strong,\n.invoice-flow-shell.dark .invoice-items-editor .quotation-col-line-total {\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-flow-shell.dark .invoice-items-editor .quotation-items-table-header,\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-total-item-discounts-badge {\n  background: var(--surface-secondary, #22252a) !important;\n  color: var(--text-secondary, #b3b8c2) !important;\n}\n.invoice-flow-shell.dark .invoice-items-editor .quotation-col-line-total,\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-discount-val-wrap.disabled\n  .quotation-input-box {\n  background: var(--surface-secondary, #22252a);\n}\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-discount-val-wrap\n  .quotation-input-box {\n  border-color: var(--border-default, #3a3f47);\n}\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-discount-val-wrap:not(.disabled)\n  .quotation-input-box {\n  background: var(--surface-primary, #191b1f);\n}\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-discount-val-wrap.disabled\n  label {\n  color: var(--text-disabled, #8a9896);\n}\n.invoice-flow-shell.dark .invoice-items-editor .quotation-item-row-card {\n  border-bottom-color: var(--border-subtle, #2c3036);\n}\n.invoice-flow-shell.dark .invoice-items-editor .quotation-item-remove-btn,\n.invoice-flow-shell.dark\n  .invoice-items-editor\n  .quotation-item-details-row\n  > [data-label]::before {\n  color: var(--text-secondary, #b3b8c2);\n}\n.invoice-items-editor .quotation-item-no-results strong {\n  align-self: flex-start;\n  text-align: left;\n  font-family: var(--font-family-primary);\n}\n.invoice-flow-shell.dark .quotation-item-search-footer-btn {\n  color: var(--interactive-default, #43a79c);\n}\n.invoice-flow-shell.dark .quotation-item-search-footer-btn:hover {\n  background: var(--interactive-soft, #153b36);\n}\n.invoice-flow-shell.dark .quotation-item-search-divider {\n  background: var(--border-subtle, #343a3a);\n}\n.invoice-flow-shell .quotation-item-search-row {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n}\n.invoice-flow-shell .quotation-item-search-box {\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.invoice-flow-shell .quotation-item-search-box:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.invoice-flow-shell .quotation-item-search-box > svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  color: var(--text-secondary, #506360);\n}\n.invoice-flow-shell .quotation-item-search-box input {\n  flex: 1;\n  min-width: 0;\n  width: auto;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font: 400 14px/21.7px var(--font-family-primary, \"Lexend\", sans-serif);\n  box-shadow: none;\n}\n.invoice-flow-shell .quotation-item-search-box input:focus {\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n}\n.invoice-flow-shell .quotation-item-search-box input::placeholder {\n  color: var(--text-secondary, #6b7b78);\n}\n.invoice-flow-shell .quotation-item-search-dropdown {\n  position: absolute;\n  z-index: 1100;\n  top: calc(100% + 4px);\n  right: 0;\n  left: 0;\n  overflow: hidden;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-elevated, #fff);\n  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0 1px 2px rgba(14, 26, 32, 0.04);\n}\n.invoice-flow-shell .quotation-item-search-results-list {\n  display: flex;\n  max-height: 250px;\n  flex-direction: column;\n  gap: 2px;\n  overflow-y: auto;\n  padding: 4px;\n}\n.invoice-flow-shell .quotation-item-result-card {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n.invoice-flow-shell .quotation-item-result-card:hover,\n.invoice-flow-shell .quotation-item-result-card.selected {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.invoice-flow-shell .quotation-item-result-top {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.invoice-flow-shell .quotation-item-result-name-group,\n.invoice-flow-shell .quotation-item-result-price-group {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n}\n.invoice-flow-shell .quotation-item-result-name-group .quotation-match-icon {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 14px;\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-flow-shell .quotation-item-result-name {\n  overflow: hidden;\n  color: var(--interactive-default, #0f766e);\n  font: 400 14px/21.7px var(--font-family-primary, \"Lexend\", sans-serif);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.invoice-flow-shell .quotation-item-result-price-group {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n.invoice-flow-shell .quotation-item-result-gst-label {\n  color: var(--text-tertiary, #6b7b78);\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n}\n.invoice-flow-shell .quotation-item-result-price {\n  color: var(--interactive-default, #0f766e);\n  font: 500 16px/20.8px var(--font-family-mono, monospace);\n}\n.invoice-flow-shell .quotation-item-result-sub {\n  margin: 0;\n  color: var(--interactive-default, #0f766e);\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n  opacity: 0.75;\n}\n.invoice-flow-shell .quotation-item-no-results {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18px;\n}\n.invoice-flow-shell.dark .quotation-item-search-box {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-primary, #191b1f);\n}\n.invoice-flow-shell.dark .quotation-item-search-box:focus-within {\n  border-color: var(--interactive-default, #43a79c);\n  box-shadow: none;\n}\n.invoice-flow-shell.dark .quotation-item-search-box > svg {\n  color: var(--text-secondary, #b3b8c2);\n}\n.invoice-flow-shell.dark .quotation-item-search-box input {\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-flow-shell.dark .quotation-item-search-dropdown {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-elevated, #25282e);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n.invoice-flow-shell.dark .quotation-item-result-card:hover,\n.invoice-flow-shell.dark .quotation-item-result-card.selected {\n  background: rgba(67, 167, 156, 0.15);\n}\n.invoice-flow-shell.dark\n  .quotation-item-result-name-group\n  .quotation-match-icon,\n.invoice-flow-shell.dark .quotation-item-result-name,\n.invoice-flow-shell.dark .quotation-item-result-price,\n.invoice-flow-shell.dark .quotation-item-result-sub {\n  color: var(--interactive-default, #43a79c);\n}\n.invoice-flow-shell.dark .quotation-item-result-gst-label {\n  color: var(--text-tertiary, #959fa8);\n}\n.invoice-flow-shell.dark .quotation-item-no-results {\n  color: var(--text-secondary, #b3b8c2);\n}\n.invoice-editor-shell .quotation-new-item-option {\n  gap: 3px;\n  padding: 10px 12px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n}\n.invoice-editor-shell .quotation-new-item-option .quotation-item-result-name {\n  color: inherit;\n  font-weight: 600;\n}\n.invoice-editor-shell\n  .quotation-new-item-option\n  .quotation-item-result-name-group\n  .quotation-match-icon {\n  color: inherit;\n}\n.invoice-editor-shell.dark .quotation-new-item-option {\n  background: transparent;\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-editor-shell.dark\n  .quotation-new-item-option\n  .quotation-item-result-sub {\n  opacity: 0.85;\n}\n@media (max-width: 700px) {\n  .invoice-flow-shell .quotation-item-search-box {\n    height: 44px;\n  }\n}\n/* Invoice detail states and their shared history/payment panels. */\n.invoice-status.status-draft {\n  background: #f1f3f2;\n  color: #52615f;\n}\n.invoice-status.status-awaiting-payment {\n  background: #fff5df;\n  color: #8a5d00;\n}\n.invoice-status.status-partially-paid {\n  background: #fff5df;\n  color: #8a5d00;\n}\n.invoice-status.status-overdue {\n  background: #fff0ed;\n  color: #b9382d;\n}\n.invoice-status.status-paid {\n  background: #e7f7ed;\n  color: #247a48;\n}\n.invoice-status.status-voided {\n  background: #f1e9e9;\n  color: #8b3434;\n}\n.invoice-origin-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 16px;\n  padding: 10px 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--interactive-default, #0f766e);\n  font: 500 12px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-origin-link svg {\n  width: 16px;\n  height: 16px;\n}\n.invoice-source-banner.draft {\n  border-color: #dce3e2;\n  background: #f7f9f8;\n}\n.invoice-financial-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid #dce3e2;\n}\n.invoice-financial-breakdown span {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  color: #506360;\n  font-size: 11px;\n}\n.invoice-financial-breakdown b {\n  color: #142624;\n  font-family: var(--font-family-mono, monospace);\n  font-weight: 500;\n}\n.invoice-inline-action {\n  display: inline-flex;\n  min-height: 36px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 11px;\n  border: 1px solid #cdd6d4;\n  border-radius: 8px;\n  background: #fff;\n  color: #142624;\n  font: 500 12px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-inline-action:hover {\n  border-color: #0f766e;\n  color: #0f766e;\n}\n.invoice-inline-action svg {\n  width: 15px;\n  height: 15px;\n}\n.invoice-settings-card .invoice-inline-action {\n  align-self: flex-start;\n  margin-top: 12px;\n}\n.invoice-state-panel {\n  margin-top: 20px;\n}\n.invoice-state-panel-heading,\n.invoice-history-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n.invoice-state-panel-heading p,\n.invoice-history-heading p {\n  margin: 4px 0 18px;\n  color: #506360;\n  font-size: 12px;\n  line-height: 18px;\n}\n.invoice-financial-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 14px;\n}\n.invoice-financial-grid > div {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px;\n  border: 1px solid #dce3e2;\n  border-radius: 8px;\n}\n.invoice-financial-grid span,\n.invoice-payment-list small {\n  color: #506360;\n  font-size: 11px;\n}\n.invoice-financial-grid strong,\n.invoice-payment-list strong {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 15px;\n  font-weight: 500;\n}\n.invoice-payment-list {\n  display: flex;\n  flex-direction: column;\n  margin-top: 14px;\n}\n.invoice-payment-list article {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 4px 12px;\n  padding: 12px 0;\n  border-top: 1px solid #eef1f0;\n}\n.invoice-payment-list small {\n  grid-column: 1/-1;\n}\n.invoice-payment-empty {\n  margin-top: 14px;\n  padding: 18px;\n  border: 1px dashed #cdd6d4;\n  border-radius: 8px;\n  color: #506360;\n  font-size: 12px;\n  text-align: center;\n}\n.invoice-secondary-actions > div:last-child {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.invoice-history-heading {\n  align-items: center;\n}\n.invoice-history-heading h2 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.invoice-history-heading .quotation-history-link-btn {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 4px 0;\n  border: 0;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  cursor: pointer;\n  font: 500 13px var(--font-family-primary);\n}\n.invoice-history-heading .quotation-history-link-btn:hover {\n  text-decoration: underline;\n}\n.invoice-history-heading .quotation-history-link-btn:focus-visible {\n  border-radius: 4px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 3px;\n}\n.invoice-history-content {\n  align-items: start;\n}\n.invoice-activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0 !important;\n  border: 0 !important;\n}\n.invoice-activity-list article {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 6px 16px;\n  padding: 12px 14px;\n  border: 1px solid #dce3e2;\n  border-bottom: 0;\n  font-size: 12px;\n}\n.invoice-activity-list article.note {\n  background: #f4f7f7;\n}\n.invoice-activity-list article:first-child {\n  border-radius: 8px 8px 0 0;\n}\n.invoice-activity-list article:last-child {\n  border-bottom: 1px solid #dce3e2;\n  border-radius: 0 0 8px 8px;\n}\n.invoice-activity-list article time {\n  grid-column: 2;\n  grid-row: 1;\n  white-space: nowrap;\n  color: #506360;\n}\n.invoice-activity-list article > span,\n.invoice-activity-list article > p {\n  grid-column: 1 / -1;\n}\n.invoice-activity-list article > span {\n  color: #142624;\n  font-weight: 500;\n}\n.invoice-activity-list article p {\n  margin: 0;\n  color: #506360;\n  line-height: 1.5;\n}\n.invoice-note-composer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n}\n.invoice-note-composer label {\n  width: 100%;\n}\n.invoice-note-composer textarea {\n  height: 92px !important;\n}\n.invoice-note-composer button {\n  height: 36px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 8px;\n  background: #0f766e;\n  color: #fff;\n  font: 500 12px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-note-composer button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.invoice-flow-shell.dark .invoice-origin-link,\n.invoice-flow-shell.dark .invoice-inline-action {\n  border-color: #3a3f47;\n  background: #191b1f;\n  color: #f2f3f5;\n}\n.invoice-flow-shell.dark .invoice-inline-action:hover {\n  border-color: #43a79c;\n  color: #43a79c;\n}\n.invoice-flow-shell.dark .invoice-financial-breakdown,\n.invoice-flow-shell.dark .invoice-payment-list article {\n  border-color: #3a3f47;\n}\n.invoice-flow-shell.dark .invoice-financial-breakdown span,\n.invoice-flow-shell.dark .invoice-payment-list small,\n.invoice-flow-shell.dark .invoice-financial-grid span,\n.invoice-flow-shell.dark .invoice-state-panel-heading p,\n.invoice-flow-shell.dark .invoice-history-heading p,\n.invoice-flow-shell.dark .invoice-payment-empty {\n  color: #b3b8c2;\n}\n.invoice-flow-shell.dark .invoice-financial-breakdown b,\n.invoice-flow-shell.dark .invoice-financial-grid strong,\n.invoice-flow-shell.dark .invoice-payment-list strong {\n  color: #f2f3f5;\n}\n.invoice-flow-shell.dark .invoice-financial-grid > div,\n.invoice-flow-shell.dark .invoice-payment-empty,\n.invoice-flow-shell.dark .invoice-activity-list article {\n  border-color: #3a3f47;\n  background: #191b1f;\n  color: #f2f3f5;\n}\n.invoice-flow-shell.dark .invoice-activity-list article p,\n.invoice-flow-shell.dark .invoice-activity-list article time {\n  color: #b3b8c2;\n}\n.invoice-flow-shell.dark .invoice-activity-list article > span {\n  color: #f2f3f5;\n}\n@media (max-width: 700px) {\n  .invoice-state-panel-heading,\n  .invoice-history-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .invoice-financial-grid {\n    grid-template-columns: 1fr;\n  }\n  .invoice-secondary-actions > div:last-child {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n  .invoice-history-content {\n    display: flex;\n    flex-direction: column;\n  }\n  .invoice-note-composer {\n    width: 100%;\n  }\n}\n\n/* Invoice detail tablet and mobile layouts from Figma 1209:51343 / 1209:55575. */\n.invoice-detail-orgbar {\n  display: none;\n  --dn-bg: var(--bg-primary, #f4f7f7);\n  --dn-surface: var(--surface-primary, #fff);\n  --dn-soft: var(--surface-secondary, #f4f7f7);\n  --dn-text: var(--text-primary, #142624);\n  --dn-muted: var(--text-secondary, #506360);\n  --dn-border: var(--border-subtle, #dce3e2);\n  --dn-border-strong: var(--border-default, #cdd6d4);\n  --dn-brand: var(--interactive-default, #0f766e);\n  --dn-brand-soft: var(--interactive-soft, #f0f8f7);\n}\n.invoice-flow-shell.dark .invoice-detail-orgbar {\n  --dn-bg: #101113;\n  --dn-surface: #191b1f;\n  --dn-soft: #22252a;\n  --dn-text: #f2f3f5;\n  --dn-muted: #b3b8c2;\n  --dn-border: #2c3036;\n  --dn-border-strong: #3a3f47;\n  --dn-brand: #43a79c;\n  --dn-brand-soft: #22252a;\n}\n.desktop-origin-link {\n  display: none;\n}\n@media (min-width: 1024px) {\n  .invoice-detail-page > .mobile-origin-link {\n    display: none;\n  }\n  .invoice-source-banner .desktop-origin-link {\n    display: inline-flex;\n    min-height: 40px;\n    flex: 0 0 auto;\n    align-self: center;\n    margin: 0 0 0 auto;\n    padding: 0 12px;\n    white-space: nowrap;\n  }\n  .invoice-source-banner > div {\n    min-width: 0;\n    flex: 1;\n  }\n}\n@media (max-width: 1023px) {\n  .invoice-detail-page {\n    padding: 24px;\n  }\n  .invoice-detail-orgbar {\n    display: block;\n    margin: 0 0 12px;\n  }\n  .invoice-detail-orgbar .debit-tablet-nav {\n    display: flex;\n    height: 62px;\n    min-height: 62px;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0;\n  }\n  .invoice-detail-orgbar .debit-organisation-switcher {\n    width: 220px;\n    height: 62px;\n  }\n  .invoice-flow-back {\n    height: 44px;\n    margin-bottom: 8px;\n  }\n  .invoice-detail-header {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin: 4px 0 16px;\n  }\n  .invoice-detail-header h1 {\n    font-size: 28px;\n    line-height: 36px;\n  }\n  .invoice-detail-header > small {\n    order: 2;\n    font-size: 13px;\n    line-height: 19px;\n  }\n  .invoice-detail-header .invoice-editor-actions {\n    order: 3;\n    display: grid;\n    width: 100%;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n  }\n  .invoice-detail-header .invoice-editor-actions button {\n    min-width: 0;\n    height: 44px;\n    padding: 0 8px;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n  .invoice-detail-header .invoice-editor-actions button.primary {\n    grid-column: 1/-1;\n  }\n  .invoice-detail-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  .invoice-detail-aside {\n    display: contents;\n    position: static;\n    width: auto;\n  }\n  .invoice-detail-aside > .invoice-total-card {\n    order: -1;\n  }\n  .invoice-detail-aside > .invoice-settings-card {\n    order: 1;\n  }\n  .invoice-detail-grid > .invoice-content-card {\n    order: 2;\n    width: 100%;\n    min-width: 0;\n  }\n  .invoice-detail-aside > .invoice-draft-footnote {\n    order: 3;\n  }\n  .invoice-detail-grid > .invoice-flow-card,\n  .invoice-detail-aside > .invoice-flow-card {\n    width: 100%;\n    min-width: 0;\n  }\n  .invoice-detail-items .head {\n    display: none;\n  }\n  .invoice-detail-items .row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 10px 16px;\n    align-items: center;\n    min-height: 0;\n    margin-top: 12px;\n    padding: 16px;\n    border: 1px solid #dce3e2;\n    border-radius: 10px;\n    background: #fff;\n    font-size: 13px;\n    line-height: 20px;\n  }\n  .invoice-detail-items .row strong:first-child {\n    grid-column: 1/-1;\n    overflow-wrap: anywhere;\n  }\n  .invoice-detail-items .row span,\n  .invoice-detail-items .row strong[data-label] {\n    display: flex;\n    grid-column: 1/-1;\n    justify-content: space-between;\n    gap: 16px;\n    text-align: right !important;\n  }\n  .invoice-detail-items .row [data-label]::before {\n    content: attr(data-label);\n    color: #506360;\n    font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n    font-size: 12px;\n    font-weight: 400;\n    text-align: left;\n  }\n  .invoice-detail-items .row strong[data-label] {\n    font-family: var(--font-family-mono, monospace);\n    font-weight: 500;\n  }\n  .invoice-content-summary {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .invoice-detail-aside > .invoice-settings-card {\n    margin-top: 0;\n  }\n  .invoice-detail-page > .invoice-history-card-live {\n    margin-top: 16px;\n  }\n}\n@media (max-width: 700px) {\n  .invoice-detail-page {\n    padding: 16px;\n  }\n  .invoice-detail-orgbar {\n    margin: 0 0 8px;\n  }\n  .invoice-detail-orgbar .debit-tablet-nav {\n    min-height: 58px;\n    height: auto;\n    justify-content: flex-start;\n    margin: 0;\n  }\n  .invoice-detail-orgbar .debit-tablet-brand {\n    display: none;\n  }\n  .invoice-detail-orgbar .debit-organisation-wrap {\n    width: 100%;\n  }\n  .invoice-detail-orgbar .debit-organisation-switcher {\n    width: 100%;\n    height: auto;\n    min-height: 58px;\n  }\n  .invoice-flow-back {\n    height: 40px;\n    margin-bottom: 8px;\n  }\n  .invoice-detail-header h1 {\n    font-size: 24px;\n    line-height: 31px;\n  }\n  .invoice-detail-header p,\n  .invoice-detail-header small {\n    font-size: 12px;\n    line-height: 18px;\n  }\n  .invoice-detail-header .invoice-editor-actions {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .invoice-detail-header .invoice-editor-actions button {\n    height: 44px;\n    font-size: 12px;\n  }\n  .invoice-detail-grid {\n    gap: 12px;\n  }\n  .invoice-detail-grid > .invoice-flow-card {\n    padding: 16px;\n    border-radius: 12px;\n  }\n  .invoice-detail-pairs {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n  .invoice-detail-items .row {\n    margin-top: 10px;\n    padding: 14px;\n    border-radius: 8px;\n    font-size: 13px;\n    line-height: 20px;\n  }\n  .invoice-content-summary > div:first-child p,\n  .invoice-content-summary > div:last-child p,\n  .invoice-settings-card p {\n    overflow-wrap: anywhere;\n  }\n  .invoice-detail-page > .invoice-state-panel,\n  .invoice-detail-page > .invoice-history-card-live {\n    margin-top: 12px;\n  }\n}\n\n/* Desktop dark surface, contrast, and state treatments from Figma 1210:54382. */\n.invoice-detail-shell.dark {\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark.invoice-flow-shell {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .invoice-flow-main {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .invoice-detail-page {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .app-topbar {\n  background: var(--surface-primary);\n}\n.invoice-detail-shell.dark .dashboard-nav.dark {\n  background: var(--surface-primary);\n}\n.invoice-detail-shell.dark .app-topbar {\n  --tb-bg: var(--surface-primary);\n  --tb-border: var(--border-subtle);\n  --tb-search-bg: var(--surface-secondary);\n  --tb-search-border: var(--border-subtle);\n  --tb-search-focus-border: var(--focus-ring);\n  --tb-text: var(--text-primary);\n  --tb-text-muted: var(--text-secondary);\n  --tb-text-tertiary: var(--text-tertiary);\n  --tb-credits-border: var(--border-default);\n  --tb-hover-bg: var(--surface-secondary);\n  --tb-avatar-border: var(--border-subtle);\n  --tb-status-ring: var(--surface-primary);\n  --tb-status-dot: var(--interactive-default);\n  --tb-menu-bg: var(--surface-primary);\n  --tb-menu-border: var(--border-subtle);\n  --tb-menu-item-hover: var(--surface-secondary);\n}\n.invoice-detail-shell.dark .dashboard-nav.dark {\n  --dash-surface: var(--surface-primary);\n  --dash-surface-2: var(--surface-secondary);\n  --dash-surface-3: var(--surface-tertiary);\n  --dash-border: var(--border-subtle);\n  --dash-border-strong: var(--border-default);\n  --dash-text: var(--text-primary);\n  --dash-muted: var(--text-secondary);\n  --dash-lock: var(--text-tertiary);\n  --dash-brand: var(--interactive-default);\n  --dash-brand-soft: var(--interactive-soft);\n  --dash-danger: var(--money-overdue);\n  --dash-bg: var(--bg-primary);\n  --text-link: var(--interactive-default);\n  background: var(--surface-primary);\n  border-color: var(--border-subtle);\n}\n.invoice-detail-shell.dark .dashboard-nav.dark {\n  background-color: #191b1f !important;\n}\n.invoice-detail-shell.dark .invoice-detail-orgbar {\n  --dn-bg: var(--bg-primary);\n  --dn-surface: var(--surface-primary);\n  --dn-soft: var(--surface-secondary);\n  --dn-text: var(--text-primary);\n  --dn-muted: var(--text-secondary);\n  --dn-border: var(--border-subtle);\n  --dn-border-strong: var(--border-default);\n  --dn-brand: var(--interactive-default);\n  --dn-brand-soft: var(--interactive-soft);\n}\n.invoice-detail-shell.dark .invoice-detail-page {\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card {\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card label,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-header p span,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-pairs strong,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card > strong,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-content-summary\n  > div:last-child\n  strong,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-attachments-line\n  strong {\n  color: var(--text-primary);\n}\n\n.invoice-detail-contact-link {\n  color: inherit;\n  font: inherit;\n  text-decoration: none;\n  text-underline-offset: 2px;\n}\n.invoice-detail-contact-link:hover {\n  text-decoration: underline !important;\n}\n.invoice-detail-contact-link:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n.invoice-detail-contact-link:hover {\n  color: #0f766e;\n  text-decoration: underline !important;\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card input,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card select,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card textarea {\n  border-color: var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-flow-card\n  input::placeholder,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-flow-card\n  textarea::placeholder {\n  color: var(--text-tertiary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-header p,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-header small,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card > p,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card p,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-draft-footnote,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-pairs span,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card > span,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-content-summary span,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-content-summary p,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-attachments-line span {\n  color: var(--text-secondary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-content-card > hr,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-settings-card hr,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-content-summary hr {\n  border-color: var(--border-subtle);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-items .head {\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-items .row {\n  border-color: var(--border-subtle);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-detail-items .row {\n  background: var(--surface-primary);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-detail-items\n  .row\n  [data-label]::before {\n  color: var(--text-secondary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-source-banner {\n  border-color: var(--border-subtle);\n  background: var(--bg-tertiary);\n  color: var(--text-link);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-source-banner.draft {\n  border-color: var(--border-subtle);\n  background: var(--bg-tertiary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-source-banner span {\n  color: var(--text-secondary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-origin-link {\n  border-color: var(--border-default);\n  background: var(--surface-secondary);\n  color: var(--text-link);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-private-note {\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-private-note span,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-history-content\n  label\n  small,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-history-content\n  > div\n  small {\n  color: var(--text-secondary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-history-content > div {\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-editor-actions button,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-doc-action,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-inline-action {\n  border-color: var(--border-default);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-editor-actions\n  button:hover,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-doc-action:hover,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-inline-action:hover {\n  border-color: var(--interactive-default);\n  color: var(--text-link);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-editor-actions\n  button.primary,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-note-composer\n  button:not(:disabled) {\n  border-color: var(--interactive-default);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-editor-actions\n  button.primary:hover,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-note-composer\n  button:not(:disabled):hover {\n  border-color: var(--interactive-hover);\n  background: var(--interactive-hover);\n  color: var(--on-interactive-primary);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-editor-actions\n  button:active,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-inline-action:active {\n  border-color: var(--interactive-pressed);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card input:focus,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-flow-card select:focus,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-flow-card\n  textarea:focus {\n  border-color: var(--focus-ring);\n  box-shadow: none;\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-draft {\n  background: var(--money-draft-soft);\n  color: var(--money-draft);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-status.status-awaiting-payment,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-status.status-partially-paid,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-status.status-partial-paid {\n  background: var(--money-pending-soft);\n  color: var(--money-pending);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-overdue {\n  background: var(--money-overdue-soft);\n  color: var(--money-overdue);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-paid {\n  background: var(--money-paid-soft);\n  color: var(--money-paid);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-status.status-voided {\n  background: var(--surface-tertiary);\n  color: var(--text-secondary);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-note-composer\n  button:disabled {\n  border: 1px solid var(--border-subtle);\n  background: var(--surface-tertiary);\n  color: var(--text-disabled);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-total-card svg,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-history-card h2 svg {\n  color: var(--interactive-default);\n}\n.invoice-detail-shell.dark .invoice-detail-page .invoice-financial-grid > div,\n.invoice-detail-shell.dark .invoice-detail-page .invoice-payment-empty {\n  border-color: var(--border-subtle);\n}\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-flow-back:focus-visible,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-editor-actions\n  button:focus-visible,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-origin-link:focus-visible,\n.invoice-detail-shell.dark\n  .invoice-detail-page\n  .invoice-inline-action:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n/* Figma Invoice Preview matching frame 905:88684 / 1179:48151 */\n.customer-invoice-preview-page {\n  width: 100%;\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 32px 0 64px;\n  box-sizing: border-box;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  color: var(--text-primary, #142624);\n}\n\n.customer-preview-back {\n  margin-bottom: 16px;\n}\n\n.customer-preview-identity-row {\n  margin-bottom: 16px;\n}\n\n.customer-preview-identity h1 {\n  margin: 0 0 8px;\n  color: var(--text-primary, #142624);\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 30px;\n  letter-spacing: -0.36px;\n}\n\n.customer-preview-status-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n\n.customer-preview-number {\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n}\n\n.customer-preview-legacy-controls {\n  display: none;\n}\n\n.customer-invoice-preview-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.customer-invoice-preview-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.invoice-preview-btn {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 13px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.invoice-preview-btn:hover {\n  border-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n\n.invoice-preview-btn.primary {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n}\n\n.invoice-preview-btn.primary:hover {\n  background: var(--interactive-hover, #0c5f59);\n}\n\n.invoice-preview-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.customer-invoice-preview-header {\n  display: none;\n}\n\n.customer-invoice-preview-feedback[aria-label=\"Invoice status summary\"] {\n  display: none;\n}\n\n.preview-meta-grid.quote-meta-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.customer-invoice-preview-header h1 {\n  margin: 0;\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 600;\n  letter-spacing: -0.48px;\n  color: var(--text-primary, #142624);\n}\n\n.customer-invoice-preview-feedback {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  box-sizing: border-box;\n}\n\n.customer-invoice-preview-feedback > svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  color: var(--text-secondary, #506360);\n}\n\n.customer-invoice-preview-feedback > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.customer-invoice-preview-feedback .feedback-primary {\n  margin: 0;\n  font-size: 13px;\n  line-height: 16.9px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.customer-invoice-preview-feedback .feedback-secondary {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n.customer-invoice-preview-feedback .dot-sep {\n  opacity: 0.7;\n}\n\n.customer-invoice-preview-card {\n  padding: 32px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  background: var(--surface-primary, #fff);\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.preview-issuer-identity {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.preview-issuer-name {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  min-height: 90px;\n}\n\n.preview-business-logo {\n  display: block;\n  width: auto;\n  height: 64px;\n  max-width: 160px;\n  flex: 0 0 auto;\n  object-fit: contain;\n  object-position: left center;\n}\n\n.preview-business-monogram {\n  display: inline-flex;\n  width: 64px;\n  height: 64px;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 64px;\n  border-radius: 999px;\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.preview-issuer-name h2 {\n  margin: 0;\n  font-size: 18px;\n  line-height: 25.2px;\n  font-weight: 500;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.preview-doc-identity {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  min-width: 200px;\n}\n\n.preview-doc-title {\n  font-size: 24px;\n  line-height: 30px;\n  font-weight: 600;\n  letter-spacing: -0.36px;\n  color: var(--text-primary, #142624);\n}\n\n.preview-doc-number {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n  color: var(--text-primary, #142624);\n}\n\n.preview-status-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.12px;\n  white-space: nowrap;\n}\n\n.preview-status-pill.status-draft {\n  background: #f4f7f7;\n  color: #506360;\n  border: 1px solid #dce3e2;\n}\n\n.preview-status-pill.status-awaiting {\n  background: #fef3c7;\n  color: #b45309;\n  border: 1px solid #fde68a;\n}\n\n.preview-status-pill.status-paid {\n  background: #dcfce7;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.preview-status-pill.status-overdue {\n  background: #fee2e2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.preview-divider {\n  margin: 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.preview-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n  gap: 20px;\n}\n\n.preview-meta-grid.quote-meta-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.preview-meta-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.preview-meta-label {\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n.preview-meta-value {\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n  word-break: break-word;\n}\n\n.preview-meta-sub {\n  font-size: 12px;\n  color: var(--text-secondary, #506360);\n  word-break: break-all;\n}\n\n.preview-items-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.preview-items-header h3 {\n  margin: 0;\n  font-size: 18px;\n  line-height: 25.2px;\n  font-weight: 500;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.preview-items-header p {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n.preview-table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.preview-items-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.preview-items-table thead tr {\n  height: 44px;\n  background: var(--surface-secondary, #f4f7f7);\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.preview-items-table th {\n  padding: 8px 12px;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.12px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.preview-items-table th.th-desc {\n  text-align: left;\n}\n\n.preview-items-table .th-qty { width: 48px; }\n.preview-items-table .th-price { width: 112px; }\n.preview-items-table .th-gst { width: 64px; }\n.preview-items-table .th-discount { width: 96px; }\n.preview-items-table .th-total { width: 140px; }\n\n.preview-items-table tbody tr {\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.preview-items-table td {\n  padding: 12px;\n  vertical-align: middle;\n  color: var(--text-primary, #142624);\n  text-align: right;\n  line-height: 21.7px;\n}\n\n.preview-items-table td.td-desc {\n  text-align: left;\n}\n\n.preview-items-table td .item-name {\n  display: block;\n  font-weight: 400;\n  color: var(--text-primary, #142624);\n}\n\n.preview-items-table td .item-sub-desc {\n  display: block;\n  margin-top: 2px;\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--text-secondary, #506360);\n}\n\n.preview-items-table td.td-empty {\n  text-align: center;\n  padding: 24px;\n  color: var(--text-secondary, #506360);\n}\n\n.font-mono {\n  font-family: var(--font-family-mono, monospace);\n  font-weight: 500;\n}\n\n.preview-bottom-section {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 400px;\n  gap: 32px;\n  align-items: flex-start;\n  margin-top: 8px;\n}\n\n.preview-notes-column {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.preview-note-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.preview-note-title {\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n  letter-spacing: 0.07px;\n}\n\n.preview-note-body {\n  margin: 0;\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n  white-space: pre-line;\n}\n\n.preview-totals-column {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  box-sizing: border-box;\n}\n\n.preview-totals-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.preview-totals-row .totals-label {\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n  letter-spacing: 0.065px;\n}\n\n.preview-totals-row .totals-value {\n  font-size: 16px;\n  line-height: 20.8px;\n  color: var(--text-primary, #142624);\n  white-space: nowrap;\n}\n\n.totals-divider {\n  margin: 4px 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.preview-totals-row.grand-total .totals-label {\n  font-size: 13px;\n  color: var(--text-secondary, #506360);\n}\n\n.preview-totals-row.grand-total .grand-amount {\n  font-size: 22px;\n  line-height: 26.4px;\n  font-weight: 700;\n  color: var(--text-primary, #142624);\n}\n\n.preview-gst-clarification {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n  letter-spacing: 0.065px;\n}\n\n.preview-card-footnote {\n  margin: 8px 0 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n  letter-spacing: 0.065px;\n}\n\n.preview-bank-details {\n  padding-top: 24px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.preview-bank-details h3 {\n  margin: 0 0 16px;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 17px;\n}\n\n.preview-bank-details dl {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0;\n}\n\n.preview-bank-details dl > div {\n  display: grid;\n  grid-template-columns: 160px minmax(0, 1fr);\n  gap: 16px;\n}\n\n.preview-bank-details dt,\n.preview-bank-details dd {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 15px;\n  line-height: 24px;\n}\n\n.preview-bank-details dd {\n  color: var(--text-primary, #142624);\n}\n\n/* Dark mode overrides for Customer Invoice Preview */\n.customer-invoice-preview-page.dark,\n.invoice-flow-shell.dark .customer-invoice-preview-page {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.customer-invoice-preview-page.dark .customer-invoice-preview-header h1,\n.invoice-flow-shell.dark .customer-invoice-preview-header h1,\n.customer-invoice-preview-page.dark .preview-issuer-name h2,\n.invoice-flow-shell.dark .preview-issuer-name h2,\n.customer-invoice-preview-page.dark .preview-doc-title,\n.invoice-flow-shell.dark .preview-doc-title,\n.customer-invoice-preview-page.dark .preview-doc-number,\n.invoice-flow-shell.dark .preview-doc-number,\n.customer-invoice-preview-page.dark .preview-meta-value,\n.invoice-flow-shell.dark .preview-meta-value,\n.customer-invoice-preview-page.dark .preview-items-header h3,\n.invoice-flow-shell.dark .preview-items-header h3,\n.customer-invoice-preview-page.dark .preview-items-table td,\n.invoice-flow-shell.dark .preview-items-table td,\n.customer-invoice-preview-page.dark .preview-items-table td .item-name,\n.invoice-flow-shell.dark .preview-items-table td .item-name,\n.customer-invoice-preview-page.dark .preview-note-title,\n.invoice-flow-shell.dark .preview-note-title,\n.customer-invoice-preview-page.dark .preview-note-body,\n.invoice-flow-shell.dark .preview-note-body,\n.customer-invoice-preview-page.dark .preview-totals-row .totals-value,\n.invoice-flow-shell.dark .preview-totals-row .totals-value,\n.customer-invoice-preview-page.dark\n  .preview-totals-row.grand-total\n  .grand-amount,\n.invoice-flow-shell.dark .preview-totals-row.grand-total .grand-amount {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.customer-invoice-preview-page.dark .customer-invoice-preview-feedback,\n.invoice-flow-shell.dark .customer-invoice-preview-feedback {\n  background: var(--surface-secondary, #22252a);\n}\n\n.customer-invoice-preview-page.dark .customer-invoice-preview-card,\n.invoice-flow-shell.dark .customer-invoice-preview-card {\n  border-color: var(--border-subtle, #343a3a);\n  background: var(--surface-primary, #191b1f);\n}\n\n.customer-invoice-preview-page.dark .preview-status-pill,\n.invoice-flow-shell.dark .preview-status-pill {\n  background: var(--surface-tertiary, #2c3036);\n  color: var(--text-secondary, #adbab7);\n}\n\n.customer-invoice-preview-page.dark .preview-items-table thead tr,\n.invoice-flow-shell.dark .preview-items-table thead tr {\n  background: var(--surface-secondary, #22252a);\n  border-bottom-color: var(--border-subtle, #343a3a);\n}\n\n.customer-invoice-preview-page.dark .preview-items-table th,\n.invoice-flow-shell.dark .preview-items-table th {\n  color: var(--text-secondary, #adbab7);\n}\n\n.customer-invoice-preview-page.dark .preview-items-table tbody tr,\n.invoice-flow-shell.dark .preview-items-table tbody tr,\n.customer-invoice-preview-page.dark .preview-divider,\n.invoice-flow-shell.dark .preview-divider,\n.customer-invoice-preview-page.dark .preview-bank-details,\n.invoice-flow-shell.dark .preview-bank-details,\n.customer-invoice-preview-page.dark .totals-divider,\n.invoice-flow-shell.dark .totals-divider {\n  border-color: var(--border-subtle, #343a3a);\n}\n\n.customer-invoice-preview-page.dark .preview-bank-details h3,\n.customer-invoice-preview-page.dark .preview-bank-details dd,\n.invoice-flow-shell.dark .preview-bank-details h3,\n.invoice-flow-shell.dark .preview-bank-details dd {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.customer-invoice-preview-page.dark .invoice-preview-btn,\n.invoice-flow-shell.dark .invoice-preview-btn {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-primary, #191b1f);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.customer-invoice-preview-page.dark .invoice-preview-btn:hover,\n.invoice-flow-shell.dark .invoice-preview-btn:hover {\n  border-color: var(--interactive-default, #43a79c);\n  color: var(--interactive-default, #43a79c);\n}\n\n.customer-invoice-preview-page.dark .invoice-preview-btn.primary,\n.invoice-flow-shell.dark .invoice-preview-btn.primary {\n  border-color: var(--interactive-default, #43a79c);\n  background: var(--interactive-default, #43a79c);\n  color: #101113;\n}\n\n.customer-invoice-preview-topbar.public-document-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.preview-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.preview-topbar-left .invoice-context {\n  font-size: 14px;\n  color: var(--text-secondary, #506360);\n  font-weight: 500;\n}\n\n.preview-amount-due-box {\n  padding: 16px;\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-sizing: border-box;\n}\n\n.amount-due-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.amount-due-label {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.amount-due-value {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 26.4px;\n  color: var(--text-primary, #142624);\n}\n\n.amount-due-sub {\n  font-size: 13px;\n  color: var(--text-secondary, #506360);\n}\n\n.preview-settled-box {\n  padding: 16px;\n  border-radius: 10px;\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-sizing: border-box;\n}\n\n.settled-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #065f46;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.preview-settled-box p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18px;\n  color: #047857;\n}\n\n.customer-invoice-preview-page.dark .preview-amount-due-box,\n.invoice-flow-shell.dark .preview-amount-due-box {\n  background: var(--surface-secondary, #22252a);\n}\n\n.customer-invoice-preview-page.dark .amount-due-label,\n.customer-invoice-preview-page.dark .amount-due-value,\n.invoice-flow-shell.dark .amount-due-label,\n.invoice-flow-shell.dark .amount-due-value {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.customer-invoice-preview-page.dark .preview-settled-box,\n.invoice-flow-shell.dark .preview-settled-box {\n  background: #06281e;\n  border-color: #0d4a36;\n}\n\n.customer-invoice-preview-page.dark .settled-header,\n.invoice-flow-shell.dark .settled-header {\n  color: #34d399;\n}\n\n.customer-invoice-preview-page.dark .preview-settled-box p,\n.invoice-flow-shell.dark .preview-settled-box p {\n  color: #a7f3d0;\n}\n\n.invoice-preview-screen-shell {\n  min-height: 100vh;\n  background: var(--bg-dashboard, #f4f7f7);\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.invoice-preview-screen-shell.dark {\n  background: #111315;\n}\n\n@media (max-width: 1023px) {\n  .customer-invoice-preview-page {\n    padding: 24px 16px 48px;\n  }\n  .preview-bottom-section {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n  .preview-totals-column {\n    border-top: 1px solid var(--border-subtle, #dce3e2);\n    padding-top: 20px;\n  }\n}\n\n@media (max-width: 700px) {\n  .customer-invoice-preview-page {\n    padding: 16px 12px 32px;\n  }\n  .customer-invoice-preview-topbar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .customer-invoice-preview-actions {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n  .customer-invoice-preview-card {\n    padding: 20px 16px;\n  }\n  .preview-issuer-identity {\n    flex-direction: column;\n  }\n  .preview-doc-identity {\n    align-items: flex-start;\n  }\n  .preview-meta-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n  .preview-meta-grid.quote-meta-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .preview-bank-details dl > div {\n    grid-template-columns: 120px minmax(0, 1fr);\n  }\n}\n\n/* ==========================================================================\n   Dedicated Send Invoice Modal (Figma node 905:88012 - Invoice Communications)\n   ========================================================================== */\n\n/* Record payment dialog (Figma nodes 905:88348 and 1209:58838) */\n.record-payment-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-4, 16px);\n  background: var(--overlay-default, rgba(10, 22, 20, 0.4));\n  backdrop-filter: blur(4px);\n}\n\n.record-payment-dialog {\n  width: min(100%, 640px);\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  box-sizing: border-box;\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  box-shadow: var(--elevation-lg, 0 16px 36px rgba(10, 22, 20, 0.18));\n}\n\n.record-payment-header,\n.record-payment-balance,\n.record-payment-actions {\n  display: flex;\n  align-items: center;\n}\n\n.record-payment-header {\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.record-payment-header h2 {\n  margin: 0;\n  font: 500 18px/25.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.record-payment-header button {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  color: var(--text-secondary, #506360);\n  background: transparent;\n  border: 0;\n  border-radius: var(--radius-md, 10px);\n  cursor: pointer;\n}\n.record-payment-header button:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.record-payment-header button span {\n  display: none;\n}\n.record-payment-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3, 12px);\n  padding: 16px 20px;\n}\n.record-payment-invoice,\n.record-payment-help {\n  margin: 0;\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.record-payment-invoice {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-weight: 500;\n  text-transform: uppercase;\n}\n.record-payment-status {\n  align-self: flex-start;\n  padding: 3px 7px;\n  color: var(--warning-text, #7d4412);\n  background: var(--warning-soft, #fef8ec);\n  border-radius: var(--radius-pill, 999px);\n  font: 500 12px/15.6px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.record-payment-help {\n  color: var(--text-secondary, #506360);\n}\n.record-payment-balance {\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n.record-payment-balance strong {\n  color: var(--text-primary, #142624);\n  font: 500 15px/19.5px var(--font-family-mono, \"JetBrains Mono\", monospace);\n  white-space: nowrap;\n}\n.record-payment-content label,\n.record-payment-field-label {\n  display: flex;\n  font: 500 13px/16.9px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.record-payment-content > label {\n  flex-direction: column;\n  gap: 6px;\n}\n.record-payment-field {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.record-payment-field .quotation-figma-dropdown,\n.record-payment-field .figma-datepicker-root,\n.record-payment-field .react-datepicker-wrapper,\n.record-payment-field .react-datepicker__input-container {\n  width: 100%;\n}\n.record-payment-field .quotation-figma-dropdown-trigger,\n.record-payment-field .figma-datepicker__input-container {\n  min-height: var(--control-md, 40px);\n  border-radius: var(--radius-md, 10px);\n}\n.record-payment-field .quotation-figma-dropdown-menu {\n  z-index: 12;\n}\n.record-payment-content label em,\n.record-payment-field-label em {\n  color: var(--danger-default, #c23a2b);\n  font-style: normal;\n}\n.record-payment-content input:not(.figma-datepicker__input),\n.record-payment-content select {\n  width: 100%;\n  height: var(--control-md, 40px);\n  padding: 0 12px;\n  box-sizing: border-box;\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  font: 400 13px/20.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.record-payment-content input:not(.figma-datepicker__input):focus,\n.record-payment-content select:focus {\n  outline: none;\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.record-payment-content input:not(.figma-datepicker__input)[readonly] {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.record-payment-error {\n  color: var(--danger-text, #a3301f);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.record-payment-projection {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  color: var(--text-secondary, #506360);\n  background: var(--surface-secondary, #f4f7f7);\n  border-radius: var(--radius-md, 10px);\n  font: 400 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.record-payment-projection strong {\n  color: var(--text-primary, #142624);\n  font-weight: 500;\n}\n.record-payment-actions {\n  gap: var(--space-3, 12px);\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.record-payment-actions button {\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n  font: 500 13px / normal var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.record-payment-actions button.primary {\n  color: var(--on-interactive-primary, #fff);\n  background: var(--interactive-default, #0f766e);\n  border-color: var(--interactive-default, #0f766e);\n}\n.record-payment-actions button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 600px) {\n  .record-payment-backdrop {\n    align-items: flex-end;\n    padding: 0;\n  }\n  .record-payment-dialog {\n    width: 100%;\n    max-height: 88vh;\n    border-radius: 20px 20px 0 0;\n  }\n  .record-payment-header {\n    padding: 16px;\n  }\n  .record-payment-header h2 {\n    font-size: 16px;\n    line-height: 22.4px;\n  }\n  .record-payment-header button {\n    display: block;\n    width: auto;\n    height: auto;\n    color: var(--interactive-default, #0f766e);\n    font: 500 13px/18.2px var(--font-family-primary, \"Lexend\", sans-serif);\n  }\n  .record-payment-header button svg {\n    display: none;\n  }\n  .record-payment-header button span {\n    display: inline;\n  }\n  .record-payment-content {\n    padding: 16px;\n  }\n  .record-payment-actions {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 16px;\n  }\n  .record-payment-actions button {\n    width: 100%;\n    min-height: 44px;\n  }\n}\n\n.send-invoice-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  background: rgba(14, 26, 32, 0.45);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n  animation: sendModalFadeIn 0.18s ease-out;\n}\n\n.send-invoice-dialog-backdrop.dark {\n  background: var(--overlay-default, rgb(0 0 0 / 60%)) !important;\n}\n\n.invoice-editor-shell:has(> .send-invoice-dialog-backdrop)\n  > .invoice-flow-main:has(> .customer-invoice-preview-page) {\n  filter: blur(4px);\n  pointer-events: none;\n}\n\n.invoice-editor-shell:has(> .invoice-flow-main > .customer-invoice-preview-page)\n  > .send-invoice-dialog-backdrop {\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n@keyframes sendModalFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.send-invoice-dialog {\n  width: 100%;\n  max-width: 664px;\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0px 1px 2px 0px rgba(14, 26, 32, 0.04);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-sizing: border-box;\n  max-height: 92vh;\n  animation: sendModalSlideUp 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes sendModalSlideUp {\n  from {\n    transform: translateY(12px) scale(0.98);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n.send-dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  gap: 12px;\n  box-sizing: border-box;\n}\n\n.send-dialog-header .header-identity {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.send-dialog-header .header-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.send-dialog-header .send-icon {\n  font-size: 20px;\n  color: var(--text-primary, #142624);\n}\n\n.send-dialog-header .send-icon.spin {\n  animation: spin 1s linear infinite;\n  color: var(--interactive-default, #0f766e);\n}\n\n.send-dialog-header .send-icon.failed {\n  color: var(--danger-default, #c23a2b);\n}\n\n.send-dialog-header .send-icon.success {\n  color: var(--success-default, #115a33);\n}\n\n.send-dialog-header .header-title {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 18px;\n  line-height: 25.2px;\n  font-weight: 500;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.send-dialog-close-btn {\n  background: transparent;\n  border: none;\n  width: 32px;\n  height: 40px;\n  border-radius: var(--radius-md, 10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-secondary, #506360);\n  font-size: 16px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.send-dialog-close-btn:hover:not(:disabled) {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n\n.send-dialog-close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.send-dialog-divider {\n  margin: 0;\n  border: 0;\n  height: 1px;\n  background: var(--border-subtle, #dce3e2);\n}\n\n.send-dialog-body {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n/* Feedback banners (waiting / failed) */\n.send-feedback-banner {\n  border-radius: var(--radius-md, 10px);\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  box-sizing: border-box;\n}\n\n.send-feedback-banner.waiting {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.send-feedback-banner.waiting .feedback-headline {\n  color: var(--text-primary, #142624);\n}\n\n.send-feedback-banner.failed {\n  background: var(--danger-soft, #fef2f1);\n  border: 1px solid rgba(194, 58, 43, 0.25);\n}\n\n.send-feedback-banner.failed .feedback-headline {\n  color: var(--danger-default, #c23a2b);\n}\n\n.send-feedback-banner .feedback-headline {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  letter-spacing: 0.07px;\n}\n\n.send-feedback-banner .feedback-sub {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  line-height: 18.2px;\n  font-weight: 400;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Form stack */\n.send-form-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.send-field-error {\n  display: block;\n  margin-top: 6px;\n  color: var(--danger-text, #a3301f);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n\n.send-input-box:has([aria-invalid=\"true\"]),\n.send-textarea-box:has([aria-invalid=\"true\"]) {\n  border-color: var(--danger-default, #c23a2b);\n}\n\n.send-context-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.send-context-row .context-identity {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n  color: var(--text-primary, #142624);\n}\n\n.send-context-row .context-status-pill {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  line-height: 15.6px;\n  font-weight: 500;\n  letter-spacing: 0.12px;\n  padding: 3px 8px;\n  border-radius: var(--radius-pill, 999px);\n  white-space: nowrap;\n}\n\n/* Field Groups */\n.send-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.send-field-group.disabled {\n  opacity: 0.75;\n}\n\n.send-field-group label {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.send-field-group.disabled label {\n  color: var(--text-disabled, #8a9896);\n}\n\n.send-input-box {\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  height: 40px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.send-field-group.disabled .send-input-box {\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-subtle, #dce3e2);\n}\n\n.send-input-box input {\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.send-input-box input:disabled {\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n\n.send-textarea-box {\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-lg, 14px);\n  padding: 12px 14px;\n  box-sizing: border-box;\n}\n\n.send-field-group.disabled .send-textarea-box {\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-subtle, #dce3e2);\n}\n\n.send-textarea-box textarea {\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  resize: vertical;\n  min-height: 120px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.send-textarea-box textarea:disabled {\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n\n/* Feedback Summary Card */\n.send-summary-card {\n  background: var(--surface-secondary, #f4f7f7);\n  border-radius: var(--radius-md, 10px);\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  box-sizing: border-box;\n}\n\n.send-summary-card .summary-title {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n}\n\n.send-summary-card .summary-detail {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  line-height: 18.2px;\n  font-weight: 400;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Delivery Options */\n.send-delivery-options {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.send-delivery-options.disabled {\n  opacity: 0.75;\n}\n\n.send-delivery-options .checkbox-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.send-delivery-options .checkbox-option input[type=\"checkbox\"] {\n  accent-color: var(--interactive-default, #0f766e);\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.send-delivery-options.disabled .checkbox-option {\n  cursor: not-allowed;\n  color: var(--text-disabled, #8a9896);\n}\n\n.send-supporting-copy {\n  margin: 4px 0 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n  letter-spacing: 0.065px;\n}\n\n/* Dialog Actions Footer */\n.send-dialog-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 16px 20px;\n  gap: 12px;\n  box-sizing: border-box;\n}\n\n.send-action-btn {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: all 0.15s ease;\n  box-sizing: border-box;\n  text-decoration: none;\n}\n\n.send-action-btn.outline {\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  color: var(--text-primary, #142624);\n}\n\n.send-action-btn.outline:hover:not(:disabled) {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.send-action-btn.outline:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.send-action-btn.primary {\n  background: var(--interactive-default, #0f766e);\n  border: 1px solid var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #ffffff);\n}\n\n.send-action-btn.primary:hover:not(:disabled) {\n  background: #0d655e;\n  border-color: #0d655e;\n}\n\n.send-action-btn.primary:disabled,\n.send-action-btn.primary.sending {\n  opacity: 0.85;\n  cursor: not-allowed;\n}\n\n/* Success Panel (Figma node 905:88103) */\n.send-success-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 4px 0 8px;\n}\n\n.send-success-indicator {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.send-success-indicator .success-icon-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(17, 90, 51, 0.12);\n  color: var(--success-default, #115a33);\n  font-size: 16px;\n}\n\n.send-success-indicator .success-sent-text {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--success-text, #115a33);\n  font-weight: 500;\n}\n\n.success-invoice-identity {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 14px;\n  line-height: 18.2px;\n  font-weight: 500;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n  color: var(--text-primary, #142624);\n}\n\n.success-badges {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.success-pill {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  line-height: 15.6px;\n  font-weight: 500;\n  letter-spacing: 0.12px;\n  padding: 3px 8px;\n  border-radius: var(--radius-pill, 999px);\n  white-space: nowrap;\n}\n\n.success-pill.warning {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n\n.success-pill.info {\n  background: var(--info-soft, #eff6ff);\n  color: var(--info-text, #1d4ed8);\n}\n\n.success-financial-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 0 4px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.success-financial-breakdown .breakdown-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n\n.success-financial-breakdown .breakdown-row span {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n.success-financial-breakdown .breakdown-row strong {\n  font-size: 15px;\n  line-height: 20px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.success-due-text {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  line-height: 21.7px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.success-footnote {\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n.success-action-wrap {\n  margin-top: 8px;\n  display: flex;\n  justify-content: flex-start;\n}\n\n/* Spinner helper */\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Dark mode for Send Invoice Dialog */\n.send-invoice-dialog-backdrop.dark .send-invoice-dialog {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #343a3a);\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.45);\n}\n\n.send-invoice-dialog-backdrop.dark .header-title,\n.send-invoice-dialog-backdrop.dark .send-icon,\n.send-invoice-dialog-backdrop.dark .send-field-group label,\n.send-invoice-dialog-backdrop.dark .send-input-box input,\n.send-invoice-dialog-backdrop.dark .send-textarea-box textarea,\n.send-invoice-dialog-backdrop.dark .send-context-row .context-identity,\n.send-invoice-dialog-backdrop.dark .send-summary-card .summary-title,\n.send-invoice-dialog-backdrop.dark .checkbox-option,\n.send-invoice-dialog-backdrop.dark .success-invoice-identity,\n.send-invoice-dialog-backdrop.dark .success-due-text,\n.send-invoice-dialog-backdrop.dark\n  .success-financial-breakdown\n  .breakdown-row\n  strong {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.send-invoice-dialog-backdrop.dark .send-dialog-divider,\n.send-invoice-dialog-backdrop.dark .success-financial-breakdown {\n  background: var(--border-subtle, #343a3a);\n  border-color: var(--border-subtle, #343a3a);\n}\n\n.send-invoice-dialog-backdrop.dark .send-input-box,\n.send-invoice-dialog-backdrop.dark .send-textarea-box {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.send-invoice-dialog-backdrop.dark .send-summary-card,\n.send-invoice-dialog-backdrop.dark .send-feedback-banner.waiting {\n  background: var(--surface-secondary, #22252a);\n}\n\n.send-invoice-dialog-backdrop.dark\n  .send-feedback-banner.waiting\n  .feedback-headline {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.send-invoice-dialog-backdrop.dark .send-feedback-banner.failed {\n  background: rgba(194, 58, 43, 0.15);\n  border-color: rgba(194, 58, 43, 0.35);\n}\n\n.send-invoice-dialog-backdrop.dark .send-context-row .context-status-pill {\n  background: var(--surface-tertiary, #2c3036);\n  color: var(--text-secondary, #adbab7);\n}\n\n.send-invoice-dialog-backdrop.dark .send-action-btn.outline {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.send-invoice-dialog-backdrop.dark\n  .send-action-btn.outline:hover:not(:disabled) {\n  background: var(--surface-secondary, #22252a);\n}\n\n.send-invoice-dialog-backdrop.dark .send-action-btn.primary {\n  background: var(--interactive-default, #43a79c);\n  border-color: var(--interactive-default, #43a79c);\n  color: #101113;\n}\n\n.send-invoice-dialog-backdrop.dark\n  .send-action-btn.primary:hover:not(:disabled) {\n  background: #399288;\n  border-color: #399288;\n}\n\n.send-invoice-dialog-backdrop.dark .success-pill.warning {\n  background: rgba(254, 248, 236, 0.12);\n  color: #f59e0b;\n}\n\n.send-invoice-dialog-backdrop.dark .success-pill.info {\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n}\n\n.invoice-editor-shell .invoice-date-fields {\n  align-items: start;\n}\n\n.invoice-editor-shell .invoice-date-fields > * {\n  min-width: 0;\n}\n\n.invoice-editor-shell .invoice-date-picker-field,\n.invoice-editor-shell .invoice-date-picker-field .react-datepicker-wrapper,\n.invoice-editor-shell\n  .invoice-date-picker-field\n  .react-datepicker__input-container {\n  width: 100%;\n}\n\n.invoice-editor-shell .invoice-date-picker-field .figma-datepicker__label {\n  align-items: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.invoice-editor-shell .invoice-date-follow-up > input[readonly] {\n  background: var(--surface-primary, #fff);\n}\n\n/* Match quotation fields with thin green focus borders and no glow. */\n:is(.invoice-flow-shell.invoice-editor-shell, .invoice-flow-shell.invoice-detail-shell, .invoice-flow-shell.rcti-editor-shell)\n  :is(.invoice-flow-card\n    input:not(:disabled):not([readonly]):not([aria-invalid=\"true\"]):focus, .invoice-flow-card\n    select:not(:disabled):not([aria-invalid=\"true\"]):focus, .invoice-flow-card\n    textarea:not(:disabled):not([readonly]):not([aria-invalid=\"true\"]):focus, .quotation-input-box:not(.disabled):not(.quotation-input-readonly):not(.error):not(:has(:disabled, [readonly], [aria-invalid=\"true\"])):focus-within, .quotation-item-search-box:not(:has([aria-invalid=\"true\"])):focus-within, .quotation-select-box:focus-within, .quotation-figma-dropdown.is-open\n    .quotation-figma-dropdown-trigger, .quotation-figma-dropdown-trigger:not(:disabled):focus-visible) {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n  outline: none;\n}\n\n:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger,\n:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)\n  .quotation-figma-dropdown-trigger:not(:disabled):focus-visible,\n.invoice-editor-shell\n  .quotation-item-details-row\n  .quotation-col-gst-select.quotation-custom-dropdown-wrap\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger {\n  border-width: 1px;\n  padding-inline: 12px 10px;\n}\n\n:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)\n  .invoice-themed-select.Mui-focused {\n  box-shadow: none;\n}\n\n:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)\n  .figma-datepicker__input-container:focus-within {\n  box-shadow: none !important;\n}\n\n:is(.invoice-editor-shell, .invoice-detail-shell, .rcti-editor-shell)\n  .figma-datepicker__input:focus {\n  box-shadow: none !important;\n}\n\n.send-invoice-dialog\n  :is(.send-input-box, .send-textarea-box):not(:has(:disabled, [aria-invalid=\"true\"])):focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n/* Invoice and RCTI draft errors match quotation field borders. */\n:is(.invoice-editor-shell, .rcti-editor-shell)\n  .invoice-flow-card\n  :is(input[aria-invalid=\"true\"], button[aria-invalid=\"true\"], .quotation-input-box:has(input[aria-invalid=\"true\"]), .quotation-item-search-box:has(input[aria-invalid=\"true\"])) {\n  border-color: var(--danger-default, #c23a2b);\n  box-shadow: none;\n}\n\n/* Multi-recipient chip field in Send Invoice Dialog */\n.send-invoice-dialog .quotation-dialog-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.send-invoice-dialog .quotation-dialog-field label {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n.send-invoice-dialog .quotation-recipient-box {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-2, 8px);\n  min-height: 40px;\n  padding: 4px 8px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px/20px var(--font-family-primary, \"Lexend\", sans-serif);\n  box-sizing: border-box;\n}\n.send-invoice-dialog .quotation-recipient-box:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.send-invoice-dialog .quotation-recipient-box.has-error {\n  border-color: var(--danger-text, #a3301f);\n}\n.send-invoice-dialog .quotation-recipient-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1, 4px);\n  max-width: 100%;\n  min-height: 28px;\n  padding: 4px 8px;\n  border-radius: var(--radius-sm, 6px);\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n}\n.send-invoice-dialog .quotation-recipient-chip > span {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.send-invoice-dialog .quotation-recipient-chip--saved {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.send-invoice-dialog .quotation-recipient-chip button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n.send-invoice-dialog .quotation-recipient-chip button:hover {\n  background: var(--surface-tertiary, #e8edec);\n}\n.send-invoice-dialog .quotation-recipient-chip button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.send-invoice-dialog .quotation-recipient-chip svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n.send-invoice-dialog .quotation-recipient-box input.quotation-recipient-entry {\n  flex: 1 1 160px;\n  width: auto;\n  min-width: 0;\n  height: 30px;\n  padding: 4px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  outline: none;\n  box-shadow: none;\n}\n.send-invoice-dialog .quotation-field-error {\n  margin: 0;\n  color: var(--danger-text, #a3301f);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.send-invoice-dialog .quotation-dialog-cancel-btn {\n  align-self: flex-start;\n  padding: 2px 4px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  font: 500 12px/16px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n  text-decoration: underline;\n}\n.send-invoice-dialog .quotation-dialog-cancel-btn:hover {\n  color: var(--interactive-hover, #0d5f58);\n}\n\n/* Dark mode overrides for recipient field */\n.send-invoice-dialog-backdrop.dark\n  .send-invoice-dialog\n  .quotation-recipient-box {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #343a3a);\n  color: #fff;\n}\n.send-invoice-dialog-backdrop.dark\n  .send-invoice-dialog\n  .quotation-recipient-chip {\n  background: rgba(15, 118, 110, 0.25);\n  color: #5eead4;\n}\n.send-invoice-dialog-backdrop.dark\n  .send-invoice-dialog\n  .quotation-recipient-chip--saved {\n  background: #2a2e35;\n  color: #cbd5e1;\n}\n.send-invoice-dialog-backdrop.dark\n  .send-invoice-dialog\n  .quotation-recipient-chip\n  button:hover {\n  background: #343a3a;\n}\n.send-invoice-dialog-backdrop.dark\n  .send-invoice-dialog\n  .quotation-recipient-box\n  input.quotation-recipient-entry {\n  color: #fff;\n}\n\n/* Issue confirmation occupies its own row above the shared email actions. */\n.rcti-email-authorisation { display: flex; align-items: flex-start; gap: 12px; padding: 16px; margin-top: 16px; border: 1px solid var(--border-subtle); border-radius: 10px; font-size: 13px; line-height: 1.6; }\n.rcti-email-authorisation input { flex: 0 0 16px; width: 16px; height: 16px; margin: 3px 0 0; accent-color: var(--interactive-default); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
